(function () {
  'use strict';

  function niloRunIdle(fn, timeout) {
    if (typeof fn !== 'function') return;
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function(){ fn(); }, { timeout: timeout || 900 });
    } else {
      window.setTimeout(fn, Math.min(timeout || 900, 350));
    }
  }

  function niloAfterFirstPaint(fn, timeout) {
    window.requestAnimationFrame(function(){
      window.requestAnimationFrame(function(){ niloRunIdle(fn, timeout || 900); });
    });
  }

  function niloSizedImageUrl(src, width) {
    if (!src) return '';
    try {
      var url = new URL(src, window.location.origin);
      if (/shopify\.com$|shopifycdn\.com$/.test(url.hostname) || url.hostname.indexOf('cdn.shopify.com') >= 0) {
        url.searchParams.set('width', String(width || 520));
        return url.toString();
      }
    } catch (error) {}
    return src;
  }

  function shuffle(array) {
    for (var i = array.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i]; array[i] = array[j]; array[j] = temp;
    }
    return array;
  }


  /* ============================================================
     NILO V5.12 — REFRESH ROTATION ENGINE
     Every real page refresh gets a new session counter/seed. The seed is then
     used against the FULL Shopify catalogue, not just the first Liquid page,
     so category imagery, hero imagery and featured product zones visibly
     rotate on every refresh while remaining stable during that page view.
     ============================================================ */
  var niloRefreshSeedV512 = null;

  function v512Hash(value) {
    var text = String(value || '');
    var hash = 2166136261;
    for (var i = 0; i < text.length; i += 1) {
      hash ^= text.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
  }

  function v512RefreshSeed() {
    if (niloRefreshSeedV512 !== null) return niloRefreshSeedV512;
    // V5.13.42: returning via history must preserve the original home selection.
    try {
      var entry = performance.getEntriesByType('navigation')[0];
      var back = entry && entry.type === 'back_forward';
      var saved = sessionStorage.getItem('nilo-v51342-home-seed');
      if (back && saved && document.querySelector('[data-nilo-app-home]')) {
        niloRefreshSeedV512 = Number(saved) >>> 0;
        document.documentElement.dataset.niloRefreshSeed = String(niloRefreshSeedV512);
        return niloRefreshSeedV512;
      }
    } catch (error) {}
    var counter = 1;
    try {
      counter = Number(sessionStorage.getItem('nilo-v512-refresh-counter') || 0) + 1;
      sessionStorage.setItem('nilo-v512-refresh-counter', String(counter));
    } catch (error) {}
    var entropy = Date.now() >>> 0;
    try {
      if (window.crypto && window.crypto.getRandomValues) {
        var values = new Uint32Array(1);
        window.crypto.getRandomValues(values);
        entropy ^= values[0];
      }
    } catch (error) {}
    niloRefreshSeedV512 = (entropy ^ Math.imul(counter, 2654435761)) >>> 0;
    document.documentElement.dataset.niloRefreshSeed = String(niloRefreshSeedV512);
    try { if (document.querySelector('[data-nilo-app-home]')) sessionStorage.setItem('nilo-v51342-home-seed', String(niloRefreshSeedV512)); } catch (error) {}
    return niloRefreshSeedV512;
  }

  function v512SeededShuffle(array, salt) {
    var out = Array.prototype.slice.call(array || []);
    var state = (v512RefreshSeed() ^ v512Hash(salt)) >>> 0;
    function next() {
      state = (Math.imul(state, 1664525) + 1013904223) >>> 0;
      return state / 4294967296;
    }
    for (var i = out.length - 1; i > 0; i -= 1) {
      var j = Math.floor(next() * (i + 1));
      var temp = out[i]; out[i] = out[j]; out[j] = temp;
    }
    return out;
  }

  function v512CategoryMode(value) {
    var key = String(value || '').toLowerCase();
    var map = {
      'abayas':'abaya', 'ensembles':'set', 'ensembles-sport':'sport_set',
      'takchitas':'takchita', 'caftans':'caftan', 'jupes':'skirt', 'robes':'dress',
      'burkinis':'swim', 'pyjamas':'pyjama_home', 'pyjama-maison':'pyjama_home',
      'moins-140':'under140', 'moins-200':'under200', 'chemises':'shirt',
      'jellabas':'jellaba', 'hijabs-foulards':'hijab', 'chaussures':'shoe',
      'sacs':'bag', 'accessoires':'accessory'
    };
    return map[key] || 'women';
  }

  /* V5.13.49 — home: strong occidental assortment and title-family dedup.
     Only used by home rotation; product pages, cart and COD are untouched. */
  function niloV51349TitleKey(product) {
    return normalizeSearchText(String(product && product.title || '')).replace(/\b(femme|homme|women|woman|man|women's|nouveau|nouveaute|modele)\b/g,'').replace(/[^\p{L}\p{N}]+/gu,' ').trim() || String(product && product.handle || '');
  }
  function niloV51349FashionType(product) {
    var title = normalizeSearchText(product && product.title || '');
    var type = normalizeSearchText(product && product.product_type || '');
    var text = title || type;
    if (/^\s*(abaya|abayas|3abaya)\b|^\s*عباية/.test(text)) return 'abaya';
    if (/\b(ensemble|ensembles|set|sets|tailleur|survetement|tracksuit|co ord|coordonne)\b|طقم|اطقم|أنسامبل/.test(text)) return 'set';
    if (/\b(robe|robes|dress|dresses)\b|فستان|فساتين|روبة/.test(text)) return 'dress';
    if (/\b(cardigan|gilet|pull|sweat|tricot|blazer|veste|jacket)\b/.test(text)) return 'cardigan';
    if (/\b(chemise|blouse|chemisier|top|tunique|shirt|haut)\b/.test(text)) return 'top';
    if (/\b(pantalon|jean|jeans|legging|jupe|skirt|short)\b/.test(text)) return 'bottom';
    if (/\b(abaya|abayas|3abaya|kimono)\b|عباية|عبايات/.test(text)) return 'abaya';
    if (/\b(jellaba|djellaba|caftan|kaftan|takchita|hijab|khimar|gandoura)\b|جلابة|قفطان|تكشيطة/.test(text)) return 'traditional';
    if (/\b(pyjama|pijama|pajama|homewear|sleepwear)\b|بيجاما/.test(text)) return 'homewear';
    if (/\b(sac|chaussure|sandale|baskets|basket|accessoire|bijou)\b/.test(text)) return 'accessory';
    if (/\b(abaya|abayas)\b|عباية/.test(type)) return 'abaya';
    if (/\b(robe|dress)\b/.test(type)) return 'dress';
    if (/\b(ensemble|set)\b/.test(type)) return 'set';
    return 'other';
  }
  function v512PickProducts(catalogue, mode, count, reserved, salt, genderContext) {
    reserved = reserved || {};
    var source=v512SeededShuffle((catalogue||[]).filter(function(product){
      return product && product.handle && !reserved[product.handle] && jsonProductMatchesMode(product,mode||'women',genderContext||'');
    }),'nilo-v51349-primary-'+salt+'-'+mode);
    source=window.NiloClothingPriorityV51381.products(source,mode);
    var picked=[],local={};
    function take(list,maximum){
      for(var i=0;i<list.length && picked.length<count && (maximum===undefined||maximum>0);i++){
        var product=list[i];if(!product||reserved[product.handle])continue;
        var family=niloV51349TitleKey(product);if(!family||local[family]||reserved['family:'+family])continue;
        if(mode==='under200' && !(jsonProductPrice(product)>0 && jsonProductPrice(product)<20000))continue;
        if(mode==='under140' && !(jsonProductPrice(product)>0 && jsonProductPrice(product)<14000))continue;
        if(mode==='under250' && !(jsonProductPrice(product)>0 && jsonProductPrice(product)<25000))continue;
        if(mode==='under300' && !(jsonProductPrice(product)>0 && jsonProductPrice(product)<30000))continue;
        reserved[product.handle]=true;reserved['family:'+family]=true;local[family]=true;picked.push(product);
        if(maximum!==undefined)maximum--;
      }
    }
    var specialty=['set','dress','abaya','jellaba','caftan','pyjama_home','sport_set','bag','shoe','swim','hijab','shirt','skirt'].indexOf(mode)>=0;
    if(specialty){take(source);return picked;}
    // Clothing ALWAYS outranks gadgets/bags/shoes in these mixed home sections.
    // Inside the garment group the existing price priority remains in force.
    var garment=source.filter(function(p){return window.NiloClothingPriorityV51381.productTier(p)===0;});
    var western=garment.filter(function(p){return ['set','dress','top','bottom','cardigan'].indexOf(niloV51349FashionType(p))>=0;});
    var otherGarments=garment.filter(function(p){return western.indexOf(p)<0;});
    var unknown=source.filter(function(p){return window.NiloClothingPriorityV51381.productTier(p)===1;});
    var accessories=source.filter(function(p){return window.NiloClothingPriorityV51381.productTier(p)===2;});
    take(western.filter(function(p){return jsonProductPrice(p)<=25000;}));
    take(otherGarments.filter(function(p){return jsonProductPrice(p)<=25000;}));
    take(western);
    take(otherGarments);
    // Only when the eligible garment supply is exhausted.
    take(unknown);
    take(accessories);
    // Preserve the original bounded fallback, but give clothing priority too.
    if(picked.length<count && !/^under(140|200|250|300)$/.test(mode)){
      var fallback=v512SeededShuffle((catalogue||[]).filter(function(p){return p && !reserved[p.handle]&&jsonProductMatchesMode(p,'women','women');}),'nilo-v51349-fallback-'+salt);
      take(window.NiloClothingPriorityV51381.products(fallback,'all'));
    }
    return picked;
  }

  function v512ApplyImage(img, product, altPrefix, targetWidth) {
    if (!img || !product) return;
    var original = jsonProductImage(product);
    if (!original) return;
    var width = Number(targetWidth || img.getAttribute('width') || 520);
    img.src = niloSizedImageUrl(original, width);
    if (width >= 700) {
      img.srcset = niloSizedImageUrl(original, 480) + ' 480w, ' + niloSizedImageUrl(original, 720) + ' 720w, ' + niloSizedImageUrl(original, width) + ' ' + width + 'w';
      img.sizes = '(max-width: 560px) 88vw, 470px';
    } else {
      var small = Math.max(120, Math.round(width * 0.55));
      img.srcset = niloSizedImageUrl(original, small) + ' ' + small + 'w, ' + niloSizedImageUrl(original, width) + ' ' + width + 'w';
      img.sizes = width <= 260 ? '120px' : '(max-width: 749px) 46vw, 240px';
    }
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.classList.remove('lazyload','lazyloading');
    img.classList.add('lazyloaded');
    img.decoding = 'async';
    img.alt = (altPrefix || localizeJsonTitle(product.title || 'Nilo')) + ' - Nilo Maroc';
  }


  /* ============================================================
     NILO V5.13 — POPULAR CATEGORY ROTATION
     The home category rail is no longer tied to the seven static theme blocks.
     On each true page refresh we select a different subset and order from a
     much larger catalogue of useful shopping universes. The selection is
     stable during the current page view, but changes after reload thanks to
     the V5.12 refresh seed. Images are also pulled from matching products in
     the full Shopify catalogue.
     ============================================================ */
  function v513SeasonLabel(arabic) {
    var month = new Date().getMonth();
    if (arabic) {
      if (month === 11 || month <= 1) return 'اختيارات الشتاء';
      if (month >= 2 && month <= 4) return 'اختيارات الربيع';
      if (month >= 5 && month <= 7) return 'اختيارات الصيف';
      return 'اختيارات الخريف';
    }
    if (month === 11 || month <= 1) return 'Sélection hiver';
    if (month >= 2 && month <= 4) return 'Sélection printemps';
    if (month >= 5 && month <= 7) return 'Sélection été';
    return 'Sélection automne';
  }

  function v513MonthLabel(arabic) {
    var month = new Date().getMonth();
    var fr = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
    var ar = ['يناير','فبراير','مارس','أبريل','ماي','يونيو','يوليوز','غشت','شتنبر','أكتوبر','نونبر','دجنبر'];
    return arabic ? ('اختيارات ' + ar[month]) : ('Sélection ' + fr[month]);
  }

  function v513PopularCategoryDefinitions() {
    var arabic = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
    var year = new Date().getFullYear();
    var root = discoveryRootUrl();
    function label(fr, ar) { return arabic ? ar : fr; }
    return [
      {key:'new', mode:'new', label:label('Nouveautés','الجديد'), href:root+'collections/all?sort_by=created-descending'},
      {key:'month-selection', mode:'new', label:v513MonthLabel(arabic), href:root+'collections/all?sort_by=created-descending'},
      {key:'season-selection', mode:'women', label:v513SeasonLabel(arabic), href:root+'collections/all'},
      {key:'back-to-school', mode:'women', label:label('Rentrée '+year,'دخول '+year), href:root+'collections/all'},
      {key:'small-price-trends', mode:'under200', label:label('Tendances petit prix','ترندات بأثمنة صغيرة'), href:root+'collections/moins-de-200-dh'},
      {key:'under140', mode:'under140', label:label('Moins de 140 DH','أقل من 140 DH'), href:root+'collections/moins-de-140-dh'},
      {key:'under200', mode:'under200', label:label('Moins de 200 DH','أقل من 200 DH'), href:root+'collections/moins-de-200-dh'},
      {key:'robes', mode:'dress', label:label('Robes','فساتين'), href:root+'collections/robes'},
      {key:'ensembles', mode:'set', label:label('Ensembles','أطقم'), href:root+'collections/ensembles'},
      {key:'abayas', mode:'abaya', label:label('Abayas','عبايات'), href:root+'search?q=abaya&type=product'},
      {key:'pyjamas', mode:'pyjama_home', label:label('Pyjamas','بيجامات'), href:root+'search?q=pyjama&type=product'},
      {key:'pyjama-maison', mode:'pyjama_home', label:label('Pyjama maison','ملابس البيت'), href:root+'search?q=pyjama%20maison&type=product'},
      {key:'hijabs-foulards', mode:'hijab', label:label('Hijabs & foulards','حجابات و فولارات'), href:root+'search?q=hijab&type=product'},
      {key:'jellabas', mode:'jellaba', label:label('Jellabas','جلابات'), href:root+'search?q=jellaba&type=product'},
      {key:'burkinis', mode:'swim', label:label('Burkinis','بوركيني'), href:root+'search?q=burkini&type=product'},
      {key:'chaussures', mode:'shoe', label:label('Chaussures','أحذية'), href:root+'search?q=chaussures&type=product'},
      {key:'sacs', mode:'bag', label:label('Sacs','حقائب'), href:root+'search?q=sac&type=product'},
      {key:'accessoires', mode:'accessory', label:label('Accessoires','إكسسوارات'), href:root+'search?q=accessoires&type=product'},
      {key:'ensembles-sport', mode:'sport_set', label:label('Ensembles sport','أطقم رياضية'), href:root+'collections/survetements'},
      {key:'caftans', mode:'caftan', label:label('Caftans','قفاطين'), href:root+'search?q=caftan&type=product'},
      {key:'takchitas', mode:'takchita', label:label('Takchitas','تكاشط'), href:root+'search?q=takchita&type=product'},
      {key:'chemises', mode:'shirt', label:label('Chemises','قمصان'), href:root+'search?q=chemise&type=product'},
      {key:'jupes', mode:'skirt', label:label('Jupes','تنانير'), href:root+'search?q=jupe&type=product'},
      {key:'looks-now', mode:'women', label:label('Looks du moment','إطلالات دابا'), href:root+'collections/all'}
    ];
  }

  function v513RotatePopularCategories(home, catalogue) {
    if (!home || !catalogue || !catalogue.length) return [];
    var rail = home.querySelector('.nilo-category-rail');
    if (!rail) return [];
    var links = Array.prototype.slice.call(rail.querySelectorAll('[data-nilo-home-category]'));
    if (!links.length) return [];

    var definitions = v513PopularCategoryDefinitions().filter(function(def){
      return catalogue.some(function(product){
        return product && product.handle && jsonProductAvailable(product) && jsonProductImage(product) && jsonProductMatchesMode(product, def.mode, '');
      });
    });
    definitions = v512SeededShuffle(definitions, 'popular-category-types');
    if (!definitions.length) return [];

    /* Western looks lead the popular categories. Abayas stay available,
       but they no longer own the first row on each visit. */
    var fashionKeys=['ensembles','robes','ensembles-sport','chemises'];
    var fashionFirst=fashionKeys.map(function(key){return definitions.find(function(d){return d.key===key;});}).filter(Boolean);
    var remaining=definitions.filter(function(d){return fashionKeys.indexOf(d.key)<0;});
    remaining.sort(function(a,b){var accessory={sacs:1,chaussures:1,'hijabs-foulards':1,accessoires:1};return Number(!!accessory[a.key])-Number(!!accessory[b.key]);});
    var selected=fashionFirst.concat(remaining).slice(0,Math.min(links.length,definitions.length));
    var reserved = {};
    var visibleKeys = [];

    links.forEach(function(link, index){
      var def = selected[index % selected.length];
      if (!def) return;
      var candidates = v512SeededShuffle(catalogue.filter(function(product){
        return product && product.handle && !reserved[product.handle] && jsonProductAvailable(product) && jsonProductImage(product) && jsonProductMatchesMode(product, def.mode, '');
      }), 'popular-category-image-' + index + '-' + def.key);
      /* Never put an unrelated product in a category to fill a missing image. */
      var product = candidates[0];
      if (!product) { link.hidden = true; return; }
      if (product) reserved[product.handle] = true;

      link.dataset.niloHomeCategory = def.key;
      link.dataset.niloV513CategoryKey = def.key;
      link.href = def.href;
      var title = link.querySelector('strong');
      if (title) title.textContent = def.label;
      var media = link.querySelector('.nilo-category-v3__media');
      if (media && product) {
        var images = Array.prototype.slice.call(media.querySelectorAll('img'));
        var img = images[0];
        if (!img) {
          img = document.createElement('img');
          img.width = 240;
          img.height = 240;
          img.loading = 'lazy';
          media.insertBefore(img, media.firstChild || null);
        }
        images.slice(1).forEach(function(extra){ extra.remove(); });
        img.classList.add('nilo-category-v3__candidate','is-active');
        v512ApplyImage(img, product, def.label, 240);
        img.onerror = function(){
          /* CDN failure: try a real matching product, otherwise remove tile. */
          img.onerror = null;
          var alternate = candidates.find(function(item){ return item.handle !== product.handle && jsonProductImage(item); });
          if (alternate) { v512ApplyImage(img, alternate, def.label, 240); img.onerror = function(){ link.hidden = true; }; }
          else link.hidden = true;
        };
        link.hidden = false;
        link.dataset.niloRotatedHandle = product.handle;
      }
      visibleKeys.push(def.key);
    });

    home.dataset.niloV513PopularCategories = visibleKeys.join('|');
    return visibleKeys;
  }


  function v512UniqueSectionTitle(base, usedTitles) {
    base = String(base || 'Sélection Nilo');
    usedTitles = usedTitles || {};
    var occurrence = usedTitles[base] || 0;
    usedTitles[base] = occurrence + 1;
    if (occurrence === 0) return base;
    var ar = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
    var suffixes = ar ?
      [' · اختيارات جديدة',' · المزيد لك',' · اكتشفي أيضاً',' · أفكار إضافية',' · اختيارات نيلو',' · الجولة التالية'] :
      [' · une autre sélection',' · nouveaux choix',' · à découvrir aussi',' · encore plus d’idées',' · coups de cœur Nilo',' · la suite'];
    var suffixIndex = (occurrence - 1) % suffixes.length;
    var cycle = Math.floor((occurrence - 1) / suffixes.length);
    return base + suffixes[suffixIndex] + (cycle ? (' ' + (cycle + 1)) : '');
  }

  function normalizeSearchText(value) {
    var plain = (value || '').trim().toLowerCase();
    var latin = plain.normalize ? plain.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : plain;
    return latin.replace(/\s+/g, ' ').trim();
  }

  function uniqueSearchTerms(terms) {
    var seen = {};
    return terms.filter(function (term) {
      var key = normalizeSearchText(term);
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function getSearchCandidates(value) {
    var original = normalizeSearchText(value);
    var candidates = [original];

    // Keep this vocabulary aligned with the Nilo scraper taxonomy.
    // Important: kitma / كيطمة is an ensemble-sport signal, NOT a pyjama alias.
    if (/\b(pyjama|pyjamas|pyjamma|pyjma|pijama|pajama|pajamas|sleepwear|homewear|loungewear|nuisette)\b/.test(original) || /robe de nuit|chemise de nuit|vetement de nuit|vetements de nuit|قميص نوم|بيجاما|بيجامة|بيجامات|منامة|لباس نوم/.test(original)) {
      candidates = candidates.concat(['pyjama', 'pyjamas', 'pijama', 'pajama', 'بيجاما', 'بيجامة']);
    } else if (/\b(kitma|kytma|kitema|survetement|survêtement|jogging|training|tracksuit|ensemble sport)\b/.test(original) || /كيطمة|كطمة/.test(original)) {
      candidates = candidates.concat(['kitma', 'survêtement', 'ensemble sport', 'jogging', 'كيطمة']);
    } else if (/\b(burkini|borkini|bourkini)\b/.test(original) || /بوركيني|بوركني|بروكيني/.test(original)) {
      candidates = candidates.concat(['burkini', 'bourkini', 'borkini']);
    } else if (/\b(robe|robes|rob|robee|dress|dresses)\b/.test(original) || /فستان|فساتين|روبة/.test(original)) {
      candidates = candidates.concat(['robe', 'robes', 'dress', 'فستان']);
    } else if (/\b(ensemble|ensembles|set|sets|2 pieces|2 piece|2piece|3 pieces|3 piece|4 pieces|4 piece|deux pieces|deux piece)\b/.test(original) || /طقم|اونسبل/.test(original)) {
      candidates = candidates.concat(['ensemble', 'ensembles', '2 pièces', 'set', 'طقم']);
    } else if (/\b(abaya|abayas|faracha)\b/.test(original) || /عباية|عبايات/.test(original)) {
      candidates = candidates.concat(['abaya', 'abayas', 'عباية']);
    } else if (/\b(jellaba|jellabas|djellaba|djellabas|jalaba|jilbab)\b/.test(original) || /جلابة|جلابا/.test(original)) {
      candidates = candidates.concat(['jellaba', 'djellaba', 'jalaba', 'جلابة']);
    } else if (/\b(takchita|takchitas|tekchita)\b/.test(original) || /تكشيطة|تكاشط/.test(original)) {
      candidates = candidates.concat(['takchita', 'tekchita', 'تكشيطة']);
    } else if (/\b(caftan|caftans|kaftan|kftan)\b/.test(original) || /قفطان/.test(original)) {
      candidates = candidates.concat(['caftan', 'kaftan', 'قفطان']);
    } else if (/\b(hijab|hijabs|khimar|foulard|foulards|voile)\b/.test(original) || /حجاب|خمار|طرحة/.test(original)) {
      candidates = candidates.concat(['hijab', 'khimar', 'foulard', 'voile', 'حجاب']);
    } else if (/\b(sac|sacs|bag|bags|handbag|pochette)\b/.test(original) || /شكارة|شنطة|حقيبة/.test(original)) {
      candidates = candidates.concat(['sac', 'sacs', 'bag', 'pochette']);
    } else if (/\b(chaussure|chaussures|shoe|shoes|sandale|sandales|botte|bottes|sneaker|sneakers|basket|baskets|mocassin|mocassins|talon|talons)\b/.test(original) || /صباط|صندل/.test(original)) {
      candidates = candidates.concat(['chaussures', 'sandale', 'sneakers', 'basket', 'mocassin']);
    } else if (/\b(accessoire|accessoires|bijou|bijoux|ceinture|lunette|lunettes|collier|bracelet|montre)\b/.test(original)) {
      candidates = candidates.concat(['accessoires', 'bijou', 'ceinture']);
    } else if (/\b(chemise|chemises|shirt|shirts)\b/.test(original) || /قميص/.test(original)) {
      candidates = candidates.concat(['chemise', 'chemises', 'shirt', 'قميص']);
    } else if (/\b(jupe|jupes|skirt|skirts)\b/.test(original) || /تنورة/.test(original)) {
      candidates = candidates.concat(['jupe', 'jupes', 'skirt', 'تنورة']);
    }

    return uniqueSearchTerms(candidates).slice(0, 7);
  }

  function shuffleChildren(container, selector) {
    if (!container) return;
    var children = Array.prototype.slice.call(selector ? container.querySelectorAll(':scope > ' + selector) : container.children);
    shuffle(children).forEach(function (child) { container.appendChild(child); });
  }


  function productHandleFromNode(node) {
    if (!node) return '';
    if (node.dataset && node.dataset.niloProductHandle) return String(node.dataset.niloProductHandle);
    var card = node.classList && node.classList.contains('nilo-product-card') ? node : node.querySelector && node.querySelector('.nilo-product-card');
    if (card && card.dataset && card.dataset.niloProductHandle) return String(card.dataset.niloProductHandle);
    var anchor = (card || node).querySelector ? (card || node).querySelector('a[href*="/products/"]') : null;
    if (!anchor) return '';
    try {
      var href = anchor.getAttribute('href') || '';
      var match = href.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : href;
    } catch (error) { return ''; }
  }

  function dedupeCatalogue(root) {
    var scope = root || document;
    var productPage = scope.querySelector && scope.querySelector('[data-nilo-product-page]');
    if (!productPage && scope.matches && scope.matches('[data-nilo-product-page]')) productPage = scope;

    /* V5.8 stability rule: never make product/home sections disappear while JS
       is still looking for alternatives. Product discovery is finalized by the
       dedicated hydrator below. Here we only remove duplicates inside one rail. */
    if (productPage) {
      productPage.querySelectorAll('[data-nilo-smart-rail]').forEach(function (rail) {
        var localSeen = {};
        var displayLimit = Number(rail.dataset.niloDisplayLimit || 0);
        var localIndex = 0;
        Array.prototype.slice.call(rail.querySelectorAll(':scope > .nilo-smart-item')).forEach(function (item) {
          var handle = productHandleFromNode(item);
          if (handle && localSeen[handle]) { item.remove(); return; }
          if (handle) localSeen[handle] = true;
          item.hidden = displayLimit > 0 ? localIndex >= displayLimit : false;
          localIndex += 1;
        });
        /* V5.10: keep the server's hidden/visible decision. Only rails marked
           instant by Liquid may be visible before the full catalogue feed is ready. */
      });
      return;
    }

    var home = document.querySelector('[data-nilo-app-home]');
    if (home) {
      /* Home must feel stable. Never dedupe one merchandising section against
         another before replacements have been fetched: that was the source of
         headings/rails appearing and disappearing immediately. */
      scope.querySelectorAll('[data-nilo-smart-section]').forEach(function (section) {
        var rail = section.querySelector('[data-nilo-smart-rail]');
        if (!rail) return;
        var localSeen = {};
        var displayLimit = Number(rail.dataset.niloDisplayLimit || 0);
        var localIndex = 0;
        Array.prototype.slice.call(rail.querySelectorAll(':scope > .nilo-smart-item')).forEach(function (item) {
          var handle = productHandleFromNode(item);
          if (handle && localSeen[handle]) { item.remove(); return; }
          if (handle) localSeen[handle] = true;
          item.hidden = displayLimit > 0 ? localIndex >= displayLimit : false;
          localIndex += 1;
        });
        section.hidden = false;
      });
      return;
    }

    var seen = {};
    scope.querySelectorAll('[data-nilo-collection-page] [data-nilo-infinite-items] > .nilo-product-card, [data-nilo-search-page] [data-nilo-infinite-items] > .nilo-product-card').forEach(function (card) {
      var handle = productHandleFromNode(card);
      if (handle) seen[handle] = true;
    });

    scope.querySelectorAll('[data-nilo-smart-section], .nilo-product-more').forEach(function (section) {
      var rail = section.querySelector('[data-nilo-smart-rail], .nilo-products-rail');
      if (!rail) return;
      var selector = rail.hasAttribute('data-nilo-smart-rail') ? ':scope > .nilo-smart-item' : ':scope > .nilo-product-card, :scope > .nilo-recent-card';
      var items = Array.prototype.slice.call(rail.querySelectorAll(selector));
      var kept = [];
      items.forEach(function (node) {
        var handle = productHandleFromNode(node);
        if (handle && seen[handle]) { node.remove(); return; }
        if (handle) seen[handle] = true;
        kept.push(node);
      });
      var displayLimit = Number(rail.dataset.niloDisplayLimit || 0);
      kept.forEach(function (item, index) { item.hidden = displayLimit > 0 ? index >= displayLimit : false; });
      if (section.hasAttribute('data-nilo-recently-viewed')) section.hidden = kept.length < 1;
      else section.hidden = kept.length < 3;
    });
  }

  function randomizeCatalogue(root) {
    (root || document).querySelectorAll('[data-nilo-shuffle]').forEach(function (container) { shuffleChildren(container); });
    (root || document).querySelectorAll('[data-nilo-shuffle-products]').forEach(function (container) {
      if (container.closest('[data-nilo-collection-page], [data-nilo-search-page]')) return;
      shuffleChildren(container, '.nilo-product-card');
    });

    (root || document).querySelectorAll('.nilo-category-v3__media').forEach(function (media) {
      var candidates = Array.prototype.slice.call(media.querySelectorAll('.nilo-category-v3__candidate'));
      if (!candidates.length) return;
      candidates.forEach(function (image) { image.classList.remove('is-active'); });
      candidates[Math.floor(Math.random() * candidates.length)].classList.add('is-active');
    });

    (root || document).querySelectorAll('[data-nilo-smart-rail]').forEach(function (rail) {
      var items = Array.prototype.slice.call(rail.querySelectorAll(':scope > .nilo-smart-item'));
      items.sort(function (a, b) {
        var scoreA = Number(a.dataset.niloScore || 0) + Math.random() * 13;
        var scoreB = Number(b.dataset.niloScore || 0) + Math.random() * 13;
        return scoreB - scoreA;
      });
      items.forEach(function (item) { rail.appendChild(item); });
      var displayLimit = Number(rail.dataset.niloDisplayLimit || 0);
      if (displayLimit > 0) items.forEach(function (item, index) { item.hidden = index >= displayLimit; });
    });

    dedupeCatalogue(root || document);

    (root || document).querySelectorAll('[data-nilo-smart-home]').forEach(function (home) {
      var sections = Array.prototype.slice.call(home.querySelectorAll(':scope > .nilo-smart-section'));
      if (sections.length < 6) return;
      shuffle(sections.slice(4)).forEach(function (section) { home.appendChild(section); });
    });
  }


  function smartCardText(card) {
    if (!card) return '';
    return normalizeSearchText((card.dataset && card.dataset.niloTaxonomy) || card.textContent || '');
  }

  function smartCardMatchesMode(card, mode) {
    if (!card) return false;
    if (card.dataset && card.dataset.niloAvailable === '0') return false;
    var text = smartCardText(card);
    var price = Number((card.dataset && card.dataset.niloPrice) || 0);
    var compare = Number((card.dataset && card.dataset.niloCompare) || 0);
    var isMen = /genre:homme|cat:homme|collection:homme|\bhomme\b|\bmen\b/.test(text);
    var isKids = /genre:enfant|cat:enfant|collection:enfant|\benfant\b|\bkids\b/.test(text);
    var has = function (pattern) { return pattern.test(text); };

    switch (mode) {
      case 'under140': return price > 0 && price < 14000;
      case 'under200': return price > 0 && price < 20000;
      case 'under250': return price > 0 && price < 25000;
      case 'under300': return price > 0 && price < 30000;
      case 'sale': case 'flash': return compare > price || has(/business:promotion|business:flash-ready|\bpromo\b|\bsale\b/);
      case 'new': return has(/business:nouveaute|\bnouveaute\b|\bnew\b|جديد/);
      case 'bestseller': return has(/bestseller|best-seller|business:best-seller-potentiel|populaire/);
      case 'dress': return has(/collection:robes|subcat:robes|type:robe|\brobe\b|\bdress\b|فستان/);
      case 'swim': return has(/collection:burkinis|subcat:burkinis|type:burkini|burkini|borkini|bourkini|بوركيني/);
      case 'abaya': return has(/collection:abayas|subcat:abayas|type:abaya|\babaya\b|عباية/);
      case 'jellaba': return has(/collection:jellabas|subcat:jellabas|type:jellaba|jellaba|djellaba|جلابة/);
      case 'modest': return has(/collection:abayas|subcat:abayas|type:abaya|abaya|jellaba|hijab|جلابة|عباية/);
      case 'set': return has(/collection:ensembles|subcat:ensembles|type:ensemble|\bensemble\b|\bset\b|طقم/);
      case 'pyjama_home': return has(/collection:pyjamas|collection:homewear|collection:nuit|subcat:pyjamas|type:pyjama|pyjama|pijama|pajama|sleepwear|homewear|nuisette|robe de nuit|chemise de nuit|بيجام/);
      case 'sport_set': return has(/collection:survetements|collection:sportwear-femme|type:ensemble-survetement|kitma|kytma|survetement|survêtement|jogging|training|tracksuit|كيطمة|كطمة/);
      case 'takchita': return has(/collection:takchitas|subcat:takchitas|type:takchita|takchita|tekchita|تكشيطة/);
      case 'caftan': return has(/collection:caftans|subcat:caftans|type:caftan|caftan|kaftan|قفطان/);
      case 'shirt': return has(/collection:chemises|subcat:chemises|type:chemise|chemise|shirt|قميص/);
      case 'skirt': return has(/collection:jupes|subcat:jupes|type:jupe|\bjupe\b|\bskirt\b|تنورة/);
      case 'hijab': return has(/collection:hijabs|subcat:hijabs|type:hijab|hijab|khimar|foulard|voile|حجاب|خمار|طرحة/);
      case 'bag': return has(/collection:sacs|subcat:sacs|type:sac|\bsac\b|\bbag\b|pochette|شنطة|حقيبة/);
      case 'shoe': return has(/collection:chaussures|subcat:chaussures|type:chaussure|chauss|shoe|sandale|botte|sneaker|basket|mocassin|talon|صندل/);
      case 'accessory': return has(/collection:accessoires|subcat:accessoires|type:accessoire|accessoire|bijou|ceinture|lunette|collier|bracelet|montre/);
      case 'women': return !isMen && !isKids;
      case 'kids_sale': return isKids && (compare > price || has(/business:promotion|business:flash-ready|\bpromo\b|\bsale\b/));
      case 'kids_under250': return isKids && price > 0 && price < 25000;
      case 'men': return isMen;
      case 'men_shirt': return isMen && has(/collection:chemises|subcat:chemises|type:chemise|chemise|shirt|قميص/);
      case 'men_set': return isMen && has(/collection:ensembles|subcat:ensembles|type:ensemble|ensemble|set|survetement|survêtement|jogging|طقم/);
      case 'men_shoe': return isMen && has(/collection:chaussures|subcat:chaussures|type:chaussure|chauss|shoe|basket|sneaker|mocassin|صندل/);
      case 'men_accessory': return isMen && has(/collection:accessoires|subcat:accessoires|type:accessoire|accessoire|sac|bag|ceinture|montre|lunette/);
      case 'men_sale': return isMen && (compare > price || has(/business:promotion|business:flash-ready|\bpromo\b|\bsale\b/));
      case 'men_new': return isMen && has(/business:nouveaute|\bnouveaute\b|\bnew\b|جديد/);
      case 'men_under250': return isMen && price > 0 && price < 25000;
      case 'men_under300': return isMen && price > 0 && price < 30000;
      case 'men_bestseller': return isMen && has(/bestseller|best-seller|business:best-seller-potentiel|populaire/);
      case 'kids': return isKids;
      default: return true;
    }
  }

  /* Nilo V5.9 catalogue discovery
     Primary source: Shopify's public storefront products JSON, scanned in pages.
     Fallback: already server-rendered cards and collection/search HTML cards.
     Important: a section is never shown until it contains real product cards. */
  var niloDiscoveryHtmlCache = {};
  var niloProductCataloguePromise = null;

  function discoveryRootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function discoveryPageUrl(source, pageNumber) {
    var base = source || (discoveryRootUrl() + 'collections/all');
    try {
      var url = new URL(base, window.location.origin);
      if (pageNumber > 1) url.searchParams.set('page', String(pageNumber));
      else url.searchParams.delete('page');
      return url.toString();
    } catch (error) { return base; }
  }

  function discoveryFetchCards(source, pageNumber) {
    var url = discoveryPageUrl(source, pageNumber);
    if (!niloDiscoveryHtmlCache[url]) {
      niloDiscoveryHtmlCache[url] = fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html', 'X-Requested-With': 'NiloDiscoveryV59' } })
        .then(function (response) { if (!response.ok) throw new Error('catalogue'); return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var host = doc.querySelector('[data-nilo-collection-page] [data-nilo-infinite-items]') ||
            doc.querySelector('[data-nilo-search-page] [data-nilo-infinite-items]') ||
            doc.querySelector('[data-nilo-infinite-items]');
          if (!host) return [];
          return Array.prototype.slice.call(host.querySelectorAll(':scope > .nilo-product-card')).filter(function (card) {
            var image = card.querySelector('.nilo-product-card__media img');
            return !!(image && (image.getAttribute('src') || image.getAttribute('srcset')));
          });
        })
        .catch(function () { return []; });
    }
    return niloDiscoveryHtmlCache[url];
  }

  function parseMoneyCents(value) {
    if (value === null || value === undefined || value === '') return 0;
    if (typeof value === 'number') {
      if (!isFinite(value)) return 0;
      return value > 10000 ? Math.round(value) : Math.round(value * 100);
    }
    var raw = String(value).trim().replace(/[^0-9,.-]/g, '').replace(',', '.');
    var parsed = parseFloat(raw);
    return isFinite(parsed) ? Math.round(parsed * 100) : 0;
  }

  function jsonProductTags(product) {
    if (!product) return '';
    if (Array.isArray(product.tags)) return product.tags.join(' ');
    return String(product.tags || '');
  }

  function jsonProductImage(product) {
    if (!product) return '';
    if (product.image) {
      if (typeof product.image === 'string') return product.image;
      if (product.image.src) return product.image.src;
    }
    if (Array.isArray(product.images) && product.images.length) {
      var image = product.images[0];
      if (typeof image === 'string') return image;
      if (image && image.src) return image.src;
    }
    if (product.featured_image) {
      if (typeof product.featured_image === 'string') return product.featured_image;
      if (product.featured_image.url) return product.featured_image.url;
      if (product.featured_image.src) return product.featured_image.src;
    }
    return '';
  }

  function jsonProductVariant(product) {
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    if (!variants.length) return null;
    return variants.find(function (variant) { return variant && variant.available !== false; }) || variants[0];
  }

  function jsonProductPrice(product) {
    var variant = jsonProductVariant(product);
    if (variant && variant.price !== undefined) return parseMoneyCents(variant.price);
    if (product && product.price !== undefined) return parseMoneyCents(product.price);
    return 0;
  }

  function jsonProductCompare(product) {
    /* Same available variant for current and old price: no max/min mixing. */
    var variant=jsonProductVariant(product);
    return variant ? parseMoneyCents(variant.compare_at_price) : 0;
  }

  function jsonProductAvailable(product) {
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    if (!variants.length) return true;
    return variants.some(function (variant) { return variant && variant.available !== false; });
  }

  function jsonProductText(product) {
    if (!product) return '';
    return normalizeSearchText([
      product.title || '', product.product_type || '', product.vendor || '', jsonProductTags(product)
    ].join(' '));
  }

  function jsonProductGender(product) {
    var text = jsonProductText(product);
    if (/genre:homme|cat:homme|collection:homme|\bhomme\b|\bmen\b|رجال|رجالي/.test(text)) return 'men';
    if (/genre:enfant|cat:enfant|collection:enfant|\benfant\b|\bkids\b|طفل|اطفال|أطفال/.test(text)) return 'kids';
    return 'women';
  }

  function jsonProductMatchesMode(product, mode, genderContext) {
    if (!product || !jsonProductAvailable(product) || !jsonProductImage(product)) return false;
    var text = jsonProductText(product);
    var price = jsonProductPrice(product);
    var compare = jsonProductCompare(product);
    var gender = jsonProductGender(product);
    var has = function (pattern) { return pattern.test(text); };

    if (genderContext === 'women' && mode.indexOf('men_') !== 0 && mode.indexOf('kids') !== 0 && mode !== 'men') {
      if (gender !== 'women') return false;
    } else if (genderContext === 'men' && mode.indexOf('kids') !== 0) {
      if (mode.indexOf('men_') !== 0 && mode !== 'men') return false;
    } else if (genderContext === 'kids') {
      if (mode.indexOf('kids') !== 0) return false;
    }

    switch (mode) {
      case 'under140': return price > 0 && price < 14000;
      case 'under200': return price > 0 && price < 20000;
      case 'under250': return price > 0 && price < 25000;
      case 'under300': return price > 0 && price < 30000;
      case 'sale': case 'flash': return compare > price || has(/business:promotion|business:flash-ready|\bpromo\b|\bsale\b/);
      case 'new': return has(/business:nouveaute|\bnouveaute\b|\bnouveau\b|\bnew\b|جديد/);
      case 'bestseller': return has(/bestseller|best-seller|business:best-seller-potentiel|populaire/);
      case 'dress': return has(/collection:robes|subcat:robes|type:robe|\brobe\b|\bdress\b|فستان|فساتين/);
      case 'swim': return has(/collection:burkinis|subcat:burkinis|type:burkini|burkini|borkini|bourkini|بوركيني/);
      case 'abaya': return has(/collection:abayas|subcat:abayas|type:abaya|\babaya\b|عباية/);
      case 'jellaba': return has(/collection:jellabas|subcat:jellabas|type:jellaba|jellaba|djellaba|جلابة/);
      case 'modest': return has(/collection:abayas|subcat:abayas|type:abaya|abaya|jellaba|hijab|جلابة|عباية/);
      case 'set': return has(/collection:ensembles|subcat:ensembles|type:ensemble|\bensemble\b|\bset\b|طقم/);
      case 'pyjama_home': return has(/collection:pyjamas|collection:homewear|collection:nuit|subcat:pyjamas|type:pyjama|pyjama|pijama|pajama|sleepwear|homewear|nuisette|robe de nuit|chemise de nuit|بيجام/);
      case 'sport_set': return has(/collection:survetements|collection:sportwear-femme|type:ensemble-survetement|kitma|kytma|survetement|survêtement|jogging|training|tracksuit|كيطمة|كطمة/);
      case 'takchita': return has(/collection:takchitas|subcat:takchitas|type:takchita|takchita|tekchita|تكشيطة/);
      case 'caftan': return has(/collection:caftans|subcat:caftans|type:caftan|caftan|kaftan|قفطان/);
      case 'shirt': return has(/collection:chemises|subcat:chemises|type:chemise|chemise|shirt|قميص/);
      case 'skirt': return has(/collection:jupes|subcat:jupes|type:jupe|\bjupe\b|\bskirt\b|تنورة/);
      case 'hijab': return has(/collection:hijabs|subcat:hijabs|type:hijab|hijab|khimar|foulard|voile|حجاب|خمار|طرحة/);
      case 'bag': return has(/collection:sacs|subcat:sacs|type:sac|\bsac\b|\bbag\b|pochette|شنطة|حقيبة/);
      case 'shoe': return has(/collection:chaussures|subcat:chaussures|type:chaussure|chauss|shoe|sandale|botte|sneaker|basket|mocassin|talon|صندل/);
      case 'accessory': return has(/collection:accessoires|subcat:accessoires|type:accessoire|accessoire|bijou|ceinture|lunette|collier|bracelet|montre/);
      case 'women': return gender === 'women';
      case 'kids': return gender === 'kids';
      case 'kids_sale': return gender === 'kids' && (compare > price || has(/business:promotion|business:flash-ready|\bpromo\b|\bsale\b/));
      case 'kids_under250': return gender === 'kids' && price > 0 && price < 25000;
      case 'men': return gender === 'men';
      case 'men_shirt': return gender === 'men' && has(/collection:chemises|subcat:chemises|type:chemise|chemise|shirt|قميص/);
      case 'men_set': return gender === 'men' && has(/collection:ensembles|subcat:ensembles|type:ensemble|ensemble|set|survetement|survêtement|jogging|طقم/);
      case 'men_shoe': return gender === 'men' && has(/collection:chaussures|subcat:chaussures|type:chaussure|chauss|shoe|basket|sneaker|mocassin|صندل/);
      case 'men_accessory': return gender === 'men' && has(/collection:accessoires|subcat:accessoires|type:accessoire|accessoire|sac|bag|ceinture|montre|lunette/);
      case 'men_sale': return gender === 'men' && (compare > price || has(/business:promotion|business:flash-ready|\bpromo\b|\bsale\b/));
      case 'men_new': return gender === 'men' && has(/business:nouveaute|\bnouveaute\b|\bnouveau\b|\bnew\b|جديد/);
      case 'men_under250': return gender === 'men' && price > 0 && price < 25000;
      case 'men_under300': return gender === 'men' && price > 0 && price < 30000;
      case 'men_bestseller': return gender === 'men' && has(/bestseller|best-seller|business:best-seller-potentiel|populaire/);
      default: return genderContext ? gender === genderContext : true;
    }
  }

  function productCataloguePage(pageNumber) {
    var root = discoveryRootUrl();
    var urls = [
      root + 'products.json?limit=250&page=' + pageNumber,
      root + 'collections/all/products.json?limit=250&page=' + pageNumber
    ];
    function attempt(index) {
      if (index >= urls.length) return Promise.resolve([]);
      return fetch(urls[index], { credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'NiloCatalogueV59' } })
        .then(function (response) { if (!response.ok) throw new Error('products-json'); return response.json(); })
        .then(function (payload) {
          var products = payload && Array.isArray(payload.products) ? payload.products : [];
          return products.length ? products : attempt(index + 1);
        })
        .catch(function () { return attempt(index + 1); });
    }
    return attempt(0);
  }

  function v51311CataloguePages() {
    /* Theme-only intelligence: do not download 10k products on every visit.
       Keep the newest 500 products plus two catalogue windows that rotate daily
       and per device. Across visits, Nilo samples the whole large catalogue while
       keeping mobile payloads reasonable. */
    var device = 'nilo';
    try {
      device = localStorage.getItem('nilo_personal_device_v1') || '';
      if (!device) {
        device = String(Date.now()) + '-' + Math.random().toString(36).slice(2);
        localStorage.setItem('nilo_personal_device_v1', device);
      }
    } catch (error) { device = String(Date.now()); }
    /* V5.13.41 — new sampling windows every page refresh, even same day. */
    var visit = String(v512RefreshSeed());
    var a = 3 + (v512Hash(device + '|a|' + visit) % 26);
    var b = 3 + (v512Hash(device + '|b|' + visit) % 26);
    if (b === a) b = 3 + ((b - 2) % 26);
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var constrained = !!(connection && (connection.saveData || /(^|-)2g$|3g/.test(String(connection.effectiveType || ''))));
    return constrained ? [1, a] : [1, 2, a];
  }

  function loadNiloProductCatalogue() {
    if (niloProductCataloguePromise) return niloProductCataloguePromise;
    var pages = v51311CataloguePages();
    niloProductCataloguePromise = Promise.all(pages.map(function(page){ return productCataloguePage(page); }))
      .then(function(groups){
        var all = [], seen = {};
        (groups || []).forEach(function(products){
          (products || []).forEach(function(product){
            if (!product || !product.handle || seen[product.handle]) return;
            seen[product.handle] = true;
            if (jsonProductAvailable(product) && jsonProductImage(product)) all.push(product);
          });
        });
        return all;
      })
      .catch(function(){ return []; });
    return niloProductCataloguePromise;
  }

  function localizeJsonTitle(title) {
    var value = String(title || '');
    var dir = (document.documentElement.getAttribute('dir') || '').toLowerCase();
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (dir !== 'rtl' && lang.indexOf('ar') !== 0) return value;
    var replacements = [
      [/Abayas?/gi,'عباية'], [/Jellabas?|Djellabas?/gi,'جلابة'], [/Takchitas?/gi,'تكشيطة'], [/Caftans?|Kaftans?/gi,'قفطان'],
      [/Robes?/gi,'فستان'], [/Ensembles?/gi,'طقم'], [/Pyjamas?|Pijamas?/gi,'بيجاما'], [/Burkinis?/gi,'بوركيني'],
      [/Hijabs?/gi,'حجاب'], [/Chemises?/gi,'قميص'], [/Jupes?/gi,'تنورة'], [/Chaussures?/gi,'حذاء'], [/Sacs?/gi,'حقيبة'],
      [/\bFemme\b/gi,'نسائية'], [/\bHomme\b/gi,'رجالي'], [/\bEnfant\b/gi,'أطفال'], [/\bmod[eè]le\b/gi,'موديل']
    ];
    replacements.forEach(function (entry) { value = value.replace(entry[0], entry[1]); });
    return value;
  }

  function formatCentsDh(cents) {
    var amount = Math.round(Number(cents || 0) / 100);
    return String(amount) + ' DH';
  }

  function makeJsonProductCard(product, contextNode) {
    var handle = String(product.handle || '');
    var image = jsonProductImage(product);
    if (!handle || !image) return null;
    var price = jsonProductPrice(product);
    var compare = jsonProductCompare(product);
    var text = jsonProductText(product);
    var title = localizeJsonTitle(product.title || 'Nilo');
    var root = discoveryRootUrl();
    var href = root + 'products/' + encodeURIComponent(handle);
    var delivery = (contextNode && contextNode.dataset && contextNode.dataset.niloCardDelivery) || 'Livraison gratuite au Maroc';
    var newLabel = (contextNode && contextNode.dataset && contextNode.dataset.niloCardNew) || 'Nouveau';
    var dealLabel = (contextNode && contextNode.dataset && contextNode.dataset.niloCardDeal) || 'Bon plan';
    var discount = compare > price && compare > 0 ? Math.round(((compare - price) * 100) / compare) : 0;
    var isNew = /business:nouveaute|\bnouveaute\b|\bnew\b|جديد/.test(text);
    var isPromo = discount > 0 || /business:promotion|business:flash-ready|\bpromo\b|\bsale\b/.test(text);

    var article = document.createElement('article');
    article.className = 'nilo-product-card';
    article.dataset.niloProductHandle = handle;
    article.dataset.niloTaxonomy = text;
    article.dataset.niloTitle = String(product.title || title || '');
    article.dataset.niloFamily = (window.NiloCatalogueCore&&window.NiloCatalogueCore.familyKey)?window.NiloCatalogueCore.familyKey(product.title||title||''):String(product.title||title||handle).toLowerCase().replace(/\s+/g,'-');
    article.dataset.niloPrice = String(price);
    article.dataset.niloCompare = String(compare);
    article.dataset.niloAvailable = '1';

    var mediaWrap = document.createElement('div');
    mediaWrap.className = 'nilo-product-card__media-wrap';
    var media = document.createElement('a');
    media.className = 'nilo-product-card__media';
    media.href = href;
    media.setAttribute('aria-label', title);

    var watermark = document.createElement('span');
    watermark.className = 'nilo-image-watermark';
    watermark.setAttribute('aria-hidden','true');
    media.appendChild(watermark);

    var img = document.createElement('img');
    img.src = niloSizedImageUrl(image, 520);
    img.srcset = niloSizedImageUrl(image, 260) + ' 260w, ' + niloSizedImageUrl(image, 390) + ' 390w, ' + niloSizedImageUrl(image, 520) + ' 520w';
    img.sizes = '(max-width: 749px) 46vw, 240px';
    img.alt = title + ' - Nilo Maroc';
    img.width = 520;
    img.height = 650;
    img.loading = 'lazy';
    img.decoding = 'async';
    try { img.fetchPriority = 'low'; } catch (error) {}
    media.appendChild(img);

    var badges = document.createElement('span');
    badges.className = 'nilo-product-card__badges';
    if (isNew) {
      var badgeNew = document.createElement('span');
      badgeNew.className = 'nilo-badge nilo-badge--new';
      badgeNew.textContent = newLabel;
      badges.appendChild(badgeNew);
    }
    if (isPromo) {
      var badgePromo = document.createElement('span');
      badgePromo.className = 'nilo-badge nilo-badge--promo';
      badgePromo.textContent = discount > 0 ? ('-' + discount + '%') : dealLabel;
      badges.appendChild(badgePromo);
    }
    media.appendChild(badges);

    var heart = document.createElement('button');
    heart.className = 'nilo-product-card__heart';
    heart.type = 'button';
    heart.dataset.niloWishlistToggle = '';
    heart.dataset.niloWishlistHandle = handle;
    heart.dataset.niloWishlistTitle = title;
    heart.dataset.niloWishlistUrl = href;
    heart.dataset.niloWishlistImage = image;
    heart.dataset.niloWishlistPrice = String(price);
    heart.dataset.niloWishlistCompare = String(compare);
    heart.setAttribute('aria-label', ((document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0 ? 'أضف إلى المفضلة' : 'Ajouter aux favoris'));
    heart.setAttribute('aria-pressed','false');
    heart.innerHTML = '<svg viewBox="0 0 24 24" width="19" height="19" fill="none"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var open = document.createElement('button');
    open.className = 'nilo-product-card__open';
    open.type = 'button';
    open.dataset.niloQuickAdd = '';
    open.dataset.niloQuickAddHandle = handle;
    open.setAttribute('aria-label', ((document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0 ? 'أضف إلى السلة' : 'Ajouter au panier'));
    open.textContent = '+';
    mediaWrap.appendChild(media);
    mediaWrap.appendChild(open);
    article.appendChild(mediaWrap);
    article.appendChild(heart);

    var info = document.createElement('div');
    info.className = 'nilo-product-card__info';
    var titleLink = document.createElement('a');
    titleLink.className = 'nilo-product-card__title';
    titleLink.href = href;
    titleLink.textContent = title;
    info.appendChild(titleLink);
    var metaBadges=document.createElement('div');
    metaBadges.className='nilo-product-card__meta-badges';
    if(isNew){var mn=document.createElement('span');mn.className='is-new';mn.innerHTML='<i>✦</i>'+newLabel;metaBadges.appendChild(mn);}
    if(discount>0){var ms=document.createElement('span');ms.className='is-sale';ms.innerHTML='<i>↓</i>-'+discount+'%';metaBadges.appendChild(ms);}
    var md=document.createElement('span');md.className='is-delivery';md.innerHTML='<i>✓</i>0 DH · Livraison gratuite';metaBadges.appendChild(md);
    var mst=document.createElement('span');mst.className='is-stock';mst.innerHTML='<i>●</i>Disponible';metaBadges.appendChild(mst);
    info.appendChild(metaBadges);
    var priceBox = document.createElement('div');
    priceBox.className = 'nilo-product-card__price';
    var current = document.createElement('span');
    current.textContent = formatCentsDh(price);
    priceBox.appendChild(current);
    if (compare > price) {
      var old = document.createElement('s');
      old.textContent = formatCentsDh(compare);
      priceBox.appendChild(old);
    }
    info.appendChild(priceBox);
    var deliveryNode = document.createElement('p');
    deliveryNode.className = 'nilo-product-card__delivery';
    deliveryNode.textContent = delivery;
    info.appendChild(deliveryNode);
    article.appendChild(info);
    return article;
  }

  function makeDiscoveryWrapper(card) {
    var wrapper = document.createElement('div');
    wrapper.className = 'nilo-smart-item';
    var handle = productHandleFromNode(card);
    if (handle) wrapper.dataset.niloProductHandle = handle;
    if(card&&card.dataset&&card.dataset.niloFamily)wrapper.dataset.niloFamily=card.dataset.niloFamily;
    wrapper.appendChild(card.cloneNode(true));
    return wrapper;
  }

  function sectionSpecificity(section) {
    var mode = String(section.dataset.niloSmartMode || '');
    if (/^(women|men|kids)$/.test(mode)) return 0;
    if (/under|sale|flash|new|bestseller/.test(mode)) return 1;
    return 3;
  }

  function existingSectionCards(section, reserved, currentHandle) {
    var cards = [];
    var seen = {};
    section.querySelectorAll('[data-nilo-smart-rail] > .nilo-smart-item .nilo-product-card').forEach(function (card) {
      var handle = productHandleFromNode(card);
      var image = card.querySelector('.nilo-product-card__media img');
      if (!handle || handle === currentHandle || reserved[handle] || seen[handle] || !image || !(image.getAttribute('src') || image.getAttribute('srcset'))) return;
      if (!smartCardMatchesMode(card, section.dataset.niloSmartMode || '')) return;
      seen[handle] = true;
      cards.push(card.cloneNode(true));
    });
    return cards;
  }

  function renderReadySection(section, products, cards, contextNode) {
    var rail = section.querySelector('[data-nilo-smart-rail]');
    if (!rail) { section.hidden = true; return; }
    while (rail.firstChild) rail.removeChild(rail.firstChild);
    (products || []).forEach(function (product) {
      var card = makeJsonProductCard(product, contextNode);
      if (!card) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'nilo-smart-item';
      wrapper.dataset.niloProductHandle = product.handle;
      wrapper.appendChild(card);
      rail.appendChild(wrapper);
    });
    (cards || []).forEach(function (card) { rail.appendChild(makeDiscoveryWrapper(card)); });
    var count = rail.querySelectorAll(':scope > .nilo-smart-item').length;
    section.removeAttribute('data-nilo-hydrating');
    section.removeAttribute('data-nilo-hydration-started');
    section.dataset.niloHydrated = 'true';
    section.dataset.niloCount = String(count);
    if (count >= 2) {
      section.hidden = false;
      section.classList.add('is-ready','is-visible');
    } else {
      section.hidden = true;
      section.classList.remove('is-ready','is-visible');
    }
  }

  function fallbackSectionCardsFromHtml(section, reserved, currentHandle) {
    var source = section.dataset.niloSourceUrl || (discoveryRootUrl() + 'collections/all');
    var mode = section.dataset.niloSmartMode || '';
    var pages = [1,2,3,4,5,6];
    var cards = [];
    var seen = {};
    function step(index) {
      if (cards.length >= 8 || index >= pages.length) return Promise.resolve(cards);
      return discoveryFetchCards(source, pages[index]).then(function (fetched) {
        fetched.forEach(function (card) {
          var handle = productHandleFromNode(card);
          if (!handle || handle === currentHandle || reserved[handle] || seen[handle]) return;
          if (!smartCardMatchesMode(card, mode)) return;
          var img = card.querySelector('.nilo-product-card__media img');
          if (!img || !(img.getAttribute('src') || img.getAttribute('srcset'))) return;
          seen[handle] = true;
          cards.push(card.cloneNode(true));
        });
        return step(index + 1);
      });
    }
    return step(0);
  }

  function hydrateDiscoveryGroup(sections, options) {
    options = options || {};
    if (!sections || !sections.length) return Promise.resolve();
    var contextNode = options.contextNode || document.body;
    var genderContext = options.genderContext || '';
    var currentHandle = options.currentHandle || '';
    var reserved = options.reserved || {};
    if (currentHandle) reserved[currentHandle] = true;

    sections.forEach(function (section) {
      section.hidden = true;
      section.classList.remove('is-ready','is-visible');
      section.removeAttribute('data-nilo-hydrating');
      section._niloExistingCards = existingSectionCards(section, reserved, currentHandle);
    });

    return loadNiloProductCatalogue().then(function (catalogue) {
      var ordered = sections.slice().sort(function (a,b) { return sectionSpecificity(b) - sectionSpecificity(a); });
      ordered.forEach(function (section) {
        var mode = section.dataset.niloSmartMode || '';
        var target = Math.max(6, Math.min(12, Number(section.dataset.niloTargetCount || 10)));
        var candidates = catalogue.filter(function (product) {
          return product.handle !== currentHandle && !reserved[product.handle] && jsonProductMatchesMode(product, mode, genderContext);
        });
        /* Rotate results per section/current product so the same catalogue does not
           always start with the exact same dozen products. */
        if (candidates.length > 1) {
          var seed = 0;
          var seedText = String((section.dataset.niloSectionKey || mode) + currentHandle);
          for (var i=0;i<seedText.length;i++) seed = (seed * 31 + seedText.charCodeAt(i)) >>> 0;
          var offset = seed % candidates.length;
          candidates = candidates.slice(offset).concat(candidates.slice(0,offset));
        }
        var selected = candidates.slice(0,target);
        section._niloSelectedProducts = selected;
        if (selected.length >= 2) selected.forEach(function (product) { reserved[product.handle] = true; });
      });

      sections.forEach(function (section) {
        var selected = section._niloSelectedProducts || [];
        if (selected.length >= 2) {
          renderReadySection(section, selected, [], contextNode);
          return;
        }
        var fallbackCards = (section._niloExistingCards || []).filter(function (card) {
          var handle = productHandleFromNode(card);
          return handle && !reserved[handle] && handle !== currentHandle;
        }).slice(0,10);
        if (fallbackCards.length >= 2) {
          fallbackCards.forEach(function (card) { var handle = productHandleFromNode(card); if (handle) reserved[handle] = true; });
          renderReadySection(section, [], fallbackCards, contextNode);
        } else {
          section.hidden = true;
        }
      });

      /* Only retry a few still-empty sections using HTML pages. The headings stay
         hidden during this fallback, so customers never see empty rails. */
      var empty = sections.filter(function (section) { return !section.classList.contains('is-ready'); }).slice(0,8);
      var chain = Promise.resolve();
      empty.forEach(function (section) {
        chain = chain.then(function () {
          return fallbackSectionCardsFromHtml(section, reserved, currentHandle).then(function (cards) {
            if (cards.length >= 2) {
              cards.forEach(function (card) { var handle = productHandleFromNode(card); if (handle) reserved[handle] = true; });
              renderReadySection(section, [], cards.slice(0,10), contextNode);
            } else {
              section.hidden = true;
            }
          });
        });
      });
      return chain;
    }).catch(function () {
      sections.forEach(function (section) {
        var cards = section._niloExistingCards || [];
        if (cards.length >= 2) renderReadySection(section, [], cards.slice(0,10), contextNode);
        else section.hidden = true;
      });
    });
  }

  function hydrateProductDiscovery(page) {
    if (!page) return;
    var sections = Array.prototype.slice.call(page.querySelectorAll('[data-nilo-smart-section][data-nilo-js-discovery="true"]'));
    if (!sections.length) return;
    var reserved = {};
    var currentHandle = String(page.dataset.productHandle || '');
    var genderContext = String(page.dataset.niloProductGender || 'women');
    page._niloDiscoveryHandles = reserved;
    hydrateDiscoveryGroup(sections, {
      contextNode: page,
      genderContext: genderContext,
      currentHandle: currentHandle,
      reserved: reserved
    });
  }

  function hydrateHomeDiscovery() {
    var home = document.querySelector('[data-nilo-app-home]');
    if (!home) return;
    var sections = Array.prototype.slice.call(home.querySelectorAll('[data-nilo-smart-section][data-nilo-js-discovery="true"]'));
    if (!sections.length) return;
    var reserved = {};
    home.querySelectorAll('.nilo-product-card').forEach(function (card) {
      if (card.closest('[data-nilo-smart-section]')) return;
      var handle = productHandleFromNode(card);
      if (handle) reserved[handle] = true;
    });
    hydrateDiscoveryGroup(sections, { contextNode: home, reserved: reserved });
  }

  function initPredictiveSearch() {
    document.querySelectorAll('[data-nilo-predictive-search]').forEach(function (form) {
      var input = form.querySelector('input[type="search"]');
      var results = form.parentElement.querySelector('[data-nilo-predictive-results]');
      var endpoint = form.dataset.predictiveUrl;
      var timer;
      var controller;
      var requestId = 0;
      if (!input || !results || !endpoint) return;

      function close() { results.hidden = true; results.innerHTML = ''; }

      function buildUrl(term, includeCollections) {
        var joiner = endpoint.indexOf('?') === -1 ? '?' : '&';
        var types = includeCollections ? 'product,collection' : 'product';
        return endpoint + joiner +
          'q=' + encodeURIComponent(term) +
          '&resources%5Btype%5D=' + encodeURIComponent(types) +
          '&resources%5Blimit%5D=8' +
          '&resources%5Blimit_scope%5D=each' +
          '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
          // V5.2 priority rule: TITLE first. Do not let tags/body win before a title match.
          '&resources%5Boptions%5D%5Bfields%5D=title' +
          '&section_id=predictive-search-v5';
      }

      function productCountFromHtml(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var panel = doc.querySelector('[data-nilo-predictive-count]');
        return panel ? Number(panel.getAttribute('data-nilo-predictive-count') || 0) : 0;
      }

      function fetchCandidate(candidates, index, activeRequestId, originalTerm) {
        if (activeRequestId !== requestId) return Promise.resolve(null);
        var term = candidates[index];
        return fetch(buildUrl(term, false), {
          signal: controller.signal,
          headers: { Accept: 'text/html' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('search');
            return response.text();
          })
          .then(function (html) {
            if (activeRequestId !== requestId) return null;
            if (productCountFromHtml(html) > 0) return html;
            if (index < candidates.length - 1) {
              return fetchCandidate(candidates, index + 1, activeRequestId, originalTerm);
            }
            // No title match, including close-language aliases: only now ask for categories.
            return fetch(buildUrl(originalTerm, true), {
              signal: controller.signal,
              headers: { Accept: 'text/html' }
            }).then(function (response) {
              if (!response.ok) throw new Error('search');
              return response.text();
            });
          });
      }

      function search() {
        var term = input.value.trim();
        if (!term) { close(); return; }
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          requestId += 1;
          var activeRequestId = requestId;
          if (controller) controller.abort();
          controller = new AbortController();
          results.hidden = false;
          results.innerHTML = '<div class="nilo-search-loading"><span></span></div>';

          var candidates = getSearchCandidates(term);
          fetchCandidate(candidates, 0, activeRequestId, term)
            .then(function (html) {
              if (!html || activeRequestId !== requestId) return;
              results.innerHTML = html;
              // Do NOT randomize predictive-search results: Shopify relevance order is intentional.
            })
            .catch(function (error) {
              if (error.name !== 'AbortError' && activeRequestId === requestId) close();
            });
        }, 160);
      }

      input.addEventListener('input', search);
      // Keep exactly what the customer typed on submit. V5.4: for a recognized Nilo
      // family, the server-side search page always routes to the canonical category so
      // the full catalogue is shown; predictive search remains title-first.
      input.addEventListener('focus', function () { if (results.innerHTML) results.hidden = false; });
      document.addEventListener('click', function (event) { if (!form.parentElement.contains(event.target)) close(); });
      document.addEventListener('keydown', function (event) { if (event.key === 'Escape') close(); });
    });
  }

  function initInfiniteScroll() {
    if (!('IntersectionObserver' in window)) return;

    function runIdle(fn, timeout) {
      if ('requestIdleCallback' in window) return window.requestIdleCallback(fn, { timeout: timeout || 700 });
      return window.setTimeout(fn, 80);
    }

    function bufferTarget() {
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (connection && connection.saveData) return 2;
      var type = String(connection && connection.effectiveType || '');
      if (/2g/.test(type)) return 2;
      if (/3g/.test(type)) return 3;
      return 4;
    }

    function warmBatchImages(nodes, limit) {
      if (!nodes || !nodes.length) return;
      runIdle(function () {
        var warmed = 0;
        nodes.some(function (node) {
          if (warmed >= (limit || 10)) return true;
          var card = node.matches && node.matches('.nilo-product-card') ? node : node.querySelector && node.querySelector('.nilo-product-card');
          var img = card && card.querySelector('.nilo-product-card__media img');
          if (!img) return false;
          var src = img.getAttribute('src') || '';
          if (!src) {
            var srcset = String(img.getAttribute('srcset') || '').split(',').map(function (part) { return part.trim().split(/\s+/)[0]; }).filter(Boolean);
            src = srcset.length ? srcset[Math.min(srcset.length - 1, 1)] : '';
          }
          if (!src) return false;
          var preload = new Image();
          preload.decoding = 'async';
          preload.src = src;
          warmed += 1;
          return false;
        });
      }, 1000);
    }

    document.querySelectorAll('[data-nilo-infinite-section]:not([data-nilo-v51342-managed])').forEach(function (section) {
      var sectionId = section.dataset.sectionId;
      var currentItems = section.querySelector('[data-nilo-infinite-items]');
      var sentinel = section.querySelector('[data-nilo-infinite-next]');
      if (!currentItems || !sentinel) return;

      var preserveOrder = section.hasAttribute('data-nilo-search-page') || section.hasAttribute('data-nilo-collection-page') || section.hasAttribute('data-nilo-preserve-order');
      var queue = [];
      var cursor = sentinel.href || '';
      var priming = false;
      var done = !cursor;
      var observer = null;
      var targetPages = bufferTarget();
      var eagerPages = targetPages >= 4 ? 2 : 1;
      var fallbackVisible = false;

      /* Keep the real pagination link as an invisible sentinel. It remains in the
         document for progressive enhancement, but customers never wait on it. */
      sentinel.style.display = 'block';
      sentinel.style.height = '1px';
      sentinel.style.minHeight = '1px';
      sentinel.style.overflow = 'hidden';
      sentinel.style.opacity = '0';
      sentinel.style.pointerEvents = 'none';
      sentinel.setAttribute('aria-hidden', 'true');

      function prioritizeInitialHomeCards(){
        if (!section.classList.contains('nilo-infinite-home'))return;
        var children=Array.prototype.slice.call(currentItems.children);
        var cards=window.NiloClothingPriorityV51381.cards(children.filter(function(n){return n.matches&&n.matches('.nilo-product-card');}),'all');
        if(cards.length<2)return;
        var i=0;children.forEach(function(node){currentItems.appendChild(node.matches&&node.matches('.nilo-product-card')?cards[i++]:node);});
      }
      prioritizeInitialHomeCards();

      function updateSentinel() {
        var nextUrl = queue.length ? queue[0].sourceUrl : cursor;
        if (nextUrl) sentinel.href = nextUrl;
        if (done && !queue.length && observer) observer.disconnect();
      }

      function pageUrl(url) {
        if (!url) return '';
        var separator = url.indexOf('?') === -1 ? '?' : '&';
        return url + separator + 'section_id=' + encodeURIComponent(sectionId);
      }

      function fetchPage(url) {
        return fetch(pageUrl(url), { credentials: 'same-origin', headers: { Accept: 'text/html', 'X-Requested-With': 'NiloBufferedFeedV51338' } })
          .then(function (response) {
            if (!response.ok) throw new Error('feed');
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newItems = doc.querySelector('[data-nilo-infinite-items]');
            var newNext = doc.querySelector('[data-nilo-infinite-next]');
            return {
              sourceUrl: url,
              nodes: newItems ? Array.prototype.slice.call(newItems.children) : [],
              nextUrl: newNext ? newNext.href : ''
            };
          });
      }

      function revealFallback() {
        if (fallbackVisible) return;
        fallbackVisible = true;
        sentinel.style.height = '';
        sentinel.style.minHeight = '';
        sentinel.style.overflow = '';
        sentinel.style.opacity = '1';
        sentinel.style.pointerEvents = '';
        sentinel.removeAttribute('aria-hidden');
      }

      async function primeBuffer() {
        if (priming || done || !cursor || queue.length >= targetPages) return;
        priming = true;
        try {
          while (!done && cursor && queue.length < targetPages) {
            var source = cursor;
            var entry = await fetchPage(source);
            if (!entry.nodes.length) {
              done = true;
              cursor = '';
              break;
            }
            queue.push(entry);
            cursor = entry.nextUrl || '';
            if (!cursor) done = true;
            warmBatchImages(entry.nodes, queue.length === 1 ? 14 : 8);
          }
        } catch (error) {
          /* A transient request error should never block scrolling. Keep the
             regular Shopify next link available as a fallback only on failure. */
          revealFallback();
        } finally {
          priming = false;
          updateSentinel();
        }
      }

      function appendBufferedPage() {
        var appended = 0;
        while (queue.length && !appended) {
          var entry = queue.shift();
          var batch = entry.nodes || [];
          var orderedBatch = preserveOrder ? batch : shuffle(batch);
          var strictMode = currentItems.dataset.niloStrictFamily || (window.NiloV51336 && window.NiloV51336.pathMode ? window.NiloV51336.pathMode() : 'all');
          if (window.NiloV51336 && window.NiloV51336.prepareBatch) orderedBatch = window.NiloV51336.prepareBatch(orderedBatch, strictMode, currentItems);
          // The mixed homepage feed must not begin with cheap accessories while
          // clothing is available in the same Shopify batch.
          if (section.classList.contains('nilo-infinite-home')) {
            var slots = orderedBatch.map(function(n){return n&&n.matches&&n.matches('.nilo-product-card');});
            var apparel = window.NiloClothingPriorityV51381.cards(orderedBatch.filter(function(n){return n&&n.matches&&n.matches('.nilo-product-card');}),'all');
            orderedBatch = orderedBatch.map(function(n,i){return slots[i]?apparel.shift():n;});
          }

          var existingHandles = {};
          currentItems.querySelectorAll('.nilo-product-card').forEach(function (card) {
            var handle = productHandleFromNode(card);
            if (handle) existingHandles[handle] = true;
          });

          var fragment = document.createDocumentFragment();
          orderedBatch.forEach(function (item) {
            var handle = productHandleFromNode(item);
            if (handle && existingHandles[handle]) return;
            if (handle) existingHandles[handle] = true;
            fragment.appendChild(item);
            appended += 1;
          });
          if (appended) currentItems.appendChild(fragment);
        }

        if (appended && !preserveOrder) dedupeCatalogue(section.closest('[data-nilo-product-page], [data-nilo-smart-home], body') || document);
        updateSentinel();
        /* Refill immediately after consumption so several full pages are always
           waiting in memory before the customer reaches them. */
        primeBuffer();
        if (queue.length) warmBatchImages(queue[0].nodes, 14);
        return appended > 0;
      }

      function consumeEagerly(left) {
        if (left <= 0 || (done && !queue.length)) return;
        if (queue.length) {
          appendBufferedPage();
          runIdle(function () { consumeEagerly(left - 1); }, 550);
          return;
        }
        primeBuffer();
        window.setTimeout(function () { consumeEagerly(left); }, 90);
      }

      /* Network prefetch starts immediately, independently of scrolling. */
      primeBuffer();

      /* Add the first 1–2 prefetched pages while the browser is idle. This gives
         the customer a long runway of products already in the DOM. */
      var startEager = function () { runIdle(function () { consumeEagerly(eagerPages); }, 650); };
      if (document.readyState === 'complete') startEager();
      else window.addEventListener('load', startEager, { once: true });

      /* The observer now consumes an ALREADY-FETCHED buffer several screens early.
         It does not wait for a network request at the end of the grid. */
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (!appendBufferedPage()) primeBuffer();
        });
      }, { rootMargin: '3200px 0px' });
      observer.observe(sentinel);
    });
  }

  function toast(message) {
    var node = document.querySelector('.nilo-toast');
    if (!node) { node = document.createElement('div'); node.className = 'nilo-toast'; document.body.appendChild(node); }
    node.textContent = message;
    node.classList.add('is-visible');
    window.clearTimeout(node._timer);
    node._timer = window.setTimeout(function () { node.classList.remove('is-visible'); }, 2200);
  }

  function updateCartBadges(count) {
    document.querySelectorAll('.nilo-mobile-nav__cart-icon').forEach(function (icon) {
      var badge = icon.querySelector('b');
      if (!badge && count > 0) { badge = document.createElement('b'); icon.appendChild(badge); }
      if (badge) { badge.textContent = count; badge.hidden = count < 1; }
    });
    document.querySelectorAll('[data-cart-count], .cart_items_count, [data-nilo-desktop-cart-count]').forEach(function (badge) { badge.textContent = count; if (badge.tagName === 'B') badge.hidden = count < 1; });
  }


  /* Nilo V5.10 — catalogue-wide product-page rails.
     - No IntersectionObserver / scroll-triggered loading.
     - The catalogue feed starts at HTML parse time from main-product-v5.liquid.
     - All recommendation rails are built in one DOM commit.
     - A product handle is used only once across the V5.10 rails. */
  function v510CardGender(card) {
    var text = smartCardText(card);
    if (/genre:homme|cat:homme|collection:homme|\bhomme\b|\bmen\b|رجال|رجالي/.test(text)) return 'men';
    if (/genre:enfant|cat:enfant|collection:enfant|\benfant\b|\bkids\b|طفل|اطفال|أطفال/.test(text)) return 'kids';
    return 'women';
  }

  function v510Seed(text) {
    var value = 2166136261;
    String(text || '').split('').forEach(function(ch){ value ^= ch.charCodeAt(0); value = Math.imul(value, 16777619); });
    return value >>> 0;
  }

  function v510Rotate(list, seedText) {
    if (!list.length) return [];
    var offset = v510Seed(seedText) % list.length;
    return list.slice(offset).concat(list.slice(0, offset));
  }

  function v510ParseFeedHtml(html) {
    if (!html) return [];
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var feed = doc.querySelector('[data-nilo-v510-feed]');
    if (!feed) return [];
    return Array.prototype.slice.call(feed.querySelectorAll(':scope > .nilo-product-card')).filter(function(card){
      var handle = productHandleFromNode(card);
      var image = card.querySelector('.nilo-product-card__media img');
      return !!(handle && image && (image.getAttribute('src') || image.getAttribute('srcset')));
    });
  }

  function v510CatalogueCards() {
    var promise = window.__niloV510FeedPromise;
    if (!promise) {
      var root = discoveryRootUrl();
      promise = Promise.all([1,2,3,4].map(function(page){
        return fetch(root + 'collections/all?view=nilo-feed&page=' + page, { credentials:'same-origin', headers:{Accept:'text/html'} })
          .then(function(response){ return response.ok ? response.text() : ''; })
          .catch(function(){ return ''; });
      }));
    }
    return promise.then(function(htmlPages){
      var cards = [], seen = {};
      (htmlPages || []).forEach(function(html){
        v510ParseFeedHtml(html).forEach(function(card){
          var handle = productHandleFromNode(card);
          if (!handle || seen[handle]) return;
          seen[handle] = true;
          cards.push(card);
        });
      });
      if (cards.length >= 56) return cards;
      /* Safety net: if Shopify ever ignores the alternate feed view, use the
         normal collection HTML pages. This path is not scroll-triggered either. */
      var root = discoveryRootUrl();
      return Promise.all([1,2,3,4,5,6,7,8,9,10,11,12].map(function(page){
        var url = root + 'collections/all' + (page > 1 ? ('?page=' + page) : '');
        return fetch(url, {credentials:'same-origin', headers:{Accept:'text/html'}})
          .then(function(response){ return response.ok ? response.text() : ''; })
          .then(function(html){
            if (!html) return [];
            var doc = new DOMParser().parseFromString(html,'text/html');
            var host = doc.querySelector('[data-nilo-collection-page] [data-nilo-infinite-items]') || doc.querySelector('[data-nilo-infinite-items]');
            if (!host) return [];
            return Array.prototype.slice.call(host.querySelectorAll(':scope > .nilo-product-card')).filter(function(card){
              var image=card.querySelector('.nilo-product-card__media img');
              return !!(productHandleFromNode(card) && image && (image.getAttribute('src') || image.getAttribute('srcset')));
            });
          }).catch(function(){ return []; });
      })).then(function(groups){
        var seen = {};
        cards.forEach(function(card){ var h=productHandleFromNode(card); if(h) seen[h]=true; });
        groups.forEach(function(group){
          (group || []).forEach(function(card){
            var h=productHandleFromNode(card);
            if (!h || seen[h]) return;
            seen[h]=true; cards.push(card);
          });
        });
        return cards;
      });
    });
  }

  function v510LabelPack(gender) {
    var ar = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
    if (ar) {
      return {
        view:'شوف الكل', genericKickers:['اختيارات نيلو','اكتشفي أكثر','موضة الآن','اختيارات لك'],
        genericTitles:['مزيد من الاختيارات لك','كملي التسوق','إطلالات أخرى تستحق التجربة','اختيارات جديدة من نيلو'],
        modeTitles:{women:'اختيارات نسائية', men:'اختيارات رجالية', kids:'اختيارات الأطفال', dress:'فساتين أكثر', set:'أطقم أكثر', pyjama_home:'بيجامات وملابس البيت', bag:'حقائب تكمل الإطلالة', shoe:'أحذية للإطلالة', abaya:'عبايات أكثر', jellaba:'جلابات أكثر', hijab:'حجابات وخُمُر', sport_set:'أطقم رياضية', swim:'بوركيني', accessory:'إكسسوارات', caftan:'قفاطين', takchita:'تكاشط', shirt:'قمصان', skirt:'تنانير', modest:'موضة محتشمة', new:'وصل حديثاً', sale:'عروض وأسعار خاصة', bestseller:'الأكثر إعجاباً', under200:'اختيارات تحت 200 DH', under250:'اختيارات تحت 250 DH', men_new:'جديد الرجال', men_sale:'عروض الرجال', men_set:'أطقم رجالية', men_shirt:'قمصان رجالية', men_shoe:'أحذية رجالية', men_accessory:'إكسسوارات رجالية', men_under250:'أقل من 250 DH', men_under300:'أقل من 300 DH', men_bestseller:'الأكثر شعبية', kids_sale:'عروض الأطفال', kids_under250:'أقل من 250 DH'}
      };
    }
    return {
      view:'Voir tout', genericKickers:['SÉLECTION NILO','ENCORE À DÉCOUVRIR','TENDANCE MAINTENANT','CHOISI POUR TOI','CONTINUE TON SHOPPING'],
      genericTitles:['Encore plus de choix pour toi','Continue de découvrir','Des idées de looks à ne pas manquer','Une nouvelle sélection Nilo','Le catalogue continue ici'],
      modeTitles:{women:'Encore plus de mode femme', men:'Encore plus de mode homme', kids:'Encore plus pour les enfants', dress:'Encore plus de robes', set:'Ensembles à découvrir', pyjama_home:'Pyjamas & tenues maison', bag:'Les sacs qui complètent le look', shoe:'Chaussures pour finir la tenue', abaya:'Encore plus d’abayas', jellaba:'Jellabas à découvrir', hijab:'Hijabs & foulards', sport_set:'Ensembles sport tendance', swim:'Burkinis à découvrir', accessory:'Les détails qui changent tout', caftan:'Caftans à découvrir', takchita:'Takchitas pour tes occasions', shirt:'Chemises à découvrir', skirt:'Jupes à découvrir', modest:'Mode pudique à découvrir', new:'Nouveautés à ne pas manquer', sale:'Bons plans du moment', bestseller:'Les plus populaires', under200:'Petits prix à moins de 200 DH', under250:'Encore plus à moins de 250 DH', men_new:'Nouveautés homme', men_sale:'Bons plans homme', men_set:'Ensembles homme', men_shirt:'Chemises homme', men_shoe:'Chaussures homme', men_accessory:'Accessoires homme', men_under250:'Homme à moins de 250 DH', men_under300:'Homme à moins de 300 DH', men_bestseller:'Les plus populaires homme', kids_sale:'Bons plans enfant', kids_under250:'Enfant à moins de 250 DH'}
    };
  }

  function v510ModeSequence(gender, page) {
    var related = String(page.dataset.niloRelatedMode || '');
    var outfit1 = String(page.dataset.niloOutfitMode1 || '');
    var outfit2 = String(page.dataset.niloOutfitMode2 || '');
    var modes;
    if (gender === 'men') {
      modes = [related,'men_new','men_set','men_shirt','men_shoe','men_accessory','men_sale','men_under250','men_bestseller','men_under300','men'];
    } else if (gender === 'kids') {
      modes = [related,'kids','kids_sale','kids_under250','kids'];
    } else {
      modes = [related,outfit1,outfit2,'new','sale','bestseller','under200','under250','dress','set','pyjama_home','bag','shoe','abaya','jellaba','hijab','sport_set','swim','accessory','caftan','takchita','shirt','skirt','modest','women'];
    }
    return modes.filter(function(mode,index){ return !!mode && modes.indexOf(mode) === index; });
  }

  function v510ModeHref(mode, page) {
    var existing = page.querySelector('[data-nilo-smart-section][data-nilo-smart-mode="' + String(mode).replace(/"/g,'') + '"]');
    return (existing && existing.dataset.niloSourceUrl) || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'collections/all';
  }

  function v510MakeSection(spec, cards, page, labels, index) {
    var section = document.createElement('section');
    section.className = 'nilo-smart-section is-ready is-visible nilo-v510-section';
    section.dataset.niloSmartMode = spec.mode;
    section.dataset.niloV510Index = String(index);
    var header = document.createElement('header');
    header.className = 'nilo-app-heading';
    var copy = document.createElement('div');
    var small = document.createElement('small');
    small.textContent = spec.kicker;
    var h2 = document.createElement('h2');
    h2.textContent = spec.title;
    copy.appendChild(small); copy.appendChild(h2);
    var all = document.createElement('a');
    all.href = spec.href || v510ModeHref(spec.mode, page);
    all.textContent = labels.view + ' ›';
    header.appendChild(copy); header.appendChild(all);
    var rail = document.createElement('div');
    rail.className = 'nilo-smart-rail';
    rail.dataset.niloSmartRail = '';
    cards.forEach(function(card){
      var wrapper = document.createElement('div');
      wrapper.className = 'nilo-smart-item';
      var handle = productHandleFromNode(card);
      if (handle) wrapper.dataset.niloProductHandle = handle;
      wrapper.appendChild(card.cloneNode(true));
      rail.appendChild(wrapper);
    });
    section.appendChild(header); section.appendChild(rail);
    return section;
  }

  function v510DedupeInstantRails(page, reserved) {
    page.querySelectorAll('[data-nilo-smart-section]:not([hidden])').forEach(function(section){
      var kept = 0;
      section.querySelectorAll('[data-nilo-smart-rail] > .nilo-smart-item').forEach(function(item){
        var card = item.querySelector('.nilo-product-card');
        var handle = productHandleFromNode(card || item);
        if (!handle || reserved[handle]) { item.remove(); return; }
        reserved[handle] = true; kept += 1;
      });
      if (kept < 2) section.hidden = true;
    });
  }

  function initV510EndlessProductDiscovery(page) {
    if (!page || page.dataset.niloV510Started === '1') return;
    page.dataset.niloV510Started = '1';
    var mount = page.querySelector('[data-nilo-v510-endless]');
    if (!mount) return;
    var currentHandle = String(page.dataset.productHandle || '');
    var gender = String(page.dataset.niloProductGender || 'women');
    var reserved = {};
    if (currentHandle) reserved[currentHandle] = true;
    v510DedupeInstantRails(page, reserved);
    page._niloDiscoveryHandles = reserved;

    /* Nothing is scroll-triggered. Feed requests have already started. */
    v510CatalogueCards().then(function(allCards){
      if (!allCards.length) return;
      var genderCards = allCards.filter(function(card){ return v510CardGender(card) === gender; });
      if (!genderCards.length) return;
      genderCards = v510Rotate(genderCards, currentHandle + ':' + gender + ':v510');
      var available = genderCards.filter(function(card){ var handle = productHandleFromNode(card); return handle && !reserved[handle] && handle !== currentHandle; });
      var targetSections = 20;
      var cardsPerSection = available.length >= 224 ? 4 : (available.length >= 168 ? 3 : (available.length >= 112 ? 2 : 1));
      var possibleSections = Math.floor(available.length / cardsPerSection);
      var sectionCount = Math.min(targetSections, possibleSections);
      if (sectionCount < 1) return;
      var labels = v510LabelPack(gender);
      var modes = v510ModeSequence(gender, page);
      var fragment = document.createDocumentFragment();

      function takeFrom(predicate, count) {
        var selected = [];
        for (var i=0; i<available.length && selected.length<count; i++) {
          var card = available[i];
          if (!card) continue;
          var handle = productHandleFromNode(card);
          if (!handle || reserved[handle]) continue;
          if (!predicate(card)) continue;
          reserved[handle] = true;
          selected.push(card);
        }
        return selected;
      }

      for (var index=0; index<sectionCount; index++) {
        var requestedMode = modes[index % modes.length] || gender;
        var selected = takeFrom(function(card){
          if (v510CardGender(card) !== gender) return false;
          return smartCardMatchesMode(card, requestedMode);
        }, cardsPerSection);
        var fallback = selected.length < cardsPerSection;
        if (fallback) {
          /* Put back the partial mode selection so a narrow category never produces
             a misleading half-filled rail. Then use a fully generic same-gender rail. */
          selected.forEach(function(card){ var h=productHandleFromNode(card); if(h) delete reserved[h]; });
          selected = takeFrom(function(card){ return v510CardGender(card) === gender; }, cardsPerSection);
        }
        if (selected.length < cardsPerSection) break;
        var genericIndex = index % labels.genericTitles.length;
        var title = fallback ? labels.genericTitles[genericIndex] : (labels.modeTitles[requestedMode] || labels.genericTitles[genericIndex]);
        var kicker = labels.genericKickers[index % labels.genericKickers.length];
        var modeForLink = fallback ? gender : requestedMode;
        fragment.appendChild(v510MakeSection({mode:modeForLink,title:title,kicker:kicker,href:v510ModeHref(modeForLink,page)}, selected, page, labels, index));
      }
      mount.replaceChildren(fragment);
      mount.dataset.niloV510Ready = '1';
      page._niloDiscoveryHandles = reserved;
    }).catch(function(){
      /* Instant server rails remain visible if the catalogue feed ever fails. */
    });
  }


  /* ============================================================
     NILO V5.11 — STABLE LARGE-CATALOGUE DISCOVERY
     The V5.10 alternate-view feed was too dependent on Shopify's
     theme-view routing. V5.11 uses Shopify's public products JSON
     as the primary source and normal collection HTML only as a
     fallback. Four server-rendered rails remain visible instantly
     on product pages even if every network request fails.
     ============================================================ */

  function v511VisibleProductHandles(scope, reserved) {
    reserved = reserved || {};
    if (!scope) return reserved;
    scope.querySelectorAll('.nilo-product-card[data-nilo-product-handle], [data-nilo-product-handle].nilo-smart-item').forEach(function(node){
      var handle = productHandleFromNode(node);
      if (handle) reserved[handle] = true;
    });
    return reserved;
  }

  function v511SectionCopy(index, gender, crossCatalogue) {
    var ar = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
    var frKickers = ['SÉLECTION NILO','ENCORE À DÉCOUVRIR','TENDANCE MAINTENANT','CONTINUE TON SHOPPING','GRAND CATALOGUE','NOUVELLES IDÉES','À AJOUTER AU PANIER','PETITS PRIX & LOOKS','CHOISI POUR TOI','LE CATALOGUE CONTINUE'];
    var frTitles = [
      'Encore plus de choix pour toi','Continue de découvrir','Des pièces à ajouter à ton look',
      'Nilo a encore plein d’idées','Encore plus de nouveautés','Découvre la suite du catalogue',
      'Des looks à ne pas manquer','Toujours plus de choix','Encore des pièces à découvrir',
      'Le shopping continue ici','Des idées pour compléter ton panier','Une autre sélection Nilo',
      'Encore plus de mode à découvrir','Fais défiler, il y en a encore','Des nouveautés pour ton prochain look'
    ];
    var arKickers = ['اختيارات نيلو','اكتشفي أكثر','موضة الآن','كملي التسوق','كتالوج كبير','أفكار جديدة'];
    var arTitles = ['مزيد من الاختيارات لك','كملي اكتشاف نيلو','قطع أخرى لإطلالتك','الكتالوج ما زال مستمراً','اختيارات جديدة من نيلو','مزيد من الموضة'];
    if (crossCatalogue) {
      var frSuffixes = ['', ' · sélection du moment', ' · nouveaux coups de cœur', ' · idées à ajouter au panier'];
      var arSuffixes = ['', ' · اختيارات اللحظة', ' · اختيارات جديدة', ' · أفكار إضافية'];
      return ar ?
        { kicker: arKickers[index % arKickers.length], title: arTitles[index % arTitles.length] + arSuffixes[Math.floor(index / arTitles.length) % arSuffixes.length] } :
        { kicker: frKickers[index % frKickers.length], title: frTitles[index % frTitles.length] + frSuffixes[Math.floor(index / frTitles.length) % frSuffixes.length] };
    }
    return ar ?
      { kicker: arKickers[index % arKickers.length], title: arTitles[index % arTitles.length] } :
      { kicker: frKickers[index % frKickers.length], title: frTitles[index % frTitles.length] };
  }

  function v511SectionFromProducts(spec, products, contextNode, index) {
    var section = document.createElement('section');
    section.className = 'nilo-smart-section is-ready is-visible nilo-v511-section';
    section.dataset.niloV511Index = String(index);
    section.dataset.niloSmartMode = spec.mode || 'all';

    var header = document.createElement('header');
    header.className = 'nilo-app-heading';
    var copy = document.createElement('div');
    var small = document.createElement('small');
    small.textContent = spec.kicker || '';
    var title = document.createElement('h2');
    title.textContent = spec.title || '';
    copy.appendChild(small);
    copy.appendChild(title);

    var all = document.createElement('a');
    all.href = spec.href || (discoveryRootUrl() + 'collections/all');
    all.textContent = ((document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0 ? 'شوف الكل' : 'Voir tout') + ' ›';
    header.appendChild(copy);
    header.appendChild(all);

    var rail = document.createElement('div');
    rail.className = 'nilo-smart-rail';
    rail.dataset.niloSmartRail = '';
    rail.dataset.niloDisplayLimit = String(products.length);

    products.forEach(function(product){
      var card = makeJsonProductCard(product, contextNode);
      if (!card) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'nilo-smart-item';
      wrapper.dataset.niloProductHandle = product.handle;
      wrapper.appendChild(card);
      rail.appendChild(wrapper);
    });

    if (rail.children.length < 2) return null;
    section.appendChild(header);
    section.appendChild(rail);
    return section;
  }

  function v511LoadHtmlCatalogueCards() {
    var root = discoveryRootUrl();
    var pages = [];
    for (var i = 1; i <= 6; i += 1) pages.push(i);
    return Promise.all(pages.map(function(pageNumber){
      var url = root + 'collections/all' + (pageNumber > 1 ? ('?page=' + pageNumber) : '');
      return fetch(url, {credentials:'same-origin', headers:{Accept:'text/html','X-Requested-With':'NiloV511Fallback'}})
        .then(function(response){ return response.ok ? response.text() : ''; })
        .then(function(html){
          if (!html) return [];
          var doc = new DOMParser().parseFromString(html,'text/html');
          var host = doc.querySelector('[data-nilo-collection-page] [data-nilo-infinite-items]') ||
            doc.querySelector('[data-nilo-infinite-items]');
          if (!host) return [];
          return Array.prototype.slice.call(host.querySelectorAll(':scope > .nilo-product-card')).filter(function(card){
            var handle = productHandleFromNode(card);
            var img = card.querySelector('.nilo-product-card__media img');
            return !!(handle && img && (img.getAttribute('src') || img.getAttribute('srcset')));
          });
        }).catch(function(){ return []; });
    })).then(function(groups){
      var seen = {}, cards = [];
      (groups || []).forEach(function(group){
        (group || []).forEach(function(card){
          var handle = productHandleFromNode(card);
          if (!handle || seen[handle]) return;
          seen[handle] = true;
          cards.push(card);
        });
      });
      return cards;
    }).catch(function(){ return []; });
  }

  function v511BuildFromHtmlCards(page, cards, reserved) {
    cards = window.NiloPricePriorityV51380.cards(v512SeededShuffle(cards || [], 'product-html-fallback-' + String(page && page.dataset ? page.dataset.productHandle || '' : '')));
    var mount = page.querySelector('[data-nilo-v511-endless]');
    if (!mount || !cards || cards.length < 2) return 0;
    var gender = String(page.dataset.niloProductGender || 'women');
    var currentHandle = String(page.dataset.productHandle || '');
    var labels = v510LabelPack(gender);
    var modes = v510ModeSequence(gender, page);
    var fragment = document.createDocumentFragment();
    var built = 0;
    var perSection = 4;
    var usedTitles = {};

    function take(predicate, count) {
      var out = [];
      for (var i=0; i<cards.length && out.length<count; i+=1) {
        var card = cards[i];
        var handle = productHandleFromNode(card);
        if (!handle || handle === currentHandle || reserved[handle]) continue;
        if (!predicate(card)) continue;
        reserved[handle] = true;
        out.push(card);
      }
      return out;
    }

    for (var index=0; index<60; index+=1) {
      var requested = modes[index % modes.length] || gender;
      var selected = take(function(card){
        return v510CardGender(card) === gender && smartCardMatchesMode(card, requested);
      }, perSection);
      var specificCount = selected.length;
      if (selected.length < perSection) {
        selected = selected.concat(take(function(card){ return v510CardGender(card) === gender; }, perSection - selected.length));
      }
      var cross = false;
      if (selected.length < perSection) {
        cross = true;
        selected = selected.concat(take(function(){ return true; }, perSection - selected.length));
      }
      if (selected.length < 2) break;

      var generic = v511SectionCopy(index, gender, cross || specificCount < 2);
      var title = (!cross && specificCount >= 2 && labels.modeTitles[requested]) ? labels.modeTitles[requested] : generic.title;
      title = v512UniqueSectionTitle(title, usedTitles);
      var kicker = generic.kicker;
      var section = v510MakeSection({
        mode: (!cross && specificCount >= 2) ? requested : gender,
        title: title,
        kicker: kicker,
        href: (!cross && specificCount >= 2) ? v510ModeHref(requested, page) : (discoveryRootUrl() + 'collections/all')
      }, selected, page, labels, index);
      section.classList.add('nilo-v511-section');
      fragment.appendChild(section);
      built += 1;
    }

    mount.replaceChildren(fragment);
    mount.dataset.niloV511Ready = '1';
    return built;
  }

  function initV511EndlessProductDiscovery(page) {
    if (!page || page.dataset.niloV511Started === '1') return;
    page.dataset.niloV511Started = '1';
    var mount = page.querySelector('[data-nilo-v511-endless]');
    if (!mount) return;

    var currentHandle = String(page.dataset.productHandle || '');
    var gender = String(page.dataset.niloProductGender || 'women');
    var reserved = {};
    if (currentHandle) reserved[currentHandle] = true;
    v511VisibleProductHandles(page.querySelector('[data-nilo-v511-instant-stack]'), reserved);
    page._niloDiscoveryHandles = reserved;

    loadNiloProductCatalogue().then(function(catalogue){
      if (!catalogue || catalogue.length < 2) throw new Error('catalogue-json-empty');

      /* Put the current visitor's universe first, then use the rest of the Nilo
         catalogue under clearly generic headings. This guarantees a long page
         without lying about a category and without recycling handles. */
      var current = window.NiloPricePriorityV51380.products(v512SeededShuffle(catalogue.filter(function(product){ return product.handle !== currentHandle; }), 'product-page-' + currentHandle));
      var genderPool = current.filter(function(product){ return jsonProductGender(product) === gender; });
      var otherPool = current.filter(function(product){ return jsonProductGender(product) !== gender; });
      var ordered = genderPool.concat(otherPool);
      var labels = v510LabelPack(gender);
      var modes = v510ModeSequence(gender, page);
      var fragment = document.createDocumentFragment();
      var cardsPerSection = 4;
      var targetSections = 20;
      var built = 0;
      var usedTitles = {};

      function takeFrom(pool, predicate, count) {
        var selected = [];
        for (var i=0; i<pool.length && selected.length<count; i+=1) {
          var product = pool[i];
          if (!product || !product.handle || reserved[product.handle]) continue;
          if (!predicate(product)) continue;
          reserved[product.handle] = true;
          selected.push(product);
        }
        return selected;
      }

      for (var index=0; index<targetSections; index+=1) {
        var requested = modes[index % modes.length] || gender;
        var selected = takeFrom(genderPool, function(product){
          return jsonProductMatchesMode(product, requested, gender);
        }, cardsPerSection);
        var specificCount = selected.length;

        if (selected.length < cardsPerSection) {
          selected = selected.concat(takeFrom(genderPool, function(){ return true; }, cardsPerSection - selected.length));
        }

        var usedCrossCatalogue = false;
        if (selected.length < cardsPerSection) {
          usedCrossCatalogue = true;
          selected = selected.concat(takeFrom(otherPool, function(){ return true; }, cardsPerSection - selected.length));
        }

        if (selected.length < 2) break;

        var generic = v511SectionCopy(index, gender, usedCrossCatalogue || specificCount < 2);
        var modeTitle = labels.modeTitles && labels.modeTitles[requested];
        var title = (!usedCrossCatalogue && specificCount >= 2 && modeTitle) ? modeTitle : generic.title;
        title = v512UniqueSectionTitle(title, usedTitles);
        var href = (!usedCrossCatalogue && specificCount >= 2) ? v510ModeHref(requested, page) : (discoveryRootUrl() + 'collections/all');
        var section = v511SectionFromProducts({
          mode: (!usedCrossCatalogue && specificCount >= 2) ? requested : 'all',
          title: title,
          kicker: generic.kicker,
          href: href
        }, selected, page, index);
        if (!section) break;
        fragment.appendChild(section);
        built += 1;
      }

      if (built) {
        mount.replaceChildren(fragment);
        mount.dataset.niloV511Ready = '1';
        page._niloDiscoveryHandles = reserved;
      } else {
        throw new Error('no-v511-sections');
      }
    }).catch(function(){
      /* Last safety net: normal collection HTML. The four instant Liquid rails
         remain on screen even if this fallback also fails. */
      v511LoadHtmlCatalogueCards().then(function(cards){
        v511BuildFromHtmlCards(page, cards, reserved);
      });
    });
  }

  function initV511StableSmartSections() {
    var productPage = document.querySelector('[data-nilo-product-page]');
    var sections = Array.prototype.slice.call(document.querySelectorAll('[data-nilo-smart-section][data-nilo-js-discovery="true"]')).filter(function(section){
      return !productPage || !productPage.contains(section);
    });
    if (!sections.length) return;

    var reserved = {};
    /* Avoid recycling products already visible in the main grid, hero rails or
       other non-smart catalogue blocks on the same page. */
    document.querySelectorAll('.nilo-product-card').forEach(function(card){
      if (card.closest('[data-nilo-smart-section]')) return;
      if (productPage && productPage.contains(card)) return;
      var handle = productHandleFromNode(card);
      if (handle) reserved[handle] = true;
    });
    /* First pass is synchronous: never leave an empty heading visible. Keep
       already-filled server rails stable; hide the empty ones immediately. */
    sections.forEach(function(section){
      var rail = section.querySelector('[data-nilo-smart-rail]');
      var items = rail ? Array.prototype.slice.call(rail.querySelectorAll(':scope > .nilo-smart-item')) : [];
      var valid = items.filter(function(item){
        var card = item.querySelector('.nilo-product-card');
        var img = card && card.querySelector('.nilo-product-card__media img');
        return !!(productHandleFromNode(item) && img && (img.getAttribute('src') || img.getAttribute('srcset')));
      });
      if (valid.length >= 2) {
        section.hidden = false;
        section.classList.add('is-ready','is-visible');
        valid.forEach(function(item){ var h=productHandleFromNode(item); if(h) reserved[h]=true; });
      } else {
        section.hidden = true;
        section.classList.remove('is-ready','is-visible');
      }
    });

    loadNiloProductCatalogue().then(function(catalogue){
      if (!catalogue || catalogue.length < 2) return;
      sections.forEach(function(section, sectionIndex){
        var rail = section.querySelector('[data-nilo-smart-rail]');
        if (!rail) return;
        var currentCount = rail.querySelectorAll(':scope > .nilo-smart-item').length;
        if (!section.hidden && currentCount >= 2) return;

        var mode = String(section.dataset.niloSmartMode || '');
        var target = Math.max(6, Math.min(10, Number(section.dataset.niloTargetCount || 8)));
        var selected = [];
        var rotatedCatalogue = window.NiloPricePriorityV51380.products(v512SeededShuffle(catalogue, 'smart-section-' + sectionIndex + '-' + mode));
        for (var i=0; i<rotatedCatalogue.length && selected.length<target; i+=1) {
          var product = rotatedCatalogue[i];
          if (!product || !product.handle || reserved[product.handle]) continue;
          if (!jsonProductMatchesMode(product, mode, '')) continue;
          reserved[product.handle] = true;
          selected.push(product);
        }

        if (selected.length < 2) {
          /* A category that truly has no products disappears completely instead
             of showing an empty title. We never fill "Chaussures" with a dress. */
          section.hidden = true;
          section.classList.remove('is-ready','is-visible');
          return;
        }

        rail.replaceChildren();
        selected.forEach(function(product){
          var card = makeJsonProductCard(product, document.body);
          if (!card) return;
          var wrapper = document.createElement('div');
          wrapper.className = 'nilo-smart-item';
          wrapper.dataset.niloProductHandle = product.handle;
          wrapper.appendChild(card);
          rail.appendChild(wrapper);
        });
        section.hidden = rail.children.length < 2;
        if (!section.hidden) section.classList.add('is-ready','is-visible');
      });
    }).catch(function(){ /* server sections remain stable */ });
  }

  function initV511HomeEndless() {
    var home = document.querySelector('[data-nilo-app-home]');
    var mount = home && home.querySelector('[data-nilo-v511-home-endless]');
    if (!home || !mount || mount.dataset.niloV511Started === '1') return;
    mount.dataset.niloV511Started = '1';

    loadNiloProductCatalogue().then(function(catalogue){
      if (!catalogue || catalogue.length < 20) return;
      catalogue = window.NiloPricePriorityV51380.products(v512SeededShuffle(catalogue, 'home-endless'));
      var reserved = {};
      v511VisibleProductHandles(home, reserved);
      var modes = ['new','sale','under200','dress','set','abaya','pyjama_home','bag','shoe','jellaba','hijab','sport_set','swim','accessory','caftan','takchita','women'];
      var labels = v510LabelPack('women');
      var fragment = document.createDocumentFragment();
      var built = 0;
      var usedTitles = {};

      for (var index=0; index<8; index+=1) {
        var mode = modes[index % modes.length];
        var selected = [];
        for (var i=0; i<catalogue.length && selected.length<4; i+=1) {
          var product = catalogue[i];
          if (!product || !product.handle || reserved[product.handle]) continue;
          if (!jsonProductMatchesMode(product, mode, '')) continue;
          reserved[product.handle] = true;
          selected.push(product);
        }
        var specificCount = selected.length;
        if (selected.length < 4) {
          for (var j=0; j<catalogue.length && selected.length<4; j+=1) {
            var fallback = catalogue[j];
            if (!fallback || !fallback.handle || reserved[fallback.handle]) continue;
            reserved[fallback.handle] = true;
            selected.push(fallback);
          }
        }
        if (selected.length < 2) break;
        var generic = v511SectionCopy(index, 'women', specificCount < 2);
        var title = specificCount >= 2 && labels.modeTitles[mode] ? labels.modeTitles[mode] : generic.title;
        title = v512UniqueSectionTitle(title, usedTitles);
        var section = v511SectionFromProducts({
          mode: specificCount >= 2 ? mode : 'all',
          title: title,
          kicker: generic.kicker,
          href: specificCount >= 2 ? v510ModeHref(mode, home) : (discoveryRootUrl() + 'collections/all')
        }, selected, home, index);
        if (!section) break;
        fragment.appendChild(section);
        built += 1;
      }

      if (built) {
        mount.replaceChildren(fragment);
        mount.dataset.niloV511Ready = '1';
      }
    }).catch(function(){ /* Home already has server content. */ });
  }


  function initV512HomeRotation() {
    var home = document.querySelector('[data-nilo-app-home]');
    if (!home || home.dataset.niloV512RotationStarted === '1') return;
    home.dataset.niloV512RotationStarted = '1';

    /* Supplement the rotating catalogue with real Shopify collections.
       Otherwise a daily window of mostly cloned abayas can dominate the home. */
    var root=discoveryRootUrl();
    var pools=['ensembles','robes','chemises','jupes'];
    var fashionRequests=pools.map(function(handle){
      return fetch(root+'collections/'+handle+'/products.json?limit=80&sort_by=price-ascending',{
        credentials:'same-origin',headers:{Accept:'application/json'}
      }).then(function(r){return r.ok?r.json():null;}).then(function(data){
        return data&&Array.isArray(data.products)?data.products:[];
      }).catch(function(){return [];});
    });
    Promise.all([loadNiloProductCatalogue()].concat(fashionRequests)).then(function(groups){
      var catalogue=[],seen={};
      groups.forEach(function(list){(list||[]).forEach(function(p){
        if(!p||!p.handle||seen[p.handle]||!jsonProductAvailable(p)||!jsonProductImage(p))return;
        seen[p.handle]=true;catalogue.push(p);
      });});
      if (catalogue.length < 20) return;
      catalogue = window.NiloClothingPriorityV51381.products(v512SeededShuffle(catalogue, 'home-master'),'all');
      var reserved = {};
      var categoryReserved = {};

      /* V5.13: rotate BOTH the popular-category identities/order and their
         product imagery from the full catalogue on every true refresh. */
      v513RotatePopularCategories(home, catalogue);

      /* Hero: three different product images on every refresh. Links/copy remain
         editorial, only the visual product changes. */
      var heroSlides = Array.prototype.slice.call(home.querySelectorAll('[data-nilo-home-hero-slide]'));
      var heroProducts = v512PickProducts(catalogue, 'women', heroSlides.length, reserved, 'hero', '');
      heroSlides.forEach(function(slide, index){
        var product = heroProducts[index];
        var img = slide.querySelector('img');
        if (product && img) {
          v512ApplyImage(img, product, product.title, 900);
          slide.dataset.niloRotatedHandle = product.handle;
        }
      });

      /* Primary featured zones (new/deals) are rebuilt from the full catalogue. */
      home.querySelectorAll('[data-nilo-home-zone]').forEach(function(zone, index){
        var mode = String(zone.dataset.niloHomeZone || 'women');
        var existingCount = zone.querySelectorAll(':scope > .nilo-product-card').length;
        var target = Math.max(6, existingCount || 8);
        var picked = v512PickProducts(catalogue, mode, target, reserved, 'zone-' + index + '-' + mode, '');
        if (picked.length < 2) return;
        var fragment = document.createDocumentFragment();
        picked.forEach(function(product){
          var card = makeJsonProductCard(product, home);
          if (card) fragment.appendChild(card);
        });
        if (fragment.childNodes.length >= 2) zone.replaceChildren(fragment);
      });

      /* The first 24 items of the infinite feed also rotate every refresh. The
         editorial inserts stay exactly where Liquid placed them. */
      var feed = document.querySelector('[data-nilo-home-feed]');
      if (feed) {
        var existingCards = Array.prototype.slice.call(feed.querySelectorAll(':scope > .nilo-product-card'));
        var feedProducts = v512PickProducts(catalogue, 'women', existingCards.length, reserved, 'home-feed', '');
        existingCards.forEach(function(card, index){
          var product = feedProducts[index];
          var replacement = product ? makeJsonProductCard(product, home) : null;
          if (replacement) card.replaceWith(replacement);
        });
      }

      home.dataset.niloV512Rotated = '1';
      window.__niloHomeV51347Catalogue = catalogue;
      window.dispatchEvent(new CustomEvent('nilo:home-catalogue-ready',{detail:{products:catalogue}}));
    }).catch(function(){ /* Server-rendered home remains fully usable. */ });
  }

  function initProduct() {
    var page = document.querySelector('[data-nilo-product-page]');
    if (!page) return;
    var gallery = page.querySelector('[data-nilo-product-gallery]');
    var galleryCurrent = page.querySelector('[data-nilo-gallery-current]');
    if (gallery && galleryCurrent) {
      /* V5.13.70 — gallery navigation in both LTR and RTL.
         RTL browsers commonly expose negative scrollLeft. Positive-only
         scrollTo targets in V5.13.69 could never move beyond image 1.
         Use element positions to avoid browser-specific RTL scroll models. */
      var galleryTimer;
      var thumbs = Array.prototype.slice.call(page.querySelectorAll('[data-nilo-thumbnail-index]'));
      function isRailRtl(rail) { return window.getComputedStyle(rail).direction === 'rtl'; }
      function goToGalleryImage(index) {
        var image = gallery.children[index];
        if (!image) return;
        var frame = gallery.getBoundingClientRect(), target = image.getBoundingClientRect();
        var delta = isRailRtl(gallery) ? target.right - frame.right : target.left - frame.left;
        gallery.scrollTo({ left: gallery.scrollLeft + delta, behavior: 'smooth' });
      }
      function currentGalleryIndex() {
        var frame = gallery.getBoundingClientRect(), rtl = isRailRtl(gallery);
        var closest = 0, distance = Infinity;
        Array.prototype.forEach.call(gallery.children, function (image, index) {
          var bounds = image.getBoundingClientRect();
          var gap = Math.abs(rtl ? bounds.right - frame.right : bounds.left - frame.left);
          if (gap < distance) { distance = gap; closest = index; }
        });
        return closest;
      }
      function keepThumbnailVisible(thumb) {
        var rail = thumb && thumb.parentElement;
        if (!rail) return;
        var frame = rail.getBoundingClientRect(), target = thumb.getBoundingClientRect();
        var space = 12, delta = 0;
        if (target.left < frame.left + space) delta = target.left - frame.left - space;
        else if (target.right > frame.right - space) delta = target.right - frame.right + space;
        if (Math.abs(delta) > 1) rail.scrollTo({ left: rail.scrollLeft + delta, behavior: 'smooth' });
      }
      function updateGalleryIndex(index) {
        var safeIndex = Math.max(0, Math.min(index, Math.max(0, gallery.children.length - 1)));
        galleryCurrent.textContent = safeIndex + 1;
        thumbs.forEach(function (thumb, thumbIndex) { thumb.classList.toggle('is-active', thumbIndex === safeIndex); });
        keepThumbnailVisible(thumbs[safeIndex]);
      }
      gallery.addEventListener('scroll', function () {
        window.clearTimeout(galleryTimer);
        galleryTimer = window.setTimeout(function () { updateGalleryIndex(currentGalleryIndex()); }, 70);
      }, { passive: true });
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var index = Number(thumb.dataset.niloThumbnailIndex || 0);
          goToGalleryImage(index);
          updateGalleryIndex(index);
        });
      });
    }

    var select = page.querySelector('[data-nilo-variant-select]');
    if (select) select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      if (!option || !option.value) return;
      var price = option.dataset.price || '';
      var compare = option.dataset.compare || '';
      page.querySelectorAll('[data-nilo-button-price], [data-nilo-sticky-price]').forEach(function (node) { node.textContent = price; });
      var priceBox = page.querySelector('[data-nilo-product-price]');
      if (priceBox) {
        priceBox.querySelector('strong').textContent = price;
        var oldPrice = priceBox.querySelector('s');
        oldPrice.textContent = compare;
        oldPrice.hidden = !compare;
      }
    });

    var variantsNode = page.querySelector('[data-nilo-variants-json]');
    var variants = [];
    if (variantsNode) {
      try { variants = JSON.parse(variantsNode.textContent); } catch (error) { variants = []; }
    }
    /* NILO V5.13.67 — Arabic option display, WITHOUT changing Shopify variant values/IDs. */
    function niloOptionNorm(value) {
      return String(value == null ? '' : value).normalize('NFKC').normalize('NFD')
        .replace(/[\u0300-\u036f\u064b-\u065f\u0670]/g, '')
        .replace(/[آأإ]/g, 'ا').replace(/ى/g, 'ي').replace(/ـ/g, '')
        .toLowerCase().replace(/\s+/g, ' ').trim();
    }
    function niloSizeCode(value) {
      var n = niloOptionNorm(value).replace(/[._-]/g, ' '), compact = n.replace(/\s/g, '').toUpperCase();
      if (/^(?:XXXXL|XXXL|XXL|XL|XS|XXS|S|M|L|4XL|5XL|6XL)$/.test(compact)) return compact;
      if (/^\d{2,3}$/.test(compact)) return compact; // Numeric apparel / footwear sizes unchanged.
      var lookup = {
        'اكس اس': 'XS', 'اكس اكس اس': 'XXS', 'اكس اس صغير': 'XS',
        'اس': 'S', 'صغير': 'S', 'مقاس صغير': 'S', 'سمول': 'S',
        'ام': 'M', 'م': 'M', 'متوسط': 'M', 'مقاس متوسط': 'M', 'ميديوم': 'M',
        'ال': 'L', 'ل': 'L', 'كبير': 'L', 'مقاس كبير': 'L', 'لارج': 'L',
        'اكس ال': 'XL', 'اكس ال كبير': 'XL', 'اكس ل': 'XL', 'اكسيل': 'XL', 'اكس لارج': 'XL',
        'اكس اكس ال': 'XXL', 'اكس اكس ل': 'XXL', 'مقاس كبير جدا': 'XXL', 'كبير جدا': 'XXL',
        'اكس اكس اكس ال': 'XXXL', 'اكس اكس اكس ل': 'XXXL', 'مقاس كبير جدا جدا': 'XXXL', 'كبير جدا جدا': 'XXXL',
        'extra large': 'XL', 'extra extra large': 'XXL', 'extra extra extra large': 'XXXL',
        'large': 'L', 'medium': 'M', 'small': 'S'
      };
      return lookup[n] || '';
    }
    function niloColorKey(value) {
      var n=niloOptionNorm(value), aliases={
        'noir':'black','اسود':'black','black':'black',
        'blanc':'white','ابيض':'white','white':'white',
        'beige':'beige','بيج':'beige',
        'marron':'brown','بني':'brown','brown':'brown',
        'gris':'gray','grey':'gray','gray':'gray','رمادي':'gray','رصاصي':'gray',
        'rouge':'red','red':'red','احمر':'red',
        'vert':'green','green':'green','اخضر':'green',
        'bleu':'blue','blue':'blue','ازرق':'blue',
        'bleu marine':'navy','marine':'navy','navy':'navy','كحلي':'navy','ازرق داكن':'navy',
        'bleu ciel':'sky blue','sky blue':'sky blue','سماوي':'sky blue','ازرق سماوي':'sky blue',
        'turquoise':'turquoise','فيروزي':'turquoise','تركواز':'turquoise','turquois':'turquoise',
        'rose':'pink','pink':'pink','وردي':'pink','زهري':'pink',
        'jaune':'yellow','yellow':'yellow','اصفر':'yellow',
        'orange':'orange','برتقالي':'orange',
        'violet':'purple','purple':'purple','بنفسجي':'purple','موف':'purple',
        'lilas':'lilac','ليلكي':'lilac','لافندر':'lavender','lavande':'lavender',
        'bordeaux':'burgundy','burgundy':'burgundy','بورغوندي':'burgundy','نبيتي':'burgundy','خمري':'burgundy',
        'kaki':'khaki','khaki':'khaki','كاكي':'khaki','زيتي':'olive','olive':'olive',
        'creme':'cream','cream':'cream','كريمي':'cream','سكري':'cream',
        'ecru':'ecru','اكرُو':'ecru','عاجي':'ivory','ivoire':'ivory',
        'camel':'camel','جملي':'camel',
        'dore':'gold','gold':'gold','ذهبي':'gold',
        'argente':'silver','silver':'silver','فضي':'silver'
      };
      return aliases[n] || n;
    }
    var niloOptionGroups = Array.prototype.slice.call(page.querySelectorAll('[data-nilo-option-group]'));
    function niloIsSizeGroup(group) {
      if (!group || group.hasAttribute('data-nilo-color-group')) return false;
      var label=niloOptionNorm((group.querySelector('legend') || {}).textContent || '');
      if (/(taille|size|pointure|مقاس|قياس|الحجم)/.test(label)) return true;
      var values=Array.prototype.map.call(group.querySelectorAll('[data-nilo-option-value]'),function(b){return niloSizeCode(b.dataset.niloOptionValue);});
      return values.length>0 && values.every(Boolean);
    }
    function niloSameOption(group, raw, selected) {
      if (String(raw)===String(selected)) return true;
      if (!group || !raw || !selected) return false;
      if (niloIsSizeGroup(group)) {
        var a=niloSizeCode(raw),b=niloSizeCode(selected);
        return !!(a && b && a===b);
      }
      if (group.hasAttribute('data-nilo-color-group')) return niloColorKey(raw)===niloColorKey(selected);
      return false;
    }
    if (/^(?:ar)(?:-|$)/i.test(document.documentElement.lang || '') || document.documentElement.dir==='rtl') {
      niloOptionGroups.forEach(function(group){
        if (!niloIsSizeGroup(group)) return;
        group.querySelectorAll('[data-nilo-option-value]').forEach(function(button){
          var label=niloSizeCode(button.dataset.niloOptionValue);
          if (!label) return; // Never overwrite an unknown, potentially non-size value.
          button.textContent=label;
          button.setAttribute('dir','ltr');
          button.setAttribute('aria-label',label);
        });
      });
    }
    function selectedProductOptions(){
      return Array.prototype.map.call(page.querySelectorAll('[data-nilo-option-group]'), function(group){
        var active=group.querySelector('[data-nilo-option-value][aria-pressed="true"]');
        return active ? active.dataset.niloOptionValue : '';
      });
    }
    function refreshProductOptionAvailability(){
      var selected=selectedProductOptions();
      page.querySelectorAll('[data-nilo-option-group]').forEach(function(group,groupIndex){
        group.querySelectorAll('[data-nilo-option-value]').forEach(function(button){
          var candidate=button.dataset.niloOptionValue;
          var possible=variants.some(function(v){
            if(!v.available || !niloSameOption(group,v.options[groupIndex],candidate)) return false;
            return selected.every(function(value,index){return index===groupIndex || !value || niloSameOption(niloOptionGroups[index],v.options[index],value);});
          });
          button.disabled=!possible;
          button.classList.toggle('is-unavailable',!possible);
          if(!possible && button.getAttribute('aria-pressed')==='true') button.setAttribute('aria-pressed','false');
        });
      });
      selected=selectedProductOptions();
      var complete=selected.length>0 && selected.every(Boolean);
      var variant=complete ? variants.find(function(candidate){return candidate.available&&candidate.options.every(function(option,index){return niloSameOption(niloOptionGroups[index],option,selected[index]);});}) : null;
      if(select){select.value=variant?String(variant.id):'';if(variant)select.dispatchEvent(new Event('change',{bubbles:true}));}
      var anyAvailable=variants.some(function(candidate){return candidate.available;});
      page.querySelectorAll('.nilo-product-form button[type="submit"], button[type="submit"][form="NiloProductForm"]').forEach(function(button){
        button.disabled=!anyAvailable;
        button.classList.toggle('nilo-needs-selection',anyAvailable&&!variant);
      });
      return variant;
    }
    page.querySelectorAll('[data-nilo-option-value]').forEach(function (pill) {
      pill.setAttribute('aria-pressed','false');
      pill.addEventListener('click', function () {
        if(pill.disabled)return;
        var group = pill.closest('[data-nilo-option-group]');
        group.querySelectorAll('[data-nilo-option-value]').forEach(function (button) { button.setAttribute('aria-pressed', 'false'); });
        pill.setAttribute('aria-pressed', 'true');
        group.classList.remove('is-required');
        var chosenVariant=refreshProductOptionAvailability();
        var msg=form&&form.querySelector('[data-nilo-product-selection-message]');
        if(chosenVariant&&msg)msg.classList.remove('is-visible');
      });
    });
    if(variants.length) refreshProductOptionAvailability();

    var form = page.querySelector('.nilo-product-form');
    if(form) form.setAttribute('novalidate','novalidate');
    if (form) form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      var requiredSelect=form.querySelector('[data-nilo-variant-select]');
      if(requiredSelect && !requiredSelect.value){
        var groups=Array.prototype.slice.call(form.querySelectorAll('[data-nilo-option-group]'));
        groups.forEach(function(group){var chosen=group.querySelector('[data-nilo-option-value][aria-pressed="true"]');group.classList.toggle('is-required',!chosen);});
        var optionsBox=form.querySelector('.nilo-product-form__variants');
        if(optionsBox){optionsBox.classList.remove('nilo-selection-required');void optionsBox.offsetWidth;optionsBox.classList.add('nilo-selection-required');}
        var msg=form.querySelector('[data-nilo-product-selection-message]');
        if(!msg){msg=document.createElement('p');msg.className='nilo-product-selection-message';msg.dataset.niloProductSelectionMessage='';optionsBox&&optionsBox.appendChild(msg);}
        if(msg){msg.textContent=(document.documentElement.lang||'').toLowerCase().indexOf('ar')===0?'خاصك تختار المقاس واللون قبل ما تزيد المنتج للسلة':'Vous devez d’abord sélectionner la taille et la couleur.';msg.classList.add('is-visible');}
        var firstMissing=groups.find(function(group){return !group.querySelector('[data-nilo-option-value][aria-pressed="true"]');});
        if(firstMissing)firstMissing.scrollIntoView({behavior:'smooth',block:'center'});
        return;
      }
      var submitter = event.submitter || document.activeElement;
      var buyNow = submitter && submitter.hasAttribute('data-nilo-buy-now');
      var buttons = page.querySelectorAll('.nilo-product-form button[type="submit"], button[type="submit"][form="NiloProductForm"]');
      buttons.forEach(function (button) { button.disabled = true; });
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (response) { if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Erreur'); }); return response.json(); })
        .then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          updateCartBadges(cart.item_count);
          try { localStorage.setItem('nilo_cart_deadline', String(Date.now() + 600000)); } catch (error) { /* optional storage */ }
          niloPersonalTrackFromNode(page, 9, 'add_cart', 15000);
          if (buyNow) { window.location.href = root + 'cart'; return; }
          toast(document.documentElement.lang.indexOf('ar') === 0 ? 'أضيف إلى السلة ✓' : 'Ajouté au panier ✓');
        })
        .catch(function (error) { toast(error.message); })
        .finally(function () { buttons.forEach(function (button) { button.disabled = false; }); });
    });

    var mainAction=page.querySelector('.nilo-product-form__actions');
    var stickyAction=page.querySelector('.nilo-product-sticky');
    if(mainAction&&stickyAction&&'IntersectionObserver' in window){
      var stickyObserver=new IntersectionObserver(function(entries){entries.forEach(function(entry){stickyAction.classList.toggle('is-main-action-visible',entry.isIntersecting&&entry.intersectionRatio>.25);});},{threshold:[0,.25,.6]});
      stickyObserver.observe(mainAction);
    }
    var stickyQuick=stickyAction&&stickyAction.querySelector('[data-nilo-quick-add]');
    if(stickyQuick&&!stickyQuick.dataset.niloStickyBound){
      stickyQuick.dataset.niloStickyBound='1';
      stickyQuick.addEventListener('click',function(event){
        event.preventDefault();event.stopPropagation();
        var handle=stickyQuick.dataset.niloQuickAddHandle||page.dataset.productHandle;
        if(handle)openQuickAdd(handle,stickyQuick);
      });
    }

    var currentHandle = page.dataset.productHandle;
    var recentSection = page.querySelector('[data-nilo-recently-viewed]');
    var recentHost = page.querySelector('[data-nilo-recent-items]');
    try {
      var recent = JSON.parse(localStorage.getItem('nilo_recent_products') || '[]').filter(function (handle) { return handle !== currentHandle; }).slice(0, 6);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (recent.length && recentSection && recentHost) {
        Promise.all(recent.map(function (handle) {
          return fetch(root + 'products/' + encodeURIComponent(handle) + '.js').then(function (response) { return response.ok ? response.json() : null; }).catch(function () { return null; });
        })).then(function (products) {
          products.filter(Boolean).forEach(function (product) {
            if (page._niloDiscoveryHandles && page._niloDiscoveryHandles[product.handle]) return;
            if (page._niloDiscoveryHandles) page._niloDiscoveryHandles[product.handle] = true;
            var card = document.createElement('a');
            card.dataset.niloProductHandle = product.handle;
            card.className = 'nilo-recent-card';
            card.href = root + 'products/' + product.handle;
            var image = document.createElement('img');
            image.loading = 'lazy'; image.alt = product.title; image.src = product.featured_image || '';
            var title = document.createElement('span'); title.textContent = product.title;
            var price = document.createElement('b'); price.textContent = Math.round(product.price / 100) + ' DH';
            card.appendChild(image); card.appendChild(title); card.appendChild(price); recentHost.appendChild(card);
          });
          dedupeCatalogue(page);
          if (recentHost.children.length) recentSection.hidden = false;
        });
      }
      localStorage.setItem('nilo_recent_products', JSON.stringify([currentHandle].concat(recent).slice(0, 8)));
    } catch (error) { /* Storage can be unavailable in private browsing. */ }

    if (!page.querySelector('[data-nilo-v51345-recommendations]')) initV511EndlessProductDiscovery(page);
  }


  function initSmartSearchRouting() {
    var route = document.querySelector('[data-nilo-smart-search-route]');
    if (route && route.dataset.niloSmartSearchRoute) {
      window.location.replace(route.dataset.niloSmartSearchRoute);
      return;
    }

    var params;
    try { params = new URLSearchParams(window.location.search); } catch (error) { return; }
    var originalTerm = params.get('nilo_search');
    if (!originalTerm) return;

    document.querySelectorAll('[data-nilo-predictive-search] input[type="search"]').forEach(function (input) {
      if (!input.value) input.value = originalTerm;
    });
  }

  function initQuantities() {
    document.addEventListener('click', function (event) {
      var plus = event.target.closest('[data-quantity-plus]');
      var minus = event.target.closest('[data-quantity-minus]');
      if (!plus && !minus) return;
      var box = event.target.closest('[data-nilo-quantity]');
      var input = box && box.querySelector('input');
      if (!input) return;
      var value = Number(input.value || 0) + (plus ? 1 : -1);
      input.value = Math.max(Number(input.min || 0), value);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    var cartForm = document.querySelector('[data-nilo-cart-form]');
    if (cartForm) {
      var cartTimer;
      cartForm.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
        input.addEventListener('change', function () {
          window.clearTimeout(cartTimer);
          cartTimer = window.setTimeout(function () { cartForm.requestSubmit(); }, 500);
        });
      });
    }
  }

  function initSort() {
    document.querySelectorAll('[data-nilo-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () { select.form.submit(); });
    });
  }

  function initCollectionFilters() {
    document.querySelectorAll('[data-nilo-filter-toggle]').forEach(function (button) {
      var drawer = document.querySelector(button.getAttribute('data-nilo-filter-toggle'));
      if (!drawer) return;

      function openDrawer() {
        drawer.hidden = false;
        document.body.classList.add('nilo-drawer-open');
        var firstClose = drawer.querySelector('[data-nilo-filter-close]');
        if (firstClose) firstClose.focus({ preventScroll: true });
      }

      function closeDrawer() {
        drawer.hidden = true;
        document.body.classList.remove('nilo-drawer-open');
        button.focus({ preventScroll: true });
      }

      button.addEventListener('click', openDrawer);
      drawer.querySelectorAll('[data-nilo-filter-close]').forEach(function (close) { close.addEventListener('click', closeDrawer); });
      drawer.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeDrawer(); });
    });

    document.querySelectorAll('[data-nilo-filter-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        form.querySelectorAll('input[type="number"]').forEach(function (input) {
          if (input.value === '') input.disabled = true;
        });
      });
    });
  }

  function initCollectionQuickFilters() {
    document.querySelectorAll('[data-nilo-quick-filters]').forEach(function (nav) {
      var url;
      try { url = new URL(window.location.href); } catch (error) { return; }
      var params = url.searchParams;

      function go(nextParams) {
        nextParams.delete('page');
        var query = nextParams.toString();
        window.location.href = window.location.pathname + (query ? '?' + query : '');
      }

      function clearShopifyFilters(nextParams) {
        Array.from(nextParams.keys()).forEach(function (key) {
          if (key.indexOf('filter.') === 0) nextParams.delete(key);
        });
      }

      nav.querySelectorAll('[data-nilo-sort-value]').forEach(function (button) {
        var value = button.dataset.niloSortValue;
        if (params.get('sort_by') === value) button.classList.add('is-active');
        button.addEventListener('click', function () {
          var next = new URLSearchParams(params.toString());
          if (next.get('sort_by') === value) next.delete('sort_by');
          else next.set('sort_by', value);
          go(next);
        });
      });

      nav.querySelectorAll('[data-nilo-price-max]').forEach(function (button) {
        var value = String(button.dataset.niloPriceMax || '');
        var paramName = button.dataset.niloPriceParam || 'filter.v.price.lte';
        if (params.get(paramName) === value || Number(params.get(paramName)) === Number(value)) button.classList.add('is-active');
        button.addEventListener('click', function () {
          var next = new URLSearchParams(params.toString());
          if (Number(next.get(paramName)) === Number(value)) next.delete(paramName);
          else next.set(paramName, value);
          go(next);
        });
      });

      var reset = nav.querySelector('[data-nilo-filter-reset]');
      if (reset) {
        var hasFilters = Array.from(params.keys()).some(function (key) { return key.indexOf('filter.') === 0; });
        if (!hasFilters && !params.get('sort_by')) reset.classList.add('is-active');
        reset.addEventListener('click', function () {
          var next = new URLSearchParams(params.toString());
          clearShopifyFilters(next);
          next.delete('sort_by');
          go(next);
        });
      }
    });
  }

  function initCartDeadline() {
    var host = document.querySelector('[data-nilo-cart-reservation]');
    if (!host) return;
    var output = host.querySelector('[data-nilo-cart-countdown]');
    if (!output) return;
    var deadline = 0;
    try { deadline = Number(localStorage.getItem('nilo_cart_deadline') || 0); } catch (error) { deadline = 0; }
    if (!deadline || deadline <= Date.now()) {
      deadline = Date.now() + 600000;
      try { localStorage.setItem('nilo_cart_deadline', String(deadline)); } catch (error) { /* optional storage */ }
    }
    function tick() {
      var remaining = Math.max(0, deadline - Date.now());
      var minutes = Math.floor(remaining / 60000);
      var seconds = Math.floor((remaining % 60000) / 1000);
      output.textContent = String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
      if (!remaining) { host.classList.add('is-expired'); window.clearInterval(host._niloTimer); }
    }
    tick();
    host._niloTimer = window.setInterval(tick, 1000);
  }

  /* ============================================================
     NILO V5.13.1 — FAVORIS LOCAUX, CATÉGORIES SÛRES ET DÉCOUVERTE
     Les favoris sont conservés sans compte sur ce navigateur. Les images de
     catégories sont hydratées uniquement avec de vrais produits disponibles.
     Les longues pages sont ajoutées progressivement, jamais au premier paint.
     ============================================================ */

  /* Nilo V5.13.5 — quick add from product cards */
  var niloQuickAddProduct=null;
  function quickAddRoot(){return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';}
  function ensureQuickAdd(){
    var existing=document.querySelector('[data-nilo-quick-add-drawer]');if(existing)return existing;
    var wrap=document.createElement('div');wrap.className='nilo-quick-add-drawer';wrap.dataset.niloQuickAddDrawer='';wrap.hidden=true;
    wrap.innerHTML='<div class="nilo-quick-add__backdrop" data-nilo-quick-add-close></div><section class="nilo-quick-add__sheet" role="dialog" aria-modal="true"><button class="nilo-quick-add__close" type="button" data-nilo-quick-add-close aria-label="Fermer">×</button><div class="nilo-quick-add__product"><img data-nilo-quick-add-image width="76" height="96" alt=""><div><small>AJOUT RAPIDE · أضف إلى السلة</small><strong data-nilo-quick-add-title></strong><b data-nilo-quick-add-price></b></div></div><div data-nilo-quick-add-options></div><button class="nilo-quick-add__submit" type="button" data-nilo-quick-add-submit disabled>AJOUTER AU PANIER <span>→</span><small>أضف إلى السلة</small></button><p data-nilo-quick-add-status></p></section>';
    document.body.appendChild(wrap);return wrap;
  }
  function productVariantOptions(v){if(Array.isArray(v.options))return v.options;var out=[];for(var i=1;i<=3;i++){if(v['option'+i])out.push(v['option'+i]);}return out;}
  function productOptionNames(p){return (p.options||[]).map(function(o,i){return typeof o==='string'?o:(o&&o.name)||('Option '+(i+1));});}
  function quickSelected(drawer){return Array.prototype.map.call(drawer.querySelectorAll('[data-nilo-qa-option]'),function(s){return s.value;});}
  function quickVariant(drawer){if(!niloQuickAddProduct)return null;var sel=quickSelected(drawer);return (niloQuickAddProduct.variants||[]).find(function(v){var opts=productVariantOptions(v);return v.available&&opts.length===sel.length&&opts.every(function(x,i){return x===sel[i];});});}
  function quickNameIsColor(name){var n=String(name||'').toLowerCase();return n.indexOf('couleur')>=0||n.indexOf('color')>=0||n.indexOf('colour')>=0||n.indexOf('لون')>=0;}
  function quickNameIsSize(name){var n=String(name||'').toLowerCase();return n.indexOf('taille')>=0||n.indexOf('size')>=0||n.indexOf('pointure')>=0||n.indexOf('مقاس')>=0;}
  function refreshQuickAdd(drawer){
    if(!niloQuickAddProduct)return;var variants=niloQuickAddProduct.variants||[],sels=Array.prototype.slice.call(drawer.querySelectorAll('[data-nilo-qa-option]')),current=sels.map(function(s){return s.value;});
    sels.forEach(function(sel,i){Array.prototype.slice.call(sel.options).forEach(function(opt){if(!opt.value){opt.disabled=false;return;}opt.disabled=!variants.some(function(v){var opts=productVariantOptions(v);return v.available&&opts[i]===opt.value&&current.every(function(c,j){return j===i||!c||opts[j]===c;});});});if(sel.value&&sel.selectedOptions[0]&&sel.selectedOptions[0].disabled)sel.value='';});
    drawer.querySelectorAll('[data-nilo-qa-swatch]').forEach(function(btn){var idx=Number(btn.dataset.optionIndex||0),sel=sels[idx],opt=sel&&Array.prototype.find.call(sel.options,function(o){return o.value===btn.dataset.value;});btn.disabled=!!(opt&&opt.disabled);btn.setAttribute('aria-pressed',sel&&sel.value===btn.dataset.value?'true':'false');});
    var v=quickVariant(drawer),submit=drawer.querySelector('[data-nilo-quick-add-submit]');if(submit)submit.disabled=!v;var price=drawer.querySelector('[data-nilo-quick-add-price]');if(price&&v)price.textContent=formatCentsDh(v.price);
  }
  function refreshCartPageSectionV51319(cart){
    var current=document.querySelector('#shopify-section-template-cart')||document.querySelector('.nilo-cart-v5-section');
    if(!current||!document.querySelector('[data-nilo-cart-page]'))return Promise.resolve(false);
    var url=quickAddRoot()+'cart?section_id=template-cart&_nilo='+Date.now();
    return fetch(url,{headers:{Accept:'text/html'}}).then(function(r){if(!r.ok)throw new Error('cart-section');return r.text();}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var incoming=doc.querySelector('#shopify-section-template-cart')||doc.querySelector('.nilo-cart-v5-section')||doc.body.firstElementChild;
      if(!incoming)throw new Error('cart-section-empty');
      current.replaceWith(incoming);
      initDeliveryEstimatesV5132();initSplitShipmentV5132();initV5136CartFloatingConfirm();
      try{window.dispatchEvent(new CustomEvent('nilo:cart-section-refreshed',{detail:{cart:cart||null}}));}catch(e){}
      return true;
    }).catch(function(){
      window.setTimeout(function(){window.location.reload();},80);return false;
    });
  }

  window.niloRefreshCartPageSectionV51320=refreshCartPageSectionV51319;

  function openQuickAdd(handle,sourceButton){
    var drawer=ensureQuickAdd();drawer.hidden=false;document.body.classList.add('nilo-quick-add-lock');drawer.querySelector('[data-nilo-quick-add-status]').textContent='Chargement…';
    fetch(quickAddRoot()+'products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'}}).then(function(r){if(!r.ok)throw new Error('Produit indisponible');return r.json();}).then(function(p){
      niloQuickAddProduct=p;drawer.querySelector('[data-nilo-quick-add-title]').textContent=p.title||'Nilo';var img=drawer.querySelector('[data-nilo-quick-add-image]');img.src=niloSizedImageUrl((p.featured_image&&((p.featured_image.src)||p.featured_image))||'',220);img.alt=p.title||'Nilo';drawer.querySelector('[data-nilo-quick-add-status]').textContent='';
      var available=(p.variants||[]).filter(function(v){return v.available;});if(!available.length)throw new Error('Produit momentanément indisponible');
      var names=productOptionNames(p),box=drawer.querySelector('[data-nilo-quick-add-options]');box.innerHTML='';
      var hasSize=names.some(quickNameIsSize);if(!hasSize){var standard=document.createElement('div');standard.className='nilo-quick-add__standard-size';standard.innerHTML='<span>Taille</span><b>STANDARD</b>';box.appendChild(standard);}
      var isDefault=available.length===1 && (!names.length || productVariantOptions(available[0]).every(function(x){return String(x).toLowerCase()==='default title';}));
      if(isDefault){drawer.querySelector('[data-nilo-quick-add-price]').textContent=formatCentsDh(available[0].price);drawer.querySelector('[data-nilo-quick-add-submit]').disabled=false;return;}
      names.forEach(function(name,i){var label=document.createElement('label');var color=quickNameIsColor(name);label.className='nilo-quick-add__option'+(color?' is-color':'');var title=document.createElement('span');title.textContent=name;var select=document.createElement('select');select.dataset.niloQaOption='';select.dataset.optionIndex=String(i);if(color){select.className='nilo-quick-add__color-source';select.setAttribute('aria-hidden','true');select.tabIndex=-1;}var ph=document.createElement('option');ph.value='';ph.textContent='Choisir / اختار';select.appendChild(ph);var seen={},values=[];available.forEach(function(v){var opts=productVariantOptions(v),val=opts[i];if(val&&!seen[val]){seen[val]=1;values.push(val);var o=document.createElement('option');o.value=val;o.textContent=val;select.appendChild(o);}});label.appendChild(title);label.appendChild(select);if(color){var sw=document.createElement('div');sw.className='nilo-quick-add__swatches';sw.setAttribute('role','group');sw.setAttribute('aria-label',name);values.forEach(function(val){var b=document.createElement('button');b.type='button';b.className='nilo-quick-add__swatch';b.dataset.niloQaSwatch='';b.dataset.optionIndex=String(i);b.dataset.value=val;b.setAttribute('aria-pressed','false');b.setAttribute('aria-label',name+' : '+val);var dot=document.createElement('i');dot.setAttribute('data-nilo-color-swatch',val);var txt=document.createElement('span');txt.textContent=val;b.appendChild(dot);b.appendChild(txt);sw.appendChild(b);});label.appendChild(sw);}box.appendChild(label);});if(window.__niloV51322InitSwatches)window.__niloV51322InitSwatches(drawer);refreshQuickAdd(drawer);
    }).catch(function(err){drawer.querySelector('[data-nilo-quick-add-status]').textContent=err.message||'Erreur';});
  }
  function addQuickVariant(drawer,button){
    var v=quickVariant(drawer);if(!v&&niloQuickAddProduct){var available=(niloQuickAddProduct.variants||[]).filter(function(x){return x.available;});if(available.length===1)v=available[0];}if(!v)return;
    button.disabled=true;button.classList.add('is-loading');fetch(quickAddRoot()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1}]})}).then(function(r){if(!r.ok)return r.json().then(function(b){throw new Error(b.description||'Erreur');});return r.json();}).then(function(){return fetch(quickAddRoot()+'cart.js',{headers:{Accept:'application/json'}});}).then(function(r){return r.json();}).then(function(cart){
      updateCartBadges(cart.item_count);try{localStorage.setItem('nilo_cart_deadline',String(Date.now()+600000));}catch(e){}if(niloQuickAddProduct){niloPersonalTrackProduct(niloQuickAddProduct,9,'add_cart',15000);}
      button.classList.remove('is-loading');button.classList.add('is-added');button.innerHTML='AJOUTÉ ✓ <small>أضيف إلى السلة</small>';toast((document.documentElement.lang||'').toLowerCase().indexOf('ar')===0?'أضيف إلى السلة ✓':'Ajouté au panier ✓');
      return refreshCartPageSectionV51319(cart).then(function(){return cart;});
    }).then(function(){setTimeout(function(){drawer.hidden=true;document.body.classList.remove('nilo-quick-add-lock');button.classList.remove('is-added');button.innerHTML='AJOUTER AU PANIER <span>→</span><small>أضف إلى السلة</small>';refreshQuickAdd(drawer);},420);}).catch(function(err){drawer.querySelector('[data-nilo-quick-add-status]').textContent=err.message||'Erreur';}).finally(function(){button.disabled=false;button.classList.remove('is-loading');});
  }
  document.addEventListener('click',function(event){
    var qa=event.target.closest&&event.target.closest('[data-nilo-quick-add]');if(qa){event.preventDefault();event.stopPropagation();openQuickAdd(qa.dataset.niloQuickAddHandle||qa.closest('[data-nilo-product-handle]').dataset.niloProductHandle,qa);return;}
    var swatch=event.target.closest&&event.target.closest('[data-nilo-qa-swatch]');if(swatch){event.preventDefault();var d=swatch.closest('[data-nilo-quick-add-drawer]'),sel=d&&d.querySelector('[data-nilo-qa-option][data-option-index="'+swatch.dataset.optionIndex+'"]');if(sel&&!swatch.disabled){sel.value=swatch.dataset.value;refreshQuickAdd(d);if(window.__niloV51322InitSwatches)window.__niloV51322InitSwatches(d);}return;}
    if(event.target.closest&&event.target.closest('[data-nilo-quick-add-close]')){var d=event.target.closest('[data-nilo-quick-add-drawer]');if(d){d.hidden=true;document.body.classList.remove('nilo-quick-add-lock');}return;}
    var submit=event.target.closest&&event.target.closest('[data-nilo-quick-add-submit]');if(submit){addQuickVariant(submit.closest('[data-nilo-quick-add-drawer]'),submit);return;}
  });
  document.addEventListener('change',function(event){if(event.target.matches&&event.target.matches('[data-nilo-qa-option]'))refreshQuickAdd(event.target.closest('[data-nilo-quick-add-drawer]'));});

  var NILO_WISHLIST_KEY = 'nilo_wishlist_v2';
  var NILO_WISHLIST_LEGACY_KEY = 'nilo_wishlist_v1';
  var NILO_WISHLIST_TTL = 45 * 24 * 60 * 60 * 1000;
  var niloWishlistItems = [];

  function readWishlist() {
    var parsed = [];
    try { parsed = JSON.parse(localStorage.getItem(NILO_WISHLIST_KEY) || '[]'); } catch (error) { parsed = []; }
    if (!Array.isArray(parsed) || !parsed.length) { try { parsed = JSON.parse(localStorage.getItem(NILO_WISHLIST_LEGACY_KEY) || '[]'); } catch (error) { parsed = []; } }
    if (!Array.isArray(parsed)) parsed = [];
    var seen = {}, now = Date.now();
    return parsed.map(function(item){
      if (typeof item === 'string') item = { handle: item, savedAt: now };
      if (!item || !item.handle) return null;
      var handle = String(item.handle).trim();
      if (!handle || seen[handle]) return null;
      var savedAt = Number(item.savedAt || now); if (!isFinite(savedAt) || savedAt <= 0) savedAt = now;
      if (now - savedAt > NILO_WISHLIST_TTL) return null;
      seen[handle] = true;
      return {
        handle: handle,
        title: String(item.title || 'Nilo'),
        url: String(item.url || (discoveryRootUrl() + 'products/' + encodeURIComponent(handle))),
        image: String(item.image || ''),
        price: Math.max(0, Number(item.price || 0)),
        compare: Math.max(0, Number(item.compare || 0)),
        savedAt: savedAt
      };
    }).filter(Boolean).slice(0, 100);
  }

  function writeWishlist() {
    try { localStorage.setItem(NILO_WISHLIST_KEY, JSON.stringify(niloWishlistItems)); localStorage.setItem(NILO_WISHLIST_LEGACY_KEY, JSON.stringify(niloWishlistItems)); } catch (error) { /* storage may be private */ }
  }

  function wishlistMap() {
    var map = {};
    niloWishlistItems.forEach(function(item){ map[item.handle] = true; });
    return map;
  }

  function syncWishlistButtons(scope) {
    var active = wishlistMap();
    var root = scope && scope.querySelectorAll ? scope : document;
    var buttons = [];
    if (root.matches && root.matches('[data-nilo-wishlist-toggle]')) buttons.push(root);
    root.querySelectorAll('[data-nilo-wishlist-toggle]').forEach(function(button){ buttons.push(button); });
    buttons.forEach(function(button){
      var selected = !!active[String(button.dataset.niloWishlistHandle || '')];
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  function syncWishlistUI(scope) {
    document.querySelectorAll('[data-nilo-wishlist-count]').forEach(function(node){
      node.textContent = String(niloWishlistItems.length);
      if (node.closest('.nilo-mobile-nav, .header_wishlist, .nilo-menu-shortcuts')) node.hidden = niloWishlistItems.length < 1;
      else node.hidden = false;
    });
    syncWishlistButtons(scope || document);
  }

  function wishlistItemFromButton(button) {
    return {
      handle: String(button.dataset.niloWishlistHandle || '').trim(),
      title: String(button.dataset.niloWishlistTitle || 'Nilo'),
      url: String(button.dataset.niloWishlistUrl || ''),
      image: String(button.dataset.niloWishlistImage || ''),
      price: Math.max(0, Number(button.dataset.niloWishlistPrice || 0)),
      compare: Math.max(0, Number(button.dataset.niloWishlistCompare || 0)),
      savedAt: Date.now()
    };
  }

  function wishlistStoredProduct(item) {
    var price = (Number(item.price || 0) / 100).toFixed(2);
    var compare = (Number(item.compare || 0) / 100).toFixed(2);
    return {
      handle: item.handle,
      title: item.title,
      image: item.image,
      tags: '',
      variants: [{ available: true, price: price, compare_at_price: compare }]
    };
  }

  function renderWishlistPage(catalogue) {
    var page = document.querySelector('[data-nilo-wishlist-page]');
    if (!page) return;
    var grid = page.querySelector('[data-nilo-wishlist-grid]');
    var empty = page.querySelector('[data-nilo-wishlist-empty]');
    if (!grid || !empty) return;
    var byHandle = {};
    (catalogue || []).forEach(function(product){ if (product && product.handle) byHandle[product.handle] = product; });
    var fragment = document.createDocumentFragment();
    niloWishlistItems.forEach(function(item){
      var product = byHandle[item.handle] || wishlistStoredProduct(item);
      var card = makeJsonProductCard(product, page);
      if (!card) return;
      card.classList.add('nilo-wishlist-card');
      fragment.appendChild(card);
    });
    grid.replaceChildren(fragment);
    empty.hidden = niloWishlistItems.length > 0;
    grid.hidden = niloWishlistItems.length < 1;
    syncWishlistUI(grid);
  }

  function initWishlist() {
    niloWishlistItems = readWishlist();
    syncWishlistUI(document);
    renderWishlistPage();

    document.addEventListener('click', function(event){
      var button = event.target.closest && event.target.closest('[data-nilo-wishlist-toggle]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      var item = wishlistItemFromButton(button);
      if (!item.handle) return;
      var index = niloWishlistItems.findIndex(function(entry){ return entry.handle === item.handle; });
      var added = index < 0;
      if (added) niloWishlistItems.unshift(item);
      else niloWishlistItems.splice(index, 1);
      writeWishlist();
      syncWishlistUI(document);
      renderWishlistPage();
      niloPersonalTrackFromNode(button.closest('[data-nilo-product-handle]') || button, added ? 8 : -2, added ? 'favorite' : 'unfavorite', 5000);
      toast(added ? (((document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0) ? 'تزاد للمفضلة' : 'Ajouté aux favoris') : (((document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0) ? 'تحيد من المفضلة' : 'Retiré des favoris'));
    });

    window.addEventListener('storage', function(event){
      if (event.key !== NILO_WISHLIST_KEY) return;
      niloWishlistItems = readWishlist();
      syncWishlistUI(document);
      renderWishlistPage();
    });

    var wishlistMutationRoots = [];
    var wishlistMutationScheduled = false;
    var observer = new MutationObserver(function(records){
      records.forEach(function(record){
        record.addedNodes.forEach(function(node){
          if (!node || node.nodeType !== 1) return;
          if ((node.matches && node.matches('[data-nilo-wishlist-toggle]')) || (node.querySelector && node.querySelector('[data-nilo-wishlist-toggle]'))) wishlistMutationRoots.push(node);
        });
      });
      if (!wishlistMutationRoots.length || wishlistMutationScheduled) return;
      wishlistMutationScheduled = true;
      window.requestAnimationFrame(function(){
        var roots = wishlistMutationRoots.splice(0, wishlistMutationRoots.length);
        wishlistMutationScheduled = false;
        roots.forEach(function(root){ syncWishlistButtons(root); });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    if (document.querySelector('[data-nilo-wishlist-page]')) { writeWishlist(); renderWishlistPage(); }
  }

  function initV5131CategoryCards() {
    var links = Array.prototype.slice.call(document.querySelectorAll('[data-nilo-category-mode]'));
    if (!links.length) return;
    loadNiloProductCatalogue().then(function(catalogue){
      var reserved = {};
      var ordered = v512SeededShuffle(catalogue, 'category-images-v5131');
      links.forEach(function(link, index){
        var mode = String(link.dataset.niloCategoryMode || 'women');
        var product = ordered.find(function(candidate){
          return candidate && !reserved[candidate.handle] && jsonProductMatchesMode(candidate, mode, '');
        });
        if (!product) {
          if (link.closest('[data-nilo-categories-page]')) link.hidden = true;
          else if (link.closest('[data-nilo-collection-page]')) link.hidden = true;
          return;
        }
        reserved[product.handle] = true;
        var media = link.querySelector('.nilo-categories-page__media') || link;
        var old = media.querySelector('img, .nilo-safe-category-fallback');
        var image = document.createElement('img');
        image.src = niloSizedImageUrl(jsonProductImage(product), link.closest('[data-nilo-categories-page]') ? 520 : 160);
        image.alt = String(link.dataset.niloCategoryLabel || link.textContent || product.title || '').trim();
        image.width = link.closest('[data-nilo-categories-page]') ? 520 : 120;
        image.height = link.closest('[data-nilo-categories-page]') ? 650 : 120;
        image.loading = index < 4 ? 'eager' : 'lazy';
        image.decoding = 'async';
        image.className = 'nilo-category-hydrated-image';
        if (old) old.replaceWith(image);
        else media.prepend(image);
      });
    });
  }

  function initV5131Discovery() {
    document.querySelectorAll('[data-nilo-v5131-discovery]').forEach(function(mount){
      if (mount.dataset.niloDiscoveryStarted === '1') return;
      mount.dataset.niloDiscoveryStarted = '1';
      var sentinel = mount.nextElementSibling && mount.nextElementSibling.matches('[data-nilo-v5131-discovery-sentinel]') ? mount.nextElementSibling : null;
      if (!sentinel) return;
      var loading = false;
      var catalogue = null;
      var cursor = 0;
      var reserved = {};
      document.querySelectorAll('[data-nilo-product-handle]').forEach(function(node){
        var handle = productHandleFromNode(node);
        if (handle) reserved[handle] = true;
      });
      var modes = ['new','sale','under200','dress','set','abaya','pyjama_home','bag','shoe','jellaba','hijab','sport_set','swim','accessory','caftan','takchita','women'];
      var labels = v510LabelPack('women');

      function appendBatch() {
        if (loading) return;
        loading = true;
        (catalogue ? Promise.resolve(catalogue) : loadNiloProductCatalogue().then(function(items){
          catalogue = window.NiloPricePriorityV51380.products(v512SeededShuffle(items, 'progressive-' + String(mount.dataset.niloDiscoveryContext || 'global')));
          return catalogue;
        })).then(function(items){
          document.querySelectorAll('[data-nilo-product-handle]').forEach(function(node){
            var visibleHandle = productHandleFromNode(node);
            if (visibleHandle) reserved[visibleHandle] = true;
          });
          var built = 0;
          var fragment = document.createDocumentFragment();
          while (built < 2 && cursor < modes.length * 8) {
            var mode = modes[cursor % modes.length];
            var selected = [];
            items.forEach(function(product){
              if (selected.length >= 4 || !product || !product.handle || reserved[product.handle]) return;
              if (jsonProductMatchesMode(product, mode, '')) selected.push(product);
            });
            if (selected.length < 4) {
              items.forEach(function(product){
                if (selected.length >= 4 || !product || !product.handle || reserved[product.handle] || selected.indexOf(product) >= 0) return;
                selected.push(product);
              });
            }
            selected.forEach(function(product){ reserved[product.handle] = true; });
            if (selected.length >= 2) {
              var copy = v511SectionCopy(cursor, 'women', false);
              var modeTitle = labels.modeTitles && labels.modeTitles[mode];
              var section = v511SectionFromProducts({ mode: mode, kicker: copy.kicker, title: modeTitle || copy.title }, selected, mount.closest('[data-nilo-categories-page], [data-nilo-wishlist-page]') || document.body, cursor);
              if (section) { fragment.appendChild(section); built += 1; }
            }
            cursor += 1;
            if (Object.keys(reserved).length >= items.length) break;
          }
          mount.appendChild(fragment);
          syncWishlistUI(mount);
          if (!built || Object.keys(reserved).length >= items.length || cursor >= modes.length * 8) {
            sentinel.hidden = true;
            observer.disconnect();
          }
        }).catch(function(){ sentinel.hidden = true; observer.disconnect(); }).finally(function(){ loading = false; });
      }

      var observer = new IntersectionObserver(function(entries){
        if (entries.some(function(entry){ return entry.isIntersecting; })) appendBatch();
      }, { rootMargin: '700px 0px' });
      observer.observe(sentinel);
    });
  }

  function initDeliveryEstimatesV5132() {
    var language = (document.documentElement.lang || 'fr-MA').toLowerCase();
    var locale = language.indexOf('ar') === 0 ? 'ar-MA' : 'fr-MA';
    document.querySelectorAll('[data-nilo-delivery-estimate]').forEach(function (node) {
      var days = Math.max(1, Number(node.dataset.niloDeliveryDays || 1));
      var target = new Date();
      target.setHours(12, 0, 0, 0);
      var addedDays = 0;
      while (addedDays < days) {
        target.setDate(target.getDate() + 1);
        /* Moroccan parcel networks usually pause or reduce service on Sunday. */
        if (target.getDay() !== 0) addedDays += 1;
      }
      var label;
      try {
        label = new Intl.DateTimeFormat(locale, { weekday:'long', day:'numeric', month:'long' }).format(target);
      } catch (error) {
        label = target.toLocaleDateString(locale);
      }
      var time = node.querySelector('[data-nilo-delivery-date]');
      if (!time) return;
      time.textContent = label.charAt(0).toUpperCase() + label.slice(1);
      time.setAttribute('datetime', target.toISOString().slice(0,10));
    });
  }

  function initSplitShipmentV5132() {
    var notice = document.querySelector('[data-nilo-split-shipment]');
    if (!notice) return;
    var suppliers = {}, page = document.querySelector('[data-nilo-cart-page]');
    var liquidCount = Number(page && page.dataset.niloParcelCount || 0) || 0;
    function genericKey(k){
      k=String(k||'').toLowerCase().trim();
      return !k || k==='nilo' || k==='nilo-ma' || k==='nilo-central' || k==='nilocentral';
    }
    function inferFromText(text){
      text=String(text||'').toLowerCase();
      var m=text.match(/(?:supplier|fournisseur|warehouse|entrep[oô]t)\s*[:=_-]\s*([a-z0-9][a-z0-9_-]*)/i);
      if(m&&m[1]) return m[1];
      m=text.match(/(?:^|[\s,#])([a-z0-9]+)-[a-z0-9-]*image-[0-9]+/i);
      if(m&&m[1]) return m[1];
      return '';
    }
    document.querySelectorAll('.nilo-cart-item[data-nilo-supplier]').forEach(function (item) {
      var key = String(item.dataset.niloSupplier || '').trim();
      var inferred = inferFromText(item.dataset.niloProfileText || '');
      if (inferred && genericKey(key)) key = inferred;
      if (key) suppliers[key] = true;
    });
    var count = Math.max(liquidCount, Object.keys(suppliers).length);
    if (count < 2) {
      notice.hidden = true;
      return;
    }
    notice.hidden = false;
    notice.querySelectorAll('[data-nilo-parcel-count]').forEach(function (node) { node.textContent = String(count); });
    notice.querySelectorAll('[data-nilo-parcel-count-fr]').forEach(function (node) { node.textContent = String(count); });
  }


  /* ============================================================
     NILO V5.13.11 — LOCAL PERSONALIZED FEED
     Zero backend: the customer taste profile lives only in localStorage.
     Signals: product views, favorites, cart additions, cart presence, searches,
     category clicks and successful COD orders. The home "Pour toi" rail and
     existing catalogue rails are ranked locally from a rotating Shopify sample.
     ============================================================ */
  var NILO_PERSONAL_KEY = 'nilo_personal_profile_v1';
  var niloPersonalProfileCache = null;
  var niloPersonalRerankTimer = null;

  function niloPersonalBlank(){
    return {v:1,createdAt:Date.now(),updatedAt:Date.now(),events:0,modes:{},colors:{},sizes:{},handles:{},price:{sum:0,weight:0},history:[],last:{},searches:{}};
  }
  function niloPersonalRead(){
    if(niloPersonalProfileCache)return niloPersonalProfileCache;
    var value=null;
    try{value=JSON.parse(localStorage.getItem(NILO_PERSONAL_KEY)||'null');}catch(error){value=null;}
    if(!value||value.v!==1)value=niloPersonalBlank();
    value.modes=value.modes||{};value.colors=value.colors||{};value.sizes=value.sizes||{};value.handles=value.handles||{};value.price=value.price||{sum:0,weight:0};value.history=Array.isArray(value.history)?value.history:[];value.last=value.last||{};value.searches=value.searches||{};
    /* Gentle ageing: very old tastes still count, but recent behavior wins. */
    var age=Date.now()-Number(value.updatedAt||Date.now());
    if(age>1209600000){
      Object.keys(value.modes).forEach(function(k){value.modes[k]*=.82;});
      Object.keys(value.colors).forEach(function(k){value.colors[k]*=.82;});
      Object.keys(value.sizes).forEach(function(k){value.sizes[k]*=.82;});
      Object.keys(value.handles).forEach(function(k){value.handles[k]*=.72;});
      value.updatedAt=Date.now();
    }
    niloPersonalProfileCache=value;return value;
  }
  function niloPersonalWrite(){
    var p=niloPersonalRead();p.updatedAt=Date.now();
    var handles=Object.keys(p.handles).sort(function(a,b){return Number(p.handles[b]||0)-Number(p.handles[a]||0);}).slice(0,100);
    var compact={};handles.forEach(function(h){compact[h]=Math.round(Number(p.handles[h]||0)*100)/100;});p.handles=compact;
    var lastKeys=Object.keys(p.last).sort(function(a,b){return Number(p.last[b]||0)-Number(p.last[a]||0);}).slice(0,120),last={};lastKeys.forEach(function(k){last[k]=p.last[k];});p.last=last;
    p.history=p.history.slice(0,50);
    try{localStorage.setItem(NILO_PERSONAL_KEY,JSON.stringify(p));}catch(error){}
  }
  function niloPersonalModesFromText(text){
    text=normalizeSearchText(text||'');var out=[];
    function add(mode,re){if(re.test(text)&&out.indexOf(mode)<0)out.push(mode);}
    add('abaya',/abaya|عباية|عبايات/);add('jellaba',/jellaba|djellaba|جلابة/);add('dress',/\brobe\b|robes|dress|فستان|فساتين/);
    add('set',/\bensemble\b|ensembles|\bset\b|طقم/);add('sport_set',/survet|jogging|training|tracksuit|kitma|كيطمة/);add('pyjama_home',/pyjama|pijama|pajama|homewear|sleepwear|بيجام/);
    add('hijab',/hijab|khimar|foulard|voile|حجاب|خمار/);add('shoe',/chauss|shoe|sandale|sneaker|basket|mocassin|botte|صندل/);add('bag',/\bsac\b|sacs|\bbag\b|pochette|حقيبة|شنطة/);
    add('accessory',/accessoire|bijou|ceinture|lunette|collier|bracelet|montre/);add('shirt',/chemise|shirt|قميص/);add('skirt',/jupe|skirt|تنورة/);add('swim',/burkini|bourkini|بوركيني/);add('caftan',/caftan|kaftan|قفطان/);add('takchita',/takchita|tekchita|تكشيطة/);
    if(/genre:homme|cat:homme|collection:homme|\bhomme\b|\bmen\b|رجالي/.test(text))out.push('men');
    else if(/genre:enfant|cat:enfant|collection:enfant|\benfant\b|\bkids\b|أطفال/.test(text))out.push('kids');
    else out.push('women');
    return out;
  }
  function niloPersonalColorsFromText(text){
    text=normalizeSearchText(text||'');var defs={noir:/noir|black|اسود|أسود/,blanc:/blanc|white|ابيض|أبيض/,beige:/beige|بيج/,marron:/marron|brown|بني/,bleu:/bleu|blue|ازرق|أزرق/,rose:/rose|pink|وردي/,vert:/vert|green|اخضر|أخضر/,gris:/gris|grey|gray|رمادي/,rouge:/rouge|red|احمر|أحمر/,violet:/violet|purple|بنفسجي/},out=[];
    Object.keys(defs).forEach(function(k){if(defs[k].test(text))out.push(k);});return out;
  }
  function niloPersonalSizesFromText(text){
    text=String(text||'').toUpperCase();var out=[];var matches=text.match(/(?:^|[^A-Z])(XXXL|XXL|XL|XS|S|M|L)(?=$|[^A-Z])/g)||[];matches.forEach(function(raw){var m=raw.replace(/[^A-Z]/g,'');if(m&&out.indexOf(m)<0)out.push(m);});return out;
  }
  function niloPersonalTrackVariant(label,value){
    label=normalizeSearchText(label||'');value=String(value||'').trim();if(!value)return;var p=niloPersonalRead(),changed=false;
    if(/couleur|color|لون/.test(label)){niloPersonalColorsFromText(value).forEach(function(c){p.colors[c]=Number(p.colors[c]||0)+2.5;changed=true;});}
    if(/taille|size|مقاس/.test(label)){var size=String(value).toUpperCase().replace(/\s+/g,'');if(size&&size.length<=8){p.sizes[size]=Number(p.sizes[size]||0)+2.5;changed=true;}}
    if(changed){p.events+=1;niloPersonalWrite();niloPersonalScheduleRerank();}
  }

  function niloPersonalEventAllowed(profile,type,handle,onceMs){
    if(!onceMs)return true;var key=String(type||'event')+'|'+String(handle||'global'),now=Date.now(),last=Number(profile.last[key]||0);if(now-last<onceMs)return false;profile.last[key]=now;return true;
  }
  function niloPersonalTrackData(handle,text,price,weight,type,onceMs){
    weight=Number(weight||0);if(!weight)return;var p=niloPersonalRead();handle=String(handle||'');
    if(!niloPersonalEventAllowed(p,type,handle,onceMs))return;
    var modes=niloPersonalModesFromText(text),colors=niloPersonalColorsFromText(text),sizes=niloPersonalSizesFromText(text),abs=Math.abs(weight);
    modes.forEach(function(mode){p.modes[mode]=Math.max(0,Number(p.modes[mode]||0)+weight);});
    colors.forEach(function(color){p.colors[color]=Math.max(0,Number(p.colors[color]||0)+weight*.75);});
    sizes.forEach(function(size){p.sizes[size]=Math.max(0,Number(p.sizes[size]||0)+weight*.55);});
    if(handle){p.handles[handle]=Math.max(0,Number(p.handles[handle]||0)+weight*.7);p.history=p.history.filter(function(x){return x&&x.h!==handle;});p.history.unshift({h:handle,t:Date.now(),w:weight,type:type||'event'});}
    price=Number(price||0);if(price>0&&weight>0){p.price.sum+=price*abs;p.price.weight+=abs;}
    p.events=Math.max(0,Number(p.events||0)+(weight>0?1:0));niloPersonalWrite();niloPersonalScheduleRerank();
  }
  function niloPersonalTrackProduct(product,weight,type,onceMs){if(!product)return;niloPersonalTrackData(product.handle,jsonProductText(product),jsonProductPrice(product),weight,type,onceMs);}
  function niloPersonalTrackFromNode(node,weight,type,onceMs){
    if(!node)return;var carrier=(node.closest&&node.closest('[data-nilo-product-handle]'))||node;
    var handle=String((carrier.dataset&&(carrier.dataset.niloProductHandle||carrier.dataset.productHandle))||(node.dataset&&(node.dataset.niloWishlistHandle||node.dataset.productHandle))||'');
    var text=String((carrier.dataset&&(carrier.dataset.niloProfileText||carrier.dataset.niloTaxonomy))||(node.dataset&&node.dataset.niloWishlistTitle)||carrier.textContent||'');
    var price=Number((carrier.dataset&&(carrier.dataset.niloProfilePrice||carrier.dataset.niloPrice))||(node.dataset&&node.dataset.niloWishlistPrice)||0);
    niloPersonalTrackData(handle,text,price,weight,type,onceMs);
  }
  function niloPersonalTrackSearch(term){
    term=normalizeSearchText(term||'');if(!term)return;var p=niloPersonalRead(),modes=niloPersonalModesFromText(term),colors=niloPersonalColorsFromText(term);modes.forEach(function(m){p.modes[m]=Number(p.modes[m]||0)+2;});colors.forEach(function(c){p.colors[c]=Number(p.colors[c]||0)+1.5;});p.searches[term]=Number(p.searches[term]||0)+1;p.events+=1;niloPersonalWrite();niloPersonalScheduleRerank();
  }
  function niloPersonalAveragePrice(profile){return profile.price&&profile.price.weight>0?profile.price.sum/profile.price.weight:0;}
  function niloPersonalScore(product,profile){
    if(!product||!jsonProductAvailable(product)||!jsonProductImage(product))return -9999;
    var text=jsonProductText(product),modes=niloPersonalModesFromText(text),colors=niloPersonalColorsFromText(text),score=0;
    modes.forEach(function(mode){score+=Math.min(42,Number(profile.modes[mode]||0)*1.75);});
    colors.forEach(function(color){score+=Math.min(18,Number(profile.colors[color]||0)*1.25);});
    var variantValues=[];(product.variants||[]).forEach(function(v){productVariantOptions(v).forEach(function(x){variantValues.push(String(x||'').toUpperCase().replace(/\s+/g,''));});});
    Object.keys(profile.sizes||{}).forEach(function(size){if(variantValues.indexOf(String(size).toUpperCase())>=0)score+=Math.min(8,Number(profile.sizes[size]||0)*.7);});
    var direct=Number(profile.handles[product.handle]||0);score+=Math.min(7,direct*.35);
    var avg=niloPersonalAveragePrice(profile),price=jsonProductPrice(product);if(avg>0&&price>0){score+=Math.max(0,14-(Math.abs(price-avg)/3500));}
    var txt=jsonProductText(product),compare=jsonProductCompare(product);if(/business:nouveaute|\bnouveaute\b|\bnew\b/.test(txt))score+=2.6;if(compare>price)score+=1.8;if(/bestseller|best-seller|populaire/.test(txt))score+=2.2;
    /* Tiny deterministic exploration jitter prevents a frozen feed. */
    score+=(v512Hash(String(product.handle)+'|'+Math.floor(Date.now()/86400000))%100)/100*3.5;
    return score;
  }
  function niloPersonalDominantModes(profile){return Object.keys(profile.modes||{}).sort(function(a,b){return Number(profile.modes[b]||0)-Number(profile.modes[a]||0);}).filter(function(k){return Number(profile.modes[k]||0)>0;}).slice(0,3);}
  function niloPersonalFamily(product){var core=window.NiloCatalogueCore;return core&&core.familyKey?core.familyKey(product&&product.title||''):String(product&&product.title||product&&product.handle||'').toLowerCase().replace(/\s+/g,'-');}
  function niloPersonalSelect(catalogue,profile,count){
    count=count||10;var ranked=(catalogue||[]).slice().sort(function(a,b){return window.NiloClothingPriorityV51381.compareProducts(a,b)||niloPersonalScore(b,profile)-niloPersonalScore(a,profile);}),selected=[],seenHandle={},seenFamily={};
    function add(product){if(!product||!product.handle||seenHandle[product.handle])return false;var fam=niloPersonalFamily(product);if(!fam||seenFamily[fam])return false;seenHandle[product.handle]=1;seenFamily[fam]=1;selected.push(product);return true;}
    ranked.slice(0,Math.max(count*4,36)).some(function(product){if(selected.length>=Math.max(6,count-2))return true;add(product);return false;});
    var explore=v512SeededShuffle((catalogue||[]).filter(function(product){return product&&!seenHandle[product.handle]&&!seenFamily[niloPersonalFamily(product)]&&jsonProductAvailable(product);}), 'personal-explore-'+Math.floor(Date.now()/86400000));
    explore.some(function(product){var text=jsonProductText(product),price=jsonProductPrice(product);if(/business:nouveaute|\bnouveaute\b|\bnew\b/.test(text)||jsonProductCompare(product)>price)return add(product);return false;});
    explore.some(function(product){if(selected.length>=count)return true;add(product);return false;});
    return selected.slice(0,count);
  }
  function niloPersonalFreshSelect(catalogue,count){
    var preferred=(catalogue||[]).filter(function(product){var text=jsonProductText(product),price=jsonProductPrice(product);return /business:nouveaute|bestseller|best-seller|populaire/.test(text)||jsonProductCompare(product)>price;});
    var pool=window.NiloClothingPriorityV51381.products(v512SeededShuffle(preferred.length>=count?preferred:catalogue,'personal-fresh-'+Math.floor(Date.now()/86400000)),'all'),seen={},out=[];
    pool.some(function(product){if(out.length>=count)return true;var fam=niloPersonalFamily(product);if(!product||!product.handle||!fam||seen[fam]||!jsonProductAvailable(product))return false;seen[fam]=1;out.push(product);return false;});return out;
  }
  function niloPersonalRenderFeed(catalogue){
    var section=document.querySelector('[data-nilo-personal-feed]'),rail=section&&section.querySelector('[data-nilo-personal-rail]');if(!section||!rail)return;
    var p=niloPersonalRead(),trained=Number(p.events||0)>=3,products=trained?niloPersonalSelect(catalogue,p,10):niloPersonalFreshSelect(catalogue,10),frag=document.createDocumentFragment();
    products.forEach(function(product){var card=makeJsonProductCard(product,document.querySelector('[data-nilo-app-home]')||document.body);if(card)frag.appendChild(card);});
    if(frag.childNodes.length<2)return;rail.replaceChildren(frag);section.hidden=false;section.classList.add('is-ready');if(window.NiloV51339&&window.NiloV51339.validateHome)window.NiloV51339.validateHome();
    var copy=section.querySelector('[data-nilo-personal-copy]'),pill=section.querySelector('[data-nilo-personal-pill]'),ar=(document.documentElement.lang||'').toLowerCase().indexOf('ar')===0;
    if(copy)copy.textContent=trained?(ar?'اختيارات تبدلات على حساب شنو كيعجبك':'Sélection ajustée selon tes clics, favoris et panier.'):(ar?'كل ما كتستعملي نيلو، الاختيارات كيتحسنو':'Plus tu utilises Nilo, plus cette sélection s’adapte à toi.');
    if(pill)pill.textContent=trained?(ar?'على ذوقك':'Selon tes goûts'):(ar?'كيكتاشف ذوقك':'Découvre tes goûts');
    syncWishlistUI(rail);
  }
  function niloPersonalRerankPersonalRail(){
    var rail=document.querySelector('[data-nilo-personal-rail]');if(!rail)return;
    var profile=niloPersonalRead(),cards=Array.prototype.slice.call(rail.children).filter(function(n){return n&&n.matches&&n.matches('.nilo-product-card');});if(cards.length<2)return;
    var seen={},unique=[];cards.forEach(function(card){var fam=(window.NiloCatalogueCore&&window.NiloCatalogueCore.familyFromDataset)?window.NiloCatalogueCore.familyFromDataset(card.dataset.niloFamily,card.dataset.niloTitle||''):String(card.dataset.niloFamily||card.dataset.niloProductHandle||'');if(!fam||seen[fam]){card.remove();return;}seen[fam]=1;unique.push(card);});
    if(Number(profile.events||0)>=2)unique.sort(function(a,b){return window.NiloClothingPriorityV51381.compareCards(a,b)||niloPersonalScoreCard(b,profile)-niloPersonalScoreCard(a,profile);});
    else unique=window.NiloClothingPriorityV51381.cards(unique,'all');
    var frag=document.createDocumentFragment();unique.forEach(function(card){frag.appendChild(card);});rail.appendChild(frag);
    if(window.NiloV51339&&window.NiloV51339.validateHome)window.NiloV51339.validateHome();
  }
  function niloPersonalScoreCard(card,profile){
    if(!card)return -9999;var text=String(card.dataset.niloTaxonomy||card.textContent||''),modes=niloPersonalModesFromText(text),colors=niloPersonalColorsFromText(text),score=0;modes.forEach(function(m){score+=Number(profile.modes[m]||0)*1.6;});colors.forEach(function(c){score+=Number(profile.colors[c]||0);});var price=Number(card.dataset.niloPrice||0),avg=niloPersonalAveragePrice(profile);if(avg&&price)score+=Math.max(0,8-Math.abs(price-avg)/5000);return score;
  }
  function niloPersonalRerankVisible(){
    var profile=niloPersonalRead();if(Number(profile.events||0)<2)return;
    document.querySelectorAll('.nilo-products-rail,[data-nilo-smart-rail],.nilo-products-grid-v3').forEach(function(host){
      if(host.matches('[data-nilo-personal-rail]'))return;
      var children=Array.prototype.slice.call(host.children).filter(function(child){return child.querySelector&&child.querySelector('.nilo-product-card')||child.matches&&child.matches('.nilo-product-card');});if(children.length<3)return;
      children.sort(function(a,b){var ca=(a.matches&&a.matches('.nilo-product-card'))?a:a.querySelector('.nilo-product-card'),cb=(b.matches&&b.matches('.nilo-product-card'))?b:b.querySelector('.nilo-product-card');var hostMode=host.dataset.niloSectionMode||host.dataset.niloMerchMode||(host.closest('[data-nilo-smart-mode]')||{}).dataset?.niloSmartMode||'all';return (window.NiloClothingPriorityV51381.mixedMode(hostMode)?window.NiloClothingPriorityV51381.compareCards(ca,cb):window.NiloPricePriorityV51380.cardPrice(ca)-window.NiloPricePriorityV51380.cardPrice(cb))||niloPersonalScoreCard(cb,profile)-niloPersonalScoreCard(ca,profile);});children.forEach(function(child){host.appendChild(child);});
    });
    var cats=document.querySelector('.nilo-category-rail');if(cats){var links=Array.prototype.slice.call(cats.children);links.sort(function(a,b){var ma=v512CategoryMode(a.dataset&&a.dataset.niloHomeCategory),mb=v512CategoryMode(b.dataset&&b.dataset.niloHomeCategory);var accessories={bag:1,shoe:1,hijab:1,accessory:1};return Number(!!accessories[ma])-Number(!!accessories[mb])||Number(profile.modes[mb]||0)-Number(profile.modes[ma]||0);});links.forEach(function(link){cats.appendChild(link);});}
  }
  function niloPersonalScheduleRerank(){
    window.clearTimeout(niloPersonalRerankTimer);niloPersonalRerankTimer=window.setTimeout(function(){if(window.NiloV51339&&window.NiloV51339.applyIntent)window.NiloV51339.applyIntent(false);niloPersonalRerankPersonalRail();},220);
  }
  function niloV51381PrioritizeVisibleHome(){
    if(!document.querySelector('[data-nilo-app-home]'))return;
    document.querySelectorAll('[data-nilo-home-zone],[data-nilo-personal-rail]').forEach(function(zone){
      var mode=zone.dataset.niloSectionMode||zone.dataset.niloMerchMode||'all';
      if(!window.NiloClothingPriorityV51381.mixedMode(mode))return;
      var nodes=Array.prototype.filter.call(zone.children,function(n){return n.matches&&n.matches('.nilo-product-card');});
      if(nodes.length<2)return;
      var ordered=window.NiloClothingPriorityV51381.cards(nodes,mode);
      if(nodes.some(function(n,i){return n!==ordered[i];}))ordered.forEach(function(n){zone.appendChild(n);});
    });
  }
  window.addEventListener('nilo:home-catalogue-ready',niloV51381PrioritizeVisibleHome);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',niloV51381PrioritizeVisibleHome,{once:true});
  else niloV51381PrioritizeVisibleHome();
  function initV51311Personalization(){
    var profile=niloPersonalRead(),page=document.querySelector('[data-nilo-product-page]');
    if(page){window.setTimeout(function(){if(!document.hidden)niloPersonalTrackFromNode(page,2,'product_view',7200000);},900);window.setTimeout(function(){if(!document.hidden)niloPersonalTrackFromNode(page,3,'product_dwell',21600000);},6500);}
    document.querySelectorAll('.nilo-cart-item[data-nilo-product-handle]').forEach(function(item){niloPersonalTrackFromNode(item,6,'cart_presence',43200000);});

    document.addEventListener('click',function(event){
      var card=event.target.closest&&event.target.closest('.nilo-product-card');
      if(card&&(event.target.closest('.nilo-product-card__media')||event.target.closest('.nilo-product-card__title')))niloPersonalTrackFromNode(card,2,'card_open',900000);
      var qa=event.target.closest&&event.target.closest('[data-nilo-quick-add]');if(qa)niloPersonalTrackFromNode(qa.closest('[data-nilo-product-handle]')||qa,3,'quick_add_open',300000);
      var pill=event.target.closest&&event.target.closest('[data-nilo-option-value]');if(pill){var group=pill.closest('[data-nilo-option-group]'),label=group&&group.querySelector('legend, .nilo-product-option__name, strong, label');niloPersonalTrackVariant(label?label.textContent:(group?group.textContent:''),pill.textContent);}
      var cat=event.target.closest&&event.target.closest('[data-nilo-home-category]');if(cat){var mode=v512CategoryMode(cat.dataset.niloHomeCategory||'');if(mode){var p=niloPersonalRead();p.modes[mode]=Number(p.modes[mode]||0)+3;p.events+=1;niloPersonalWrite();niloPersonalScheduleRerank();}}
    },false);
    document.addEventListener('change',function(event){var sel=event.target.closest&&event.target.closest('[data-nilo-qa-option]');if(sel){var lab=sel.closest('label');niloPersonalTrackVariant(lab?lab.textContent:'',sel.value);}},false);
    document.addEventListener('submit',function(event){var form=event.target.closest&&event.target.closest('form[role="search"],.nilo-search');if(!form)return;var input=form.querySelector('input[type="search"],input[name="q"]');if(input)niloPersonalTrackSearch(input.value);},false);
    function trackCompletedOrder(){
      var nodes=Array.prototype.slice.call(document.querySelectorAll('.nilo-cart-item[data-nilo-product-handle]'));
      var productPage=document.querySelector('[data-nilo-product-page]');if(productPage)nodes.push(productPage);
      var seen={};nodes.forEach(function(node){var h=String((node.dataset&&(node.dataset.niloProductHandle||node.dataset.productHandle))||'');if(!h||seen[h])return;seen[h]=1;niloPersonalTrackFromNode(node,22,'order_success',259200000);});
    }
    window.addEventListener('nilo:order-created',trackCompletedOrder);
    window.addEventListener('nilo:order-success',trackCompletedOrder);

    niloAfterFirstPaint(function(){ if(window.NiloV51339&&window.NiloV51339.applyIntent)window.NiloV51339.applyIntent(false);niloPersonalRerankPersonalRail(); }, 420);
    window.NiloPersonalization={profile:function(){return JSON.parse(JSON.stringify(niloPersonalRead()));},reset:function(){try{localStorage.removeItem(NILO_PERSONAL_KEY);}catch(e){}niloPersonalProfileCache=null;window.location.reload();}};
  }

  function init() {
    /* Critical interaction layer first: keep the page usable immediately. */
    initWishlist();
    initSmartSearchRouting();
    initPredictiveSearch();
    initInfiniteScroll();
    initProduct();
    initQuantities();
    initSort();
    initCollectionFilters();
    initCollectionQuickFilters();
    initCartDeadline();
    initDeliveryEstimatesV5132();
    initSplitShipmentV5132();
    initV5136CartFloatingConfirm();
    initV51310AutoMotion();
    initV51311Personalization();

    /* V5.13.49: curated fashion home runs after first paint, not during startup.
       The old v51345 build declared this rotation but never invoked it. */
    if(document.querySelector('[data-nilo-app-home]')) {
      niloAfterFirstPaint(function(){ initV512HomeRotation(); }, 620);
    }

    /* V5.13.35: other pages still use their lightweight local sorting. */
    niloAfterFirstPaint(function(){ if(window.NiloV51339&&window.NiloV51339.init)window.NiloV51339.init(); }, 180);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();


  function initV5136CartFloatingConfirm(){
    var sticky=document.querySelector('[data-nilo-cart-confirm-sticky]');
    var form=document.querySelector('[data-nilo-native-cod-form][data-kind="cart"]');
    if(!sticky||!form)return;
    sticky.hidden=false;
    var nativeButton=form.querySelector('.nilo-native-cod-submit');
    if(nativeButton&&'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){entries.forEach(function(entry){sticky.classList.toggle('is-native-visible',entry.isIntersecting&&entry.intersectionRatio>.2);});},{threshold:[0,.2,.7]}).observe(nativeButton);
    }
    var b=sticky.querySelector('[data-nilo-cart-confirm-sticky-button]');
    if(b)b.addEventListener('click',function(){
      if(!form.checkValidity()){form.scrollIntoView({behavior:'smooth',block:'center'});setTimeout(function(){form.reportValidity();},350);return;}
      form.requestSubmit();
    });
  }

  function initV51310AutoMotion(){
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;

    var pauseUntil=new WeakMap();
    var visibleState=new WeakMap();
    var railCursor=0;
    var pageScrollUntil=0;
    window.addEventListener('scroll',function(){pageScrollUntil=Date.now()+900;},{passive:true});
    var railsCache=[];
    var lastScan=0;
    var visibilityObserver=('IntersectionObserver' in window)?new IntersectionObserver(function(entries){
      entries.forEach(function(entry){visibleState.set(entry.target,entry.isIntersecting);});
    },{rootMargin:'180px 0px',threshold:0}):null;

    function pauseRail(rail,ms){pauseUntil.set(rail,Date.now()+(ms||6500));}
    function isPaused(rail){return Date.now()<(pauseUntil.get(rail)||0);}
    function bindRail(rail){
      if(!rail)return;
      if(rail.dataset.niloAutoPauseBound!=='1'){
        rail.dataset.niloAutoPauseBound='1';
        ['touchstart','pointerdown','wheel'].forEach(function(type){rail.addEventListener(type,function(){pauseRail(rail,6500);},{passive:true});});
      }
      if(visibilityObserver&&rail.dataset.niloVisibilityObserved!=='1'){rail.dataset.niloVisibilityObserved='1';visibilityObserver.observe(rail);}
    }
    function isNearViewport(rail){
      if(visibilityObserver)return visibleState.get(rail)!==false;
      var r=rail.getBoundingClientRect();return r.bottom>-100&&r.top<window.innerHeight+180;
    }
    function directChildren(rail){return Array.prototype.filter.call(rail.children,function(el){return el&&el.nodeType===1&&!el.hidden;});}
    function advanceRail(rail,stepClass){
      if(!rail||document.hidden||isPaused(rail)||!isNearViewport(rail))return false;
      var items=directChildren(rail);
      if(items.length<2||rail.scrollWidth<=rail.clientWidth+10)return false;
      var current=Number(rail.dataset.niloAutoIndex||0),next=(current+1)%items.length,target=items[next];
      rail.dataset.niloAutoIndex=String(next);
      if(stepClass)rail.classList.add(stepClass);
      if (window.getComputedStyle(rail).direction === 'rtl') {
        /* V5.13.70 — recommendations must also advance in Arabic RTL. */
        var railFrame=rail.getBoundingClientRect(), targetFrame=target.getBoundingClientRect();
        rail.scrollTo({left:rail.scrollLeft+targetFrame.right-railFrame.right,behavior:'smooth'});
      } else {
        rail.scrollTo({left:next===0?0:Math.max(0,target.offsetLeft-(items[0].offsetLeft||0)),behavior:'smooth'});
      }
      if(stepClass)window.setTimeout(function(){rail.classList.remove(stepClass);},520);
      return true;
    }
    function refreshRails(force){
      var now=Date.now();if(!force&&now-lastScan<9000)return;lastScan=now;
      var seen=[];
      document.querySelectorAll('[data-nilo-smart-rail], .nilo-products-rail').forEach(function(rail){
        if(!rail||seen.indexOf(rail)>=0)return;seen.push(rail);bindRail(rail);
      });
      railsCache=seen;
      if(railCursor>=railsCache.length)railCursor=0;
    }

    var home=document.querySelector('[data-nilo-app-home]');
    var cats=home&&home.querySelector('.nilo-category-rail');
    if(cats)bindRail(cats);
    refreshRails(true);

    /* One lightweight scheduler for categories + one product rail per tick.
       The hero carousel is managed only by nilo-mobile-v3.js, avoiding competing timers. */
    window.setInterval(function(){
      if(document.hidden||Date.now()<pageScrollUntil)return;
      if(cats)advanceRail(cats,'is-auto-moving');
      refreshRails(false);
      if(!railsCache.length)return;
      var attempts=0;
      while(attempts<railsCache.length){
        var rail=railsCache[railCursor%railsCache.length];
        railCursor=(railCursor+1)%railsCache.length;attempts+=1;
        if(rail!==cats&&advanceRail(rail,'is-auto-moving'))break;
      }
    },1500);
  }

})();

/* ============================================================
   NILO V5.13.21 — inline cart variants + desktop shell
   ============================================================ */
(function(){
  if(window.__niloV51322Enhancements)return;window.__niloV51322Enhancements=true;
  function routeRoot(){return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';}
  function norm(v){try{v=String(v||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'');}catch(e){v=String(v||'');}return v.toLowerCase().trim();}
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  var COLORS={
    'noir':'#111111','black':'#111111','blanc':'#ffffff','white':'#ffffff','rouge':'#d7192d','red':'#d7192d',
    'bleu marine':'#183153','navy':'#183153','marine':'#183153','bleu ciel':'#8ecae6','sky blue':'#8ecae6','bleu':'#2f6fd6','blue':'#2f6fd6',
    'vert':'#2f7d4c','green':'#2f7d4c','kaki':'#7b8050','khaki':'#7b8050','marron':'#7a4b2f','brown':'#7a4b2f',
    'beige':'#d8c3a5','camel':'#c19a6b','taupe':'#9b8b7a','gris':'#9a9a9a','grey':'#9a9a9a','gray':'#9a9a9a',
    'rose':'#e9a5b8','pink':'#e9a5b8','fuchsia':'#d92b78','jaune':'#f3cf30','yellow':'#f3cf30','orange':'#e9822b',
    'violet':'#7651a8','purple':'#7651a8','lilas':'#b8a1d9','lavande':'#b9a7d8','bordeaux':'#7c2030','burgundy':'#7c2030',
    'creme':'#f1eadb','cream':'#f1eadb','ecru':'#e7ddc6','dore':'#caa44a','gold':'#caa44a','argente':'#b7b7b7','silver':'#b7b7b7',
    /* Arabic labels in Shopify /ar: use actual identifiable colors, not generic gray dots. */
    'اسود':'#111111','أسود':'#111111','ابيض':'#ffffff','أبيض':'#ffffff',
    'احمر':'#d7192d','أحمر':'#d7192d','ازرق':'#2f6fd6','أزرق':'#2f6fd6',
    'كحلي':'#183153','ازرق داكن':'#183153','سماوي':'#8ecae6','ازرق سماوي':'#8ecae6',
    'فيروزي':'#38b9b7','تركواز':'#38b9b7','turquoise':'#38b9b7',
    'اخضر':'#2f7d4c','أخضر':'#2f7d4c','زيتي':'#73764b',
    'كاكي':'#7b8050','بني':'#7a4b2f','جملي':'#c19a6b','بيج':'#d8c3a5',
    'رصاصي':'#9a9a9a','رمادي':'#9a9a9a','وردي':'#e9a5b8','زهري':'#e9a5b8',
    'اصفر':'#f3cf30','أصفر':'#f3cf30','برتقالي':'#e9822b',
    'موف':'#7651a8','بنفسجي':'#7651a8','ليلكي':'#b8a1d9','لافندر':'#b9a7d8',
    'نبيتي':'#7c2030','خمري':'#7c2030','بورغوندي':'#7c2030',
    'سكري':'#f1eadb','كريمي':'#f1eadb','عاجي':'#e7ddc6',
    'ذهبي':'#caa44a','فضي':'#b7b7b7'
  };
  function colorFor(value){var n=norm(value).replace(/[\u064b-\u065f\u0670]/g,'').replace(/[آأإ]/g,'ا'),keys=Object.keys(COLORS).sort(function(a,b){return b.length-a.length;});for(var i=0;i<keys.length;i++){if(n===keys[i]||n.indexOf(keys[i])!==-1)return COLORS[keys[i]];}return '#d8d8dc';}
  function swatchBackground(raw){var parts=String(raw||'').split(/\s*(?:\/|\+|&| et )\s*/i).filter(Boolean);if(parts.length>1)return 'linear-gradient(135deg,'+colorFor(parts[0])+' 0 50%,'+colorFor(parts[1])+' 50% 100%)';return colorFor(raw);}
  function initSwatches(scope){(scope||document).querySelectorAll('[data-nilo-color-swatch]').forEach(function(el){el.style.background=swatchBackground(el.getAttribute('data-nilo-color-swatch')||'');});}
  window.__niloV51322InitSwatches=initSwatches;
  function productVariantOptions(v){if(Array.isArray(v&&v.options))return v.options;var out=[];for(var i=1;i<=3;i++){if(v&&v['option'+i])out.push(v['option'+i]);}return out;}
  function optionNames(p){return (p&&p.options||[]).map(function(o,i){return typeof o==='string'?o:(o&&o.name)||('Option '+(i+1));});}
  /* NILO V5.13.69 — Cart-only Arabic size presentation; never rewrite the actual Shopify option/variant. */
  function cartSizeLabel(raw){
    var v=String(raw==null?'':raw);
    try{v=v.normalize('NFKC').normalize('NFD');}catch(e){}
    var n=v.replace(/[\u0300-\u036f\u064b-\u065f\u0670]/g,'').replace(/[آأإ]/g,'ا')
      .replace(/ى/g,'ي').replace(/ـ/g,'').replace(/[._-]/g,' ').toLowerCase().replace(/\s+/g,' ').trim();
    var compact=n.replace(/\s+/g,'').toUpperCase();
    if(/^(?:XXS|XS|S|M|L|XL|XXL|XXXL|XXXXL|4XL|5XL|6XL)$/.test(compact))return compact;
    if(/^\d{2,3}$/.test(compact))return compact;
    var names={
      'اكس اس':'XS','اكس اكس اس':'XXS','اس':'S','صغير':'S','مقاس صغير':'S','سمول':'S',
      'ام':'M','م':'M','متوسط':'M','مقاس متوسط':'M','ميديوم':'M',
      'ال':'L','ل':'L','كبير':'L','مقاس كبير':'L','لارج':'L',
      'اكس ال':'XL','اكس ل':'XL','اكسيل':'XL','اكس لارج':'XL','اكس ال كبير':'XL',
      'اكس اكس ال':'XXL','اكس اكس ل':'XXL','مقاس كبير جدا':'XXL','كبير جدا':'XXL',
      'اكس اكس اكس ال':'XXXL','اكس اكس اكس ل':'XXXL','مقاس كبير جدا جدا':'XXXL','كبير جدا جدا':'XXXL',
      'small':'S','medium':'M','large':'L','extra large':'XL','extra extra large':'XXL','extra extra extra large':'XXXL'
    };
    return names[n]||'';
  }
  function cartArabic(){return /^ar(?:-|$)/i.test(document.documentElement.lang||'')||document.documentElement.dir==='rtl';}
  function cartIsSizeName(name){var n=norm(name);return /(?:taille|size|pointure|مقاس|قياس|الحجم)/.test(n);}
  function cartIsSizeOption(name,values){
    if(isColorName(name))return false;
    if(cartIsSizeName(name))return true;
    return !!(values&&values.length&&values.every(function(v){return !!cartSizeLabel(v);}));
  }
  function cartDisplaySize(value){return cartSizeLabel(value)||String(value==null?'':value);}
  function cartRelabelChips(scope){
    if(!cartArabic())return;
    (scope||document).querySelectorAll('[data-nilo-cart-option-chip]').forEach(function(chip){
      var raw=chip.dataset.niloOptionValue||'', name=chip.dataset.niloOptionName||'';
      if(!cartIsSizeOption(name,[raw]))return;
      var label=cartSizeLabel(raw),display=chip.querySelector('b');
      if(label&&display){display.textContent=label;display.setAttribute('dir','ltr');}
    });
  }
  function isColorName(v){var n=norm(v);return n.indexOf('couleur')>=0||n.indexOf('color')>=0||n.indexOf('colour')>=0||n.indexOf('لون')>=0;}
  var productCache={};
  function loadProduct(handle){if(productCache[handle])return Promise.resolve(productCache[handle]);return fetch(routeRoot()+'products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'}}).then(function(r){if(!r.ok)throw new Error('Impossible de charger les variantes');return r.json();}).then(function(p){productCache[handle]=p;return p;});}
  function updateCartBadgesLocal(count){
    document.querySelectorAll('.nilo-mobile-nav__cart-icon b,#cart_items,[data-nilo-desktop-cart-count]').forEach(function(n){n.textContent=String(count||0);if(n.tagName==='B')n.hidden=!count;});
  }
  function refreshCartSection(cart){var current=document.querySelector('#shopify-section-template-cart')||document.querySelector('.nilo-cart-v5-section');if(!current)return Promise.resolve(false);var url=routeRoot()+'cart?section_id=template-cart&_nilo='+Date.now();return fetch(url,{headers:{Accept:'text/html'}}).then(function(r){if(!r.ok)throw new Error('refresh');return r.text();}).then(function(html){var doc=new DOMParser().parseFromString(html,'text/html'),incoming=doc.querySelector('#shopify-section-template-cart')||doc.querySelector('.nilo-cart-v5-section')||doc.body.firstElementChild;if(!incoming)throw new Error('refresh-empty');current.replaceWith(incoming);try{window.dispatchEvent(new CustomEvent('nilo:cart-section-refreshed',{detail:{cart:cart||null}}));}catch(e){}return true;});}
  function closeInlinePickers(except){document.querySelectorAll('[data-nilo-cart-inline-picker]').forEach(function(p){if(p===except)return;p.hidden=true;p.innerHTML='';var card=p.closest('.nilo-cart-item');if(card)card.classList.remove('is-option-open');});document.querySelectorAll('[data-nilo-cart-option-chip][aria-expanded="true"]').forEach(function(b){if(except&&except.parentNode&&except.parentNode.contains(b))return;b.setAttribute('aria-expanded','false');});}
  function replaceVariant(card,newVariantId,button){
    var oldId=Number(card.dataset.niloVariantId||0),qty=Number(card.dataset.niloQuantity||1),key=card.dataset.niloLineKey||'';
    if(!newVariantId||Number(newVariantId)===oldId){closeInlinePickers();return;}
    var picker=card.querySelector('[data-nilo-cart-inline-picker]');if(picker)picker.classList.add('is-loading');if(button)button.disabled=true;
    fetch(routeRoot()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(newVariantId),quantity:qty}]})})
      .then(function(r){if(!r.ok)return r.json().then(function(b){throw new Error(b.description||'Erreur');});return r.json();})
      .then(function(){return fetch(routeRoot()+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:0})});})
      .then(function(r){if(!r.ok)throw new Error('Impossible de modifier cette option');return r.json();})
      .then(function(){return fetch(routeRoot()+'cart.js',{headers:{Accept:'application/json'}});})
      .then(function(r){return r.json();})
      .then(function(cart){updateCartBadgesLocal(cart.item_count);return refreshCartSection(cart);})
      .catch(function(err){if(picker){picker.classList.remove('is-loading');picker.innerHTML='<p class="nilo-cart-inline-picker__error">'+esc(err.message||'Erreur. Réessaie.')+'</p>';}if(button)button.disabled=false;});
  }
  function openInlinePicker(chip){
    var card=chip.closest('.nilo-cart-item');if(!card)return;var picker=card.querySelector('[data-nilo-cart-inline-picker]');if(!picker)return;
    if(!picker.hidden&&chip.getAttribute('aria-expanded')==='true'){closeInlinePickers();return;}
    closeInlinePickers(picker);card.classList.add('is-option-open');chip.setAttribute('aria-expanded','true');picker.hidden=false;picker.classList.remove('is-loading');picker.innerHTML='<div class="nilo-cart-inline-picker__loading">كنحمّلو الاختيارات… · Chargement…</div>';
    var handle=card.dataset.niloProductHandle||'',idx=Number(chip.dataset.niloOptionIndex||0),currentVariantId=Number(card.dataset.niloVariantId||0);
    loadProduct(handle).then(function(product){
      var variants=product.variants||[],current=variants.find(function(v){return Number(v.id)===currentVariantId;})||variants[0],currentOpts=productVariantOptions(current),names=optionNames(product),name=names[idx]||chip.dataset.niloOptionName||'Option',values=[],seen={};
      variants.forEach(function(v){var opts=productVariantOptions(v),value=opts[idx];if(!value||seen[value])return;seen[value]=true;var candidate=variants.find(function(c){var copts=productVariantOptions(c);return c.available!==false&&copts[idx]===value&&currentOpts.every(function(cv,j){return j===idx||copts[j]===cv;});});values.push({value:value,variant:candidate||null});});
      var color=isColorName(name),isSize=cartArabic()&&cartIsSizeOption(name,values.map(function(o){return o.value;}));
      var labelName=isSize?'المقاس':name;
      var html='<div class="nilo-cart-inline-picker__head"><span><b>'+esc(labelName)+'</b><small>بدّلي الاختيار · Modifier</small></span><button type="button" data-nilo-cart-inline-close aria-label="Fermer">×</button></div><div class="nilo-cart-inline-picker__choices '+(color?'is-colors':'is-text')+'">';
      values.forEach(function(o){
        var selected=String(currentOpts[idx]||'')===String(o.value),disabled=!o.variant;
        var visible=isSize?cartDisplaySize(o.value):String(o.value);
        var display=esc(visible),direction=isSize?' dir="ltr"':'';
        // Keep original variant ID and Shopify API data. Only visible text is normalized.
        html+='<button type="button" class="nilo-cart-inline-choice'+(selected?' is-selected':'')+'" data-nilo-cart-inline-choice data-nilo-new-variant="'+(o.variant?esc(o.variant.id):'')+'"'+(disabled?' disabled':'')+' aria-label="'+display+'"'+direction+'>'+(color?'<i data-nilo-color-swatch="'+esc(o.value)+'"></i><span>'+display+'</span>':'<span>'+display+'</span>')+'</button>';
      });
      html+='</div>';picker.innerHTML=html;initSwatches(picker);
    }).catch(function(err){picker.innerHTML='<p class="nilo-cart-inline-picker__error">'+esc(err.message||'Erreur')+'</p>';});
  }

  function openDesktopMenu(){var menu=document.querySelector('[data-nilo-desktop-menu]'),toggle=document.querySelector('[data-nilo-desktop-menu-toggle]');if(!menu)return;menu.hidden=false;document.body.classList.add('nilo-desktop-menu-open');if(toggle)toggle.setAttribute('aria-expanded','true');requestAnimationFrame(function(){menu.classList.add('is-visible');});}
  function closeDesktopMenu(){var menu=document.querySelector('[data-nilo-desktop-menu]'),toggle=document.querySelector('[data-nilo-desktop-menu-toggle]');if(!menu)return;menu.classList.remove('is-visible');document.body.classList.remove('nilo-desktop-menu-open');if(toggle)toggle.setAttribute('aria-expanded','false');setTimeout(function(){menu.hidden=true;},180);}

  document.addEventListener('click',function(e){
    var chip=e.target.closest&&e.target.closest('[data-nilo-cart-option-chip]');if(chip){e.preventDefault();e.stopPropagation();openInlinePicker(chip);return;}
    var choice=e.target.closest&&e.target.closest('[data-nilo-cart-inline-choice]');if(choice){e.preventDefault();var card=choice.closest('.nilo-cart-item');replaceVariant(card,Number(choice.dataset.niloNewVariant||0),choice);return;}
    if(e.target.closest&&e.target.closest('[data-nilo-cart-inline-close]')){e.preventDefault();closeInlinePickers();return;}
    if(e.target.closest&&e.target.closest('[data-nilo-desktop-menu-toggle]')){e.preventDefault();openDesktopMenu();return;}
    if(e.target.closest&&e.target.closest('[data-nilo-desktop-menu-close]')){e.preventDefault();closeDesktopMenu();return;}
    if(!e.target.closest||!e.target.closest('.nilo-cart-item__options,.nilo-cart-inline-picker'))closeInlinePickers();
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeInlinePickers();closeDesktopMenu();}});
  initSwatches(document);cartRelabelChips(document);window.addEventListener('nilo:cart-section-refreshed',function(){initSwatches(document);cartRelabelChips(document);});
})();


/* ============================================================
   NILO V5.13.22 — prix intelligents + accueil personnalisé
   ============================================================ */
(function(){
  if(window.__niloV51322SmartUx)return;window.__niloV51322SmartUx=true;
  var PRICE_KEY='nilo_smart_price_v51322';
  function routeRoot(){return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';}
  function firstName(v){var s=String(v||'').trim();if(!s)return '';s=s.split(/\s+/)[0];return s.charAt(0).toUpperCase()+s.slice(1);}
  function readKnownName(){
    var host=document.querySelector('[data-nilo-personal-hello]');var liquid=host&&host.dataset.niloLiquidName;if(liquid)return firstName(liquid);
    var keys=['nilo_cod_customer_v1','nilo_last_order_v1'];
    for(var i=0;i<keys.length;i++){try{var x=JSON.parse(localStorage.getItem(keys[i])||'null');if(x){var n=x.customerName||x.name||x.firstName;if(n)return firstName(n);}}catch(e){}}
    try{var arr=JSON.parse(localStorage.getItem('nilo_orders_v2')||'[]');if(Array.isArray(arr)){for(var j=0;j<arr.length;j++){var n=arr[j]&&(arr[j].customerName||arr[j].name||arr[j].firstName);if(n)return firstName(n);}}}catch(e){}
    return '';
  }
  function initGreeting(){
    var host=document.querySelector('[data-nilo-personal-hello]');if(!host)return;var name=readKnownName();if(!name){host.hidden=true;return;}
    var nameEl=host.querySelector('[data-nilo-hello-name]');if(nameEl)nameEl.textContent=name;host.setAttribute('aria-label','Bonjour, '+name);host.hidden=false;
  }
  function rawProductPrice(v){var n=Number(v&&v.price);return isFinite(n)&&n>0?n:null;}
  function fetchProductsPage(page){return fetch(routeRoot()+'products.json?limit=250&page='+page,{credentials:'same-origin',headers:{Accept:'application/json'}}).then(function(r){if(!r.ok)throw new Error('catalogue');return r.json();}).then(function(b){return Array.isArray(b.products)?b.products:[];});}
  function scanCatalogue(){var all=[],page=1,maxPages=8;function next(){return fetchProductsPage(page).then(function(items){all=all.concat(items);if(items.length===250&&page<maxPages){page++;return next();}return all;});}return next();}
  function chooseThreshold(products){
    var raw=[];(products||[]).forEach(function(p){(Array.isArray(p.variants)?p.variants:[]).forEach(function(v){if(v.available===false)return;var n=rawProductPrice(v);if(n!=null)raw.push(n);});});if(!raw.length)return null;var probe=raw.slice().sort(function(a,b){return a-b;})[Math.floor(raw.length/2)],scale=probe>5000?100:1;var prices=[];(products||[]).forEach(function(p){var vars=Array.isArray(p.variants)?p.variants:[],best=null;vars.forEach(function(v){if(v.available===false)return;var n=rawProductPrice(v);if(n!=null){n=n/scale;if(best==null||n<best)best=n;}});if(best!=null)prices.push(best);});
    if(prices.length<50)return null;prices.sort(function(a,b){return a-b;});var target=prices[49];var threshold=Math.max(140,Math.ceil(target/20)*20);return Math.min(1000,threshold);
  }
  function labelFor(el,t){var txt=String(el.textContent||'').trim();if(/^\s*-?\s*140\s*DH\s*$/i.test(txt))return '-'+t+' DH';if(/أقل من|بأقل من/.test(txt))return txt.replace(/140\s*(?:DH|DH)?/i,t+' DH');if(/b\s*9el\s*men/i.test(txt))return txt.replace(/140\s*DH/i,t+' DH');return txt.replace(/140\s*DH/i,t+' DH');}
  function applyThreshold(t){if(!t)return;
    document.querySelectorAll('a,button,strong,span,h1,h2,h3').forEach(function(el){var txt=String(el.textContent||'').trim();if(!txt||txt.length>80||el.children.length)return;var isPrice=/140\s*(?:DH|DH)/i.test(txt)&&(/moins|petit|prix|9el|أقل|بأقل|-140/i.test(txt));if(isPrice)el.textContent=labelFor(el,t);});
    document.querySelectorAll('a[href]').forEach(function(a){var h=a.getAttribute('href')||'';if(/filter\.v\.price\.lte=140|moins(?:\+|%20|-)de(?:\+|%20|-)140|moins-140|moins_140/i.test(h)){a.setAttribute('href',routeRoot()+'collections/all?filter.v.price.lte='+t);a.dataset.niloSmartPrice='1';}});
    document.querySelectorAll('[data-nilo-home-category="moins-140"]').forEach(function(a){a.setAttribute('href',routeRoot()+'collections/all?filter.v.price.lte='+t);a.dataset.niloSmartPrice='1';var label=a.querySelector('strong,span:last-child');if(label&&/140/.test(label.textContent||''))label.textContent=labelFor(label,t);});
    document.querySelectorAll('[data-nilo-price-max="140"]').forEach(function(b){b.dataset.niloSmartPriceControl='1';b.dataset.niloPriceMax=String(t);b.textContent='-'+t+' DH';});
    try{localStorage.setItem(PRICE_KEY,JSON.stringify({threshold:t,at:Date.now()}));}catch(e){}
  }
  function initSmartPrice(){ try{localStorage.removeItem(PRICE_KEY);}catch(e){} }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initGreeting();initSmartPrice();},{once:true});else{initGreeting();initSmartPrice();}
})();
